/* i18n helper (global fallback) */
if(typeof window!=="undefined" && typeof window.T==="undefined"){window.T=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
/*! GhostStat — Visitor Intelligence Hub.
 *
 *  Reads only endpoints that already exist, and only the keys they actually return (every shape
 *  below was read out of Stats.php / aggregation.php / behavior.php, not remembered):
 *
 *    /stats/realtime                          {online, per_minute, recent:[{path,host,country,ago,vid}]}
 *    /plugin/visitor-intelligence/list        {visitors:[{id,short_id,device,country,browser,
 *                                              first_source,sessions,pageviews,first_seen,last_seen,
 *                                              cadence,returning,is_bot}], total, shown}
 *    /plugin/visitor-intelligence/get?id=     {ok, profile:{…location,network,engagement,acquisition,map}}
 *    /plugin/visitor-intelligence/bsessions   {sessions:[{session_id,intent_score,frustration_score,
 *                                              attention_score,persona,journey,visitor_type,dwell_ms,
 *                                              scroll_pct,clicks,summary,device,country,vid}]}
 *    /plugin/visitor-intelligence/behavior    {kpis:{sessions,…}}
 *
 *  GS.api resolves to the ENVELOPE {ok,status,data} — unwrap once, here, so `ok` means the
 *  payload's ok everywhere below. That distinction has cost this project three separate bugs.
 *
 *  Behaviour scores exist only where the vib tracker has fired. Where they do not, the gauges say
 *  so. A confident zero would be a lie, and the rest of the story — who, where, from what source,
 *  how often, what they read — is real regardless.
 */
(function () {
  function T(k, v) { return (window.GS && GS.t) ? GS.t(k, v) : k; }

  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["vi-hub"] = "1"; } catch (e) {}

  var root, MODE = "live", DEV = "", TAG = "", SEL = null, TAB = "intent";
  // Visitor-type filter for the stream: people / bots / all. A per-account preference (seeded from the
  // signed-in user in initFilters and saved back on change), so it follows you across devices. Defaults to
  // people-only — the Hub is about visitors, and bots / AI crawlers have their own pages.
  var BOTF = "humans";
  var VIEW = "overview", SDIM = "device", SSEL = null;   // shared across all views
  var LIVE = {}, LIST = [], BEH = {}, PROF = {}, TRAJ = {}, TRAJTRIED = {}, SEGTRAJ = {}, SEGSIG = {}, SEGMOT = {}, SEGDEC = {}, SEGBM = {}, EMO = {}, SIG = {}, MOTD = {}, MAP = {}, timer = null;

  function q(k) { return root ? root.querySelector('[data-h="' + k + '"]') : null; }
  function qa(s) { return root ? Array.prototype.slice.call(root.querySelectorAll(s)) : []; }
  function esc(x) { return String(x == null ? "" : x).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nf(n) { return (+n || 0).toLocaleString(); }
  function unwrap(r) { return (r && r.data && typeof r.data === "object") ? r.data : (r || {}); }
  function api(p) {
    return GS.api(p + (p.indexOf("?") < 0 ? "?" : "&") + "site=" + encodeURIComponent(GS.site)).then(unwrap);
  }
  function apiPost(p, body) {
    return GS.api(p + (p.indexOf("?") < 0 ? "?" : "&") + "site=" + encodeURIComponent(GS.site),
      { method: "POST", body: JSON.stringify(body || {}) }).then(unwrap);
  }

  /* ---------------------------------------------------------------- range */

  function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function _today() { var t = new Date(); return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())); }
  function preset(k) {
    var to = _today(), from = new Date(to.getTime()), lbl, d = parseInt(k, 10);
    if (!isNaN(d)) { from = new Date(to.getTime() - (d - 1) * 86400000); lbl = T('vih.last') + d + " days"; }
    else if (k === "today") lbl = T('vih.today');
    else if (k === "yesterday") { to = new Date(to.getTime() - 86400000); from = new Date(to.getTime()); lbl = T('vih.yesterday'); }
    else { from = new Date(to.getTime() - 6 * 86400000); lbl = T('vih.last_7_days'); k = "7"; }
    return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(k) };
  }
  var RANGE = (function () {
    try {
      var s = JSON.parse(localStorage.getItem("gs_hub_range") || "null");
      // a preset is a rule, not a fixed window: re-anchor it, or "last 7 days" freezes on the day
      // you last touched the picker and Refresh re-queries a dead range forever
      if (s && s.preset) return preset(s.preset);
      if (s && s.from && s.to) return s;
    } catch (e) {}
    return preset("7");
  })();
  function rng() { return "from=" + RANGE.from + "&to=" + RANGE.to; }

  /* --------------------------------------------------------------- links */

  function link(slug, params) {
    if (window.GSLink && GSLink.page) return GSLink.page(slug, params || {});
    var p = [];
    for (var k in params) if (params[k] !== null && params[k] !== undefined && params[k] !== "")
      p.push(encodeURIComponent(k) + "=" + encodeURIComponent(params[k]));
    return "/" + slug + (p.length ? "?" + p.join("&") : "");
  }

  /* --------------------------------------------------------- small stuff */

  /* A flag from a country code: regional indicators are the code's letters offset into a private
     block. No image, no lookup table, and it degrades to the letters where the font has no glyph. */
  function flag(cc) {
    if (!cc || !/^[A-Za-z]{2}$/.test(cc)) return "";
    var c = cc.toUpperCase();
    return String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65, 0x1F1E6 + c.charCodeAt(1) - 65);
  }
  /* A colour derived from the id, so the same visitor is the same colour every time you look.
     Deterministic, not random — an avatar that changes on refresh is noise. */
  function hue(id) { var h = 0, s = String(id || ""); for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360; return h; }
  function avatar(id) { return "hsl(" + hue(id) + ",42%,46%)"; }
  function initials(id) { return String(id || "??").slice(0, 2).toUpperCase(); }

  function ago(sec) {
    sec = Math.max(0, +sec || 0);
    if (sec < 60) return sec + "s";
    if (sec < 3600) return Math.floor(sec / 60) + "m";
    if (sec < 86400) return Math.floor(sec / 3600) + "h";
    return Math.floor(sec / 86400) + "d";
  }
  function dwell(ms) {
    if (ms == null) return null;
    var s = Math.round(ms / 1000);
    return s < 60 ? s + "s" : Math.floor(s / 60) + "m " + (s % 60) + "s";
  }

  var PERSONA = {
    "Frustrated visitor": ["#E0533D", "bi-emoji-angry",      T('vih.showed_intent_but_hit_friction_u2014_rage_cl')],
    "High-intent buyer":  ["#1FA463", "bi-bag-check",        T('vih.strong_intent_low_friction_u2014_read_with_p')],
    "Comparison shopper": ["#D97706", "bi-shuffle",          T('vih.moved_back_and_forth_between_pages_weighing_')],
    "Researcher":         ["#6C4BE8", "bi-mortarboard",      T('vih.slow_and_thorough_u2014_deep_reading_and_hig')],
    "Hesitator":          ["#E0A800", "bi-hourglass-split",  T('vih.interested_but_unsure_u2014_paused_repeatedl')],
    "Lost visitor":       ["#8C95A1", "bi-signpost-2",       T('vih.dead_clicks_and_shallow_depth_u2014_couldn_t')],
    "Skimmer":            ["#2A6FE8", "bi-lightning-charge", T('vih.moved_fast_and_shallow_u2014_scanning_not_re')],
    "Casual browser":     ["#29C5E8", "bi-eye",              T('vih.present_with_light_interaction_u2014_no_stro')]
  };
  function pcol(p)  { return (PERSONA[p] || ["#8C95A1"])[0]; }
  function picon(p) { return (PERSONA[p] || [null, "bi-person"])[1]; }
  function pslug(p) { return String(p || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, ""); }
  function pName(p) { return T("vi.persona." + pslug(p)); }        // localized persona label (English key -> label)
  function pDesc(p) { return T("vi.persona_d." + pslug(p)); }      // localized persona description
  function jName(k) { return T("vi.journey." + pslug(k)); }        // localized journey-stage label

  /* one icon-forward persona chip: icon always; label/count optional; tooltip explains the mood and
     the whole chip is the deep-link (used as a filter tag in the stream, a badge on the card). */
  function pchip(p, o) { o = o || {}; if (!p) return "";
    return '<span class="vh-persona' + (o.big ? " big" : "") + '" style="background:' + pcol(p) +
      '" title="' + esc(pName(p) + " \u2014 " + phelp(p)) + '"><i class="bi ' + picon(p) + '"></i>' +
      (o.label ? "<span>" + esc(pName(p)) + "</span>" : "") + (o.count != null ? "<b>" + o.count + "</b>" : "") + "</span>"; }

  /* Is this a person?
     The stream showed a BOT badge on the story panel and nothing on the card, so a row reading
     "102 pages · 8 visits" looked like your best visitor when it was a crawler. Bots are FLAGGED
     at ingest and counted, never dropped — that is deliberate: silently discarding traffic means
     your numbers disagree with your server logs and nobody can tell you why. But a flag you cannot
     see is the same as no flag. */
  var BOTCAT = {
    search_engine: ["#2A6FE8", "A search engine crawler \u2014 this is how you get indexed. You want this one."],
    ai:            ["#6C4BE8", T('vih.an_ai_crawler_collecting_content_for_a_model')],
    seo:           ["#29C5E8", T('vih.an_seo_tool_crawling_your_site')],
    monitor:       ["#8C95A1", T('vih.an_uptime_or_monitoring_probe')],
    scraper:       ["#E0533D", "A scraper \u2014 taking content, giving nothing back."],
    spam:          ["#E0533D", T('vih.known_bad_traffic')],
    unknown:       ["#8C95A1", T('vih.flagged_as_automated_from_its_user_agent_but')]
  };
  function botBadge(v, big) {
    if (!v || !v.is_bot) return "";
    var cat = String(v.bot_category || "unknown").toLowerCase();
    var m = BOTCAT[cat] || BOTCAT.unknown;
    var label = v.bot_name || (cat === "search_engine" ? T("vi.bot.search_engine") : "Bot");
    var t = [m[1]];
    if (v.bot_name) t.push(T("vi.bot.identified")+" " + v.bot_name + (v.bot_verified ? " (verified by reverse DNS)" : " (claimed in the user-agent \u2014 not verified)"));
    t.push(T("vi.bot.counted_note"));
    return '<span class="vh-bot' + (big ? " big" : "") + '" style="background:' + m[0] + '" title="' + esc(t.join("\n")) + '">' +
      '<i class="bi bi-robot"></i>' + (big ? " <span>" + esc(label) + "</span>" : "") + "</span>";
  }
  function phelp(p) { return pDesc(p); }

  /* ------------------------------------------------------------ gauges */

  var GAUGE = {
    intent: { label: T('vih.intent'), ring: ["#2A6FE8", "#1FA463"],
      help: "0\u2013100. How strongly the behaviour suggests they were trying to DO something, not just browsing. Scored from dwell, scroll depth and click pattern \u2014 never from the user-agent.",
      band: function (v) { return T(v >= 70 ? "vi.band.intent_hi" : v >= 40 ? "vi.band.intent_mid" : "vi.band.intent_lo"); } },
    frustration: { label: T('vih.frustration'), ring: ["#FFC83A", "#E0533D"],
      help: "0\u2013100, and higher is worse. Rage clicks, dead clicks, scroll thrash, repeated backtracking.",
      band: function (v) { return T(v >= 70 ? "vi.band.fric_hi" : v >= 40 ? "vi.band.fric_mid" : "vi.band.fric_lo"); } },
    attention: { label: T('vih.attention'), ring: ["#29C5E8", "#6C4BE8"],
      help: "0\u2013100. Reading depth and dwell \u2014 how much of the page actually got read, not how long the tab sat open.",
      band: function (v) { return T(v >= 70 ? "vi.band.att_hi" : v >= 40 ? "vi.band.att_mid" : "vi.band.att_lo"); } }
  };

  function ring(v, from, to) {
    var R = 20, C = 2 * Math.PI * R, len = Math.max(0, Math.min(100, v)) / 100 * C;
    var gid = "g" + Math.random().toString(36).slice(2, 7);
    return '<svg width="48" height="48" viewBox="0 0 48 48">' +
      '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="' + from + '"/><stop offset="1" stop-color="' + to + '"/></linearGradient></defs>' +
      '<circle cx="24" cy="24" r="' + R + '" fill="none" stroke="rgba(255,255,255,.1)" stroke-width="4"/>' +
      '<circle class="vh-g-ring" cx="24" cy="24" r="' + R + '" fill="none" stroke="url(#' + gid + ')" stroke-width="4"' +
      ' stroke-linecap="round" stroke-dasharray="' + len.toFixed(1) + " " + (C - len).toFixed(1) + '"' +
      ' transform="rotate(-90 24 24)"/></svg>';
  }

  function renderGauges(b) {
    var host = q("gauges"); if (!host) return;
    host.innerHTML = ["intent", "frustration", "attention"].map(function (k) {
      var g = GAUGE[k], v = b ? b[k + "_score"] : null;
      var none = v == null;
      var tip = g.help + (none ? "\n\nNo score yet: behaviour comes from the tracker, and this visitor has not sent any."
                                : "\n\n" + g.band(v) + " (" + v + "/100)");
      return '<div class="vh-g' + (none ? " none" : "") + '" title="' + esc(tip) + '">' +
        ring(none ? 0 : v, g.ring[0], g.ring[1]) +
        '<div><div class="vh-g-n">' + (none ? "\u2014" : v) + "</div>" +
        '<div class="vh-g-l">' + g.label + "</div>" +
        '<div class="vh-g-d">' + (none ? "no data yet" : g.band(v)) + "</div></div></div>";
    }).join("");
  }

  /* ------------------------------------------------------- journey stage */

  var STAGES = [
    ["exploration", T('vih.exploring'),     "bi-compass",        T('vih.looking_around_no_target_yet')],
    ["evaluation",  T('vih.evaluating'),    "bi-search",         T('vih.reading_properly_u2014_weighing_it_up')],
    ["comparison",  T('vih.comparing'),     "bi-arrow-left-right",T('vih.moving_between_options')],
    ["commitment",  T('vih.ready'),         "bi-check2-circle",  T('vih.behaviour_of_someone_about_to_act')],
    ["confusion",   T('vih.confused'),      "bi-question-circle",T('vih.backtracking_hesitating_re_reading')],
    ["frustration", T('vih.frustrated'),    "bi-emoji-frown",    T('vih.rage_or_dead_clicks_u2014_something_is_in_th')]
  ];
  function renderStage(cur) {
    var host = q("stage"); if (!host) return;
    var c = String(cur || "").toLowerCase();
    host.innerHTML = STAGES.map(function (s) {
      var on = c === s[0], bad = s[0] === "confusion" || s[0] === "frustration";
      return '<div class="vh-st' + (on ? " on" : "") + (on && bad ? " bad" : "") + '" title="' +
        esc(T("vi.journey_d."+pslug(s[0])) + (on ? "" : "\n\n" + T("vi.journey.not_current"))) + '">' +
        '<i class="bi ' + s[2] + '"></i><span>' + esc(jName(s[0])) + "</span></div>";
    }).join("");
  }

  /* ----------------------------------------------------------- the story */

  function pickVisitor(id) {
    SEL = id;
    qa(".vh-card").forEach(function (c) { c.classList.toggle("on", c.getAttribute("data-vid") === id); });
    if (window.GSLink) GSLink.write({ id: id });
    renderStory();
    if (CP_OPEN) cpRender();
    if (!PROF[id]) {
      api("/plugin/visitor-intelligence/get?id=" + encodeURIComponent(id)).then(function (r) {
        if (r && r.ok && r.profile) { PROF[id] = r.profile; if (SEL === id) renderStory(); }
      }).catch(function () {});
    }
    if (!TRAJ[id]) {
      api("/plugin/visitor-intelligence/trajectory?id=" + encodeURIComponent(id)).then(function (r) {
        if (r && r.ok) { TRAJ[id] = r; if (SEL === id) renderTrajectory(); }
      }).catch(function () {});
    }
    if (!EMO[id]) {
      api("/plugin/visitor-intelligence/emotions?id=" + encodeURIComponent(id)).then(function (r) {
        if (r && r.ok) { EMO[id] = r; if (SEL === id) { renderEmotion(); renderDecision(); } }
      }).catch(function () {});
    }
    if (!SIG[id]) {
      api("/plugin/visitor-intelligence/signature?id=" + encodeURIComponent(id)).then(function (r) {
        if (r && r.ok) { SIG[id] = r; if (SEL === id) renderSignature(); }
      }).catch(function () {});
    }
    if (!MOTD[id]) {
      api("/plugin/visitor-intelligence/motivation?id=" + encodeURIComponent(id)).then(function (r) {
        if (r && r.ok) { MOTD[id] = r; if (SEL === id) renderMotivation(); }
      }).catch(function () {});
    }
  }

  function behOf(id) { return BEH[id] || null; }

  function renderStory() {
    var empty = q("story-empty"), body = q("story-body");
    if (!SEL) { if (empty) empty.hidden = false; if (body) body.hidden = true; renderTiles(null); return; }
    if (empty) empty.hidden = true; if (body) body.hidden = false;

    var row = LIST.filter(function (v) { return v.id === SEL; })[0] || {};
    var live = (LIVE.recent || []).filter(function (v) { return v.vid === SEL; })[0] || null;
    var p = PROF[SEL] || null, b = behOf(SEL);
    var sid = row.short_id || String(SEL).slice(0, 10);

    q("avatar").style.background = avatar(SEL);
    q("avatar").textContent = initials(sid);
    q("s-id").textContent = sid;

    var pe = q("s-persona");
    if (b && b.persona) { pe.hidden = false; pe.innerHTML = '<i class="bi ' + picon(b.persona) + '"></i> ' + esc(pName(b.persona)); pe.style.background = pcol(b.persona); pe.title = pName(b.persona) + " \u2014 " + phelp(b.persona); }
    else pe.hidden = true;
    var stg = q("s-stage");
    if (b && b.journey) { stg.hidden = false; stg.textContent = b.journey; } else stg.hidden = true;
    q("s-ret").hidden = !row.returning;
    var bt = q("s-bot");
    bt.hidden = !row.is_bot;
    if (row.is_bot) {
      bt.outerHTML = botBadge(row, true).replace('class="vh-bot big"', 'class="vh-bot big" data-h="s-bot"');
    }

    /* The one-line summary. Where behaviour has been scored, that sentence is the engine's. Where it
       has not, say something true from what we DO have rather than leave a blank or invent a mood. */
    var sum = q("s-summary");
    if (b && b.summary) sum.textContent = b.summary;
    else {
      var bits = [];
      if (row.first_source) bits.push("Arrived via " + row.first_source.toLowerCase());
      if (row.sessions > 1) bits.push("back for visit " + row.sessions);
      if (row.pageviews) bits.push(nf(row.pageviews) + " page" + (row.pageviews === 1 ? "" : "s") + " read");
      sum.textContent = bits.length ? bits.join(" \u00b7 ") + "." : T("vi.empty.no_beh");
    }

    var meta = [];
    if (row.country) meta.push("<span>" + flag(row.country) + " <b>" + esc(row.country) + "</b>" +
      (p && p.location && p.location.city ? " " + esc(p.location.city) : "") + "</span>");
    if (row.device) meta.push("<span><b>" + esc(row.device) + "</b>" + (row.browser ? " \u00b7 " + esc(row.browser) : "") + "</span>");
    if (row.first_source) meta.push('<span>from <b>' + esc(row.first_source) + "</b></span>");
    if (row.cadence && row.cadence !== T('vih.none')) meta.push("<span>returns <b>" + esc(row.cadence.toLowerCase()) + "</b></span>");
    if (p && p.network && p.network.provider) meta.push('<span><a href="' + esc(link("provider", { provider: p.network.provider })) +
      '" title=T("vi.open.provider")>' + esc(p.network.provider) + "</a></span>");
    if (live) meta.push('<span class="vh-onnow"><b>on ' + esc(live.path || "/") + "</b> now</span>");
    q("s-meta").innerHTML = meta.join("");

    q("s-open").href = link("visitor-intelligence", { id: SEL });

    renderGauges(b);
    renderTrajectory();
    renderEmotion();
    renderSignature();
    renderMotivation();
    renderDecision();
    renderStage(b && b.journey);
    renderTimeline(p, b, live);
    renderTab();
    renderTiles(row, live, b, p);
  }

  /* ------------------------------------------------ Intent Trajectory engine
     How intent MOVED across the visit — not the single current number the gauge shows, but its shape.
     Reads the per-page intent scores already stored for this visitor (vi2_intent) and derives, in the
     browser, four things people act on: direction (least-squares slope over the reading sequence),
     acceleration (2nd-half slope minus 1st), volatility (std-dev of step-to-step change), and the
     reversal points where direction flipped. Presentation over existing data; nothing is stored. */
  function trajStats(scores) {
    var n = scores.length;
    function slope(a) {
      var m = a.length; if (m < 2) return 0;
      var sx = 0, sy = 0, sxy = 0, sxx = 0;
      for (var i = 0; i < m; i++) { sx += i; sy += a[i]; sxy += i * a[i]; sxx += i * i; }
      var d = m * sxx - sx * sx; return d ? (m * sxy - sx * sy) / d : 0;
    }
    var mid = Math.floor(n / 2), deltas = [], rev = [], prev = 0;
    for (var i = 1; i < n; i++) {
      var d = scores[i] - scores[i - 1]; deltas.push(d);
      var s = d > 1 ? 1 : d < -1 ? -1 : 0;
      if (s !== 0) { if (prev !== 0 && s !== prev) rev.push(i - 1); prev = s; }
    }
    var mean = deltas.reduce(function (a, b) { return a + b; }, 0) / (deltas.length || 1);
    var vol = Math.sqrt(deltas.reduce(function (a, b) { return a + (b - mean) * (b - mean); }, 0) / (deltas.length || 1));
    return { slope: slope(scores), accel: slope(scores.slice(mid)) - slope(scores.slice(0, Math.max(2, mid + 1))),
             vol: vol, rev: rev, first: scores[0], last: scores[n - 1], net: scores[n - 1] - scores[0] };
  }

  function trajSvg(scores, rev, color, baseline) {
    baseline = baseline || "rgba(255,255,255,.14)";
    var W = 300, H = 82, pad = 7, n = scores.length;
    function x(i) { return pad + (W - 2 * pad) * (n === 1 ? 0.5 : i / (n - 1)); }
    function y(v) { return pad + (H - 2 * pad) * (1 - Math.max(0, Math.min(100, v)) / 100); }
    var pts = scores.map(function (v, i) { return x(i).toFixed(1) + "," + y(v).toFixed(1); });
    var line = "M" + pts.join(" L");
    var area = line + " L" + x(n - 1).toFixed(1) + "," + (H - pad) + " L" + x(0).toFixed(1) + "," + (H - pad) + " Z";
    var dots = rev.map(function (i) {
      return '<circle cx="' + x(i).toFixed(1) + '" cy="' + y(scores[i]).toFixed(1) + '" r="3.4" fill="#fff" stroke="' + color + '" stroke-width="2"/>';
    }).join("");
    var gid = "tg" + Math.random().toString(36).slice(2, 7);
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" class="vh-traj-svg">' +
      '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="' + color + '" stop-opacity="0.20"/><stop offset="1" stop-color="' + color + '" stop-opacity="0"/></linearGradient></defs>' +
      '<line x1="' + pad + '" y1="' + y(50).toFixed(1) + '" x2="' + (W - pad) + '" y2="' + y(50).toFixed(1) + '" stroke="' + baseline + '" stroke-width="1" stroke-dasharray="3 3"/>' +
      '<path d="' + area + '" fill="url(#' + gid + ')"/>' +
      '<path d="' + line + '" fill="none" stroke="' + color + '" stroke-width="2.2" stroke-linejoin="round" stroke-linecap="round"/>' +
      dots + '<circle cx="' + x(n - 1).toFixed(1) + '" cy="' + y(scores[n - 1]).toFixed(1) + '" r="3" fill="' + color + '"/></svg>';
  }

  function metric(label, value, color, tip) {
    return '<div class="vh-traj-m" title="' + esc(tip) + '"><div class="vh-traj-m-l">' + esc(label) + "</div>" +
      '<div class="vh-traj-m-v" style="color:' + color + '">' + esc(value) + "</div></div>";
  }

  /* The expandable "what this is / how it's read / what to do" info field. Native <details>, no JS. */
  function trajInfo() {
    return '<details class="vh-info"><summary title=T("vi.info.traj_title")><i class="bi bi-info-circle"></i></summary>' +
      '<div class="vh-info-body">' +
        T("vi.info.traj_1") +
        T("vi.info.traj_2") +
        T("vi.info.traj_3") +
      "</div></details>";
  }

  function renderTrajectory() {
    var host = q("traj"); if (!host) return;
    if (!SEL) { host.hidden = true; return; }
    var t = TRAJ[SEL];
    if (!t) { host.hidden = true; return; }               // still loading; stay hidden until it arrives
    var pts = (t.points || []).filter(function (p) { return p && typeof p.score === "number"; });
    var scores = pts.map(function (p) { return p.score; });

    // Fewer than two readings can't have a shape. Say so plainly instead of drawing a fake line.
    if (scores.length < 2) {
      host.hidden = false;
      host.innerHTML = '<div class="vh-traj-head"><span class="vh-h">'+T('vih.intent_trajectory')+'</span>' + trajInfo() + "</div>" +
        '<div class="vh-traj-thin">' + (scores.length === 1
          ? "One intent reading so far (" + scores[0] + "/100) \u2014 a trajectory needs at least two, which appear as this visitor reads more pages."
          : T("vi.empty.no_intent")) + "</div>";
      return;
    }

    var s = trajStats(scores);
    var dir = s.slope > 1.2 ? "rising" : s.slope < -1.2 ? "falling" : "steady";
    var color = dir === "rising" ? "#1FA463" : dir === "falling" ? "#E0533D" : "#2A6FE8";
    var headline = T(dir === "rising" ? "vi.intent.rising" : dir === "falling" ? "vi.intent.falling" : "vi.intent.holding");
    var accelWord = s.accel > 1 ? (dir === "falling" ? "dropping faster" : "accelerating")
                  : s.accel < -1 ? (dir === "rising" ? T("vi.accel.leveling") : T("vi.accel.cooling")) : T("vi.accel.holding");
    var volPct = Math.min(100, Math.round(s.vol * 4));
    var volWord = s.vol < 6 ? "steady" : s.vol < 16 ? "variable" : "erratic";
    var netSign = s.net > 0 ? "+" : "";

    var chips = '<div class="vh-traj-metrics">' +
      metric(T("vi.stat.direction"), headline.replace(T('vih.intent_is'), ""), color,
             T("vi.stat_d.direction")) +
      metric(T("vi.stat.acceleration"), accelWord, s.accel > 1 ? "#1FA463" : s.accel < -1 ? "#E0533D" : "#9FB0C8",
             T("vi.stat_d.acceleration")) +
      metric(T("vi.stat.net_change"), netSign + s.net + " pts", s.net > 0 ? "#1FA463" : s.net < 0 ? "#E0533D" : "#9FB0C8",
             "First reading (" + s.first + ") to last (" + s.last + "), across " + t.sessions + " visit" + (t.sessions === 1 ? "" : "s") + ".") +
      "</div>";

    var volMeter = '<div class="vh-traj-vol" title=T("vi.stat_d.volatility")>' +
      '<span class="vh-traj-vol-l">'+T('vih.volatility')+'</span>' +
      '<span class="vh-traj-vol-bar"><i style="width:' + volPct + '%;background:' + (volPct > 60 ? "#E0533D" : volPct > 30 ? "#D97706" : "#1FA463") + '"></i></span>' +
      '<span class="vh-traj-vol-v">' + volWord + "</span></div>";

    // deep-links carry the visitor + their latest session + latest page so the target lands in context
    var last = pts[pts.length - 1] || {};
    var dl = { id: SEL, visitor_id: SEL, session_id: last.session_id || "", page_url: last.page || "" };
    var tiles = [
      ["session-recordings", "bi-play-btn", T("vi.btn.watch_visit")],
      ["heatmaps", "bi-fire", T("vi.btn.where_intent")],
      ["user-flow", "bi-diagram-3", T("vi.btn.path")],
      ["funnels", "bi-filter", T("vi.btn.converted")],
      ["visitor-intelligence", "bi-stars", T("vi.btn.ai_insight")]
    ].map(function (x) {
      var params = x[0] === "visitor-intelligence" ? { id: SEL, tab: "insights" } : dl;
      return '<a class="vh-traj-tile" href="' + esc(link(x[0], params)) + '" title="Open ' + x[2] + '">' +
        '<i class="bi ' + x[1] + '"></i><span>' + x[2] + "</span></a>";
    }).join("");

    host.hidden = false;
    host.innerHTML =
      '<div class="vh-traj-head"><span class="vh-h">'+T('vih.intent_trajectory')+'</span>' +
        '<span class="vh-traj-badge" style="color:' + color + ';border-color:' + color + '33;background:' + color + '14">' +
          '<i class="bi ' + (dir === "rising" ? "bi-graph-up-arrow" : dir === "falling" ? "bi-graph-down-arrow" : "bi-dash-lg") + '"></i> ' +
          esc(headline + " \u00b7 " + accelWord) + "</span>" + trajInfo() + "</div>" +
      '<div class="vh-traj-graph">' + trajSvg(scores, s.rev, color) +
        (s.rev.length ? '<span class="vh-traj-rev" title=T("vi.stat.reversals")>' + s.rev.length + " reversal" + (s.rev.length === 1 ? "" : "s") + "</span>" : "") + "</div>" +
      chips + volMeter +
      '<div class="vh-traj-tiles">' + tiles + "</div>";
  }

  /* ================================================= Emotional Reconstruction engine
     The tracker never records "emotions" — it records intent, friction and attention on each page.
     This reconstructs the felt experience from those three signals: eight named states, a valence
     wave (how good/bad the visit felt over time), an emotional strip (the dominant state per page),
     and dip markers where it went wrong. Presentation over existing data; nothing is stored. */
  var EMODEF = window.__EMODEF || {
    curiosity:     { label: T('vih.curiosity'),     color: "#2A6FE8", icon: "bi-binoculars",          val: 1,  help: "Attentive and exploring \u2014 reading widely, no strong buying signal yet." },
    confidence:    { label: T('vih.confidence'),    color: "#1FA463", icon: "bi-hand-thumbs-up",      val: 1,  help: "Clear intent with little friction \u2014 they know what they want." },
    satisfaction:  { label: T('vih.satisfaction'),  color: "#059669", icon: "bi-emoji-smile",         val: 1,  help: "Engaged and content \u2014 real intent and attention, low friction." },
    determination: { label: T('vih.determination'), color: "#0891B2", icon: "bi-flag-fill",           val: 1,  help: "Strong, focused intent \u2014 pushing toward a goal." },
    hesitation:    { label: T('vih.hesitation'),    color: "#D97706", icon: "bi-pause-circle",        val: -1, help: "Half-committed \u2014 moderate signals, pausing before acting." },
    annoyance:     { label: T('vih.annoyance'),     color: "#EA580C", icon: "bi-emoji-frown",         val: -1, help: "Mild friction \u2014 small irritations building." },
    overwhelm:     { label: T('vih.overwhelm'),     color: "#7C3AED", icon: "bi-exclamation-diamond", val: -1, help: "Too much at once \u2014 high friction alongside high activity." },
    frustration:   { label: T('vih.frustration'),   color: "#E0533D", icon: "bi-emoji-angry",         val: -1, help: "Real friction \u2014 the visit is going wrong for them." },
    settled:       { label: T('vih.settled'),       color: "#8798B0", icon: "bi-dash-circle",         val: 0,  help: "Low arousal \u2014 no strong emotion on this page." }
  };
  function emoName(k){ return T("vi.emo." + k); }
  function emoHelp(k){ return T("vi.emo_d." + k); }
  var EMO_KEYS = ["curiosity", "confidence", "satisfaction", "determination", "hesitation", "annoyance", "overwhelm", "frustration"];

  /* Reconstruct the eight emotion intensities (0\u2013100) from one moment's intent(i)/friction(f)/attention(a). */
  function reconEmo(m) {
    var i = m.i == null ? 0 : m.i, f = m.f == null ? 0 : m.f, a = m.a == null ? 0 : m.a;
    var lowF = 1 - f / 100, cl = function (x) { return Math.max(0, Math.min(100, Math.round(x))); };
    return {
      frustration:   f >= 55 ? cl(f) : 0,
      annoyance:     (f >= 25 && f < 60) ? cl(f + 8) : 0,
      overwhelm:     (f >= 45 && a >= 60) ? cl((f + a) / 2) : 0,
      hesitation:    m.ftype === "hesitant" ? cl(Math.max(52, f))
                     : (f >= 25 && f < 55 && i >= 25 && i < 65) ? cl(45 + (f - 25)) : 0,
      determination: (i >= 65 && f < 45) ? cl(i) : 0,
      confidence:    (i >= 50 && f < 40) ? cl(i * lowF) : 0,
      satisfaction:  (i >= 55 && f < 30 && a >= 45) ? cl((i + a) / 2 * lowF) : 0,
      curiosity:     (a >= 50 && i >= 20 && i < 70 && f < 45) ? cl(a * (1 - f / 130)) : 0
    };
  }
  function emoDominant(e) {
    var best = "settled", bv = 0;
    EMO_KEYS.forEach(function (k) { if (e[k] > bv) { bv = e[k]; best = k; } });
    return bv >= 22 ? best : "settled";              // below this it's low-arousal, not an emotion
  }
  function emoValence(e) {                            // dominant intensity, signed by its valence: -100..100
    var d = emoDominant(e); if (d === "settled") return 0;
    return EMODEF[d].val * e[d];
  }
  function emoWaveSvg(vals, dips) {
    var W = 300, H = 92, pad = 8, mid = H / 2, n = vals.length;
    function x(i) { return pad + (W - 2 * pad) * (n === 1 ? 0.5 : i / (n - 1)); }
    function y(v) { return mid - (v / 100) * (mid - pad); }
    var pts = vals.map(function (v, i) { return x(i).toFixed(1) + "," + y(v).toFixed(1); });
    var line = "M" + pts.join(" L");
    var area = line + " L" + x(n - 1).toFixed(1) + "," + mid + " L" + x(0).toFixed(1) + "," + mid + " Z";
    var gid = "ew" + Math.random().toString(36).slice(2, 7);
    var dots = dips.map(function (i) { return '<circle cx="' + x(i).toFixed(1) + '" cy="' + y(vals[i]).toFixed(1) + '" r="3.4" fill="#E0533D" stroke="#fff" stroke-width="1.4"/>'; }).join("");
    return '<svg viewBox="0 0 ' + W + " " + H + '" class="vh-emo-svg">' +
      '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="#1FA463" stop-opacity="0.34"/><stop offset="0.5" stop-color="#1FA463" stop-opacity="0.03"/>' +
        '<stop offset="0.5" stop-color="#E0533D" stop-opacity="0.03"/><stop offset="1" stop-color="#E0533D" stop-opacity="0.34"/></linearGradient></defs>' +
      '<line x1="' + pad + '" y1="' + mid + '" x2="' + (W - pad) + '" y2="' + mid + '" stroke="rgba(255,255,255,.14)" stroke-width="1" stroke-dasharray="3 3"/>' +
      '<path d="' + area + '" fill="url(#' + gid + ')"/>' +
      '<path d="' + line + '" fill="none" stroke="#C7D4E6" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"/>' + dots + "</svg>";
  }
  function emoInfo() {
    return '<details class="vh-info"><summary title=T("vi.info.emo_title")><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.emo_1") +
      T("vi.info.emo_2") +
      T("vi.info.emo_3") +
      "</div></details>";
  }
  function renderEmotion() {
    var host = q("emo"); if (!host) return;
    if (!SEL) { host.hidden = true; return; }
    var d = EMO[SEL];
    if (!d) { host.hidden = true; return; }
    var moments = (d.moments || []).filter(function (m) { return m && m.i != null; });
    if (moments.length < 2) {
      host.hidden = false;
      host.innerHTML = '<div class="vh-emo-head"><span class="vh-h">'+T('vih.emotional_reconstruction')+'</span>' + emoInfo() + "</div>" +
        '<div class="vh-emo-thin">' + (moments.length === 1
          ? "One scored page so far \u2014 the emotional arc appears once this visitor has read a couple more."
          : T("vi.empty.no_emo")) + "</div>";
      return;
    }
    // per-moment reconstruction
    var recon = moments.map(reconEmo);
    var vals = recon.map(emoValence);
    var dips = [];
    vals.forEach(function (v, i) { if (v <= -45) dips.push(i); });
    if (!dips.length) { var lo = 0; vals.forEach(function (v, i) { if (v < vals[lo]) lo = i; }); if (vals[lo] < -25) dips.push(lo); }

    // aggregate totals for the headline + badges
    var totals = {}; EMO_KEYS.forEach(function (k) { totals[k] = 0; });
    recon.forEach(function (e) { EMO_KEYS.forEach(function (k) { totals[k] += e[k]; }); });
    var ranked = EMO_KEYS.filter(function (k) { return totals[k] > 0; }).sort(function (a, b) { return totals[b] - totals[a]; });
    var sum = EMO_KEYS.reduce(function (s, k) { return s + totals[k]; }, 0) || 1;
    var headline = ranked.length ? T("vi.climate.visit_mostly", {mood: emoName(ranked[0]).toLowerCase()}) : T("vi.climate.visit_calm");
    var hcol = ranked.length ? EMODEF[ranked[0]].color : "#8798B0";
    var badges = ranked.slice(0, 3).map(function (k) {
      var def = EMODEF[k], pct = Math.round(totals[k] / sum * 100);
      return '<span class="vh-emo-badge" style="color:' + def.color + ';border-color:' + def.color + '33;background:' + def.color + '14" title="' + esc(emoHelp(ranked[i])) + '">' +
        '<i class="bi ' + def.icon + '"></i> ' + def.label + " <b>" + pct + "%</b></span>";
    }).join("");

    // dominant-emotion strip: one cell per moment
    var strip = recon.map(function (e, idx) {
      var dm = emoDominant(e), def = EMODEF[dm], m = moments[idx];
      return '<span class="vh-emo-cell" style="background:' + def.color + (dm === "settled" ? ";opacity:.4" : "") + '" title="' +
        esc(def.label + " \u00b7 " + (m.page || "/") + (dm !== "settled" ? " (" + Math.round(e[dm]) + "/100)" : "")) + '"></span>';
    }).join("");

    var last = moments[moments.length - 1] || {};
    var dl = { id: SEL, visitor_id: SEL, session_id: last.session_id || "", page_url: last.page || "" };
    var tiles = [
      ["session-recordings", "bi-play-btn", T("vi.btn.watch_moments")],
      ["heatmaps", "bi-fire", T("vi.btn.where_friction")],
      ["visitor-intelligence", "bi-stars", T("vi.btn.ai_insight")]
    ].map(function (x) {
      var params = x[0] === "visitor-intelligence" ? { id: SEL, tab: "insights" } : dl;
      return '<a class="vh-traj-tile" href="' + esc(link(x[0], params)) + '" title="Open ' + x[2] + '"><i class="bi ' + x[1] + '"></i><span>' + x[2] + "</span></a>";
    }).join("");

    host.hidden = false;
    host.innerHTML =
      '<div class="vh-emo-head"><span class="vh-h">'+T('vih.emotional_reconstruction')+'</span>' +
        '<span class="vh-traj-badge" style="color:' + hcol + ';border-color:' + hcol + '33;background:' + hcol + '14">' + esc(headline) + "</span>" +
        emoInfo() + "</div>" +
      '<div class="vh-emo-graph">' + emoWaveSvg(vals, dips) +
        (dips.length ? '<span class="vh-emo-dip" title="'+T('vih.low_points_u2014_where_the_visit_felt_most_n')+'">' + dips.length + " dip" + (dips.length === 1 ? "" : "s") + "</span>" : "") + "</div>" +
      '<div class="vh-emo-strip-wrap"><span class="vh-emo-strip-l">'+T('vih.page_by_page')+'</span><div class="vh-emo-strip">' + strip + "</div></div>" +
      '<div class="vh-emo-badges">' + (badges || '<span class="vh-emo-thin">Low arousal throughout \u2014 no strong emotion to report.</span>') + "</div>" +
      '<div class="vh-traj-tiles">' + tiles + "</div>";
  }

  /* ================================================= Micro-Behavior Signature engine
     The classification is the persona (Buyer / Researcher / Skimmer / Confused / Comparison /
     Frustrated); this panel shows it AS a signature plus the fingerprint underneath — the seven
     micro-behaviours the /signature endpoint tallied from the per-page types and reasons. */
  function sigName(k){ return T("vi.sig." + k); }
  function sigHelp(k){ return T("vi.sig_d." + k); }
  var SIG_DIM = [
    ["reading_cadence",  T('vih.reading_cadence'),  "#1FA463", T('vih.how_thoroughly_they_read_u2014_deep_sustaine')],
    ["cta_approach",     T('vih.cta_approach'),     "#0891B2", T('vih.how_they_approached_calls_to_action_u2014_dw')],
    ["hover_hesitation", T('vih.hover_hesitation'), "#D97706", T('vih.pausing_over_links_and_buttons_before_commit')],
    ["scroll_rhythm",    T('vih.scroll_rhythm'),    "#2A6FE8", T('vih.the_scroll_pattern_u2014_steady_reading_vers')],
    ["backtracking",     T('vih.backtracking'),     "#E0533D", T('vih.returning_to_earlier_pages_or_scroll_positio')],
    ["mouse_drift",      T('vih.mouse_drift'),      "#7C3AED", T('vih.erratic_pointer_movement_u2014_exit_drifts_r')],
    ["form_hesitation",  T('vih.form_hesitation'),  "#EA580C", T('vih.hesitating_inside_forms_approximate_without_')]
  ];
  function sigInfo() {
    return '<details class="vh-info"><summary title=T("vi.info.sig_title")><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.sig_1") +
      T("vi.info.sig_2") +
      T("vi.info.sig_3") +
      "</div></details>";
  }
  function renderSignature() {
    var host = q("sig"); if (!host) return;
    if (!SEL) { host.hidden = true; return; }
    var d = SIG[SEL];
    if (!d) { host.hidden = true; return; }
    var sig = d.signature, micro = d.micro || {};
    if (!sig || !d.pages) {
      host.hidden = false;
      host.innerHTML = '<div class="vh-sig-head"><span class="vh-h">'+T('vih.micro_behaviour_signature')+'</span>' + sigInfo() + "</div>" +
        '<div class="vh-sig-thin">Not enough scored interaction to fingerprint this visitor yet \u2014 it appears once the tracker has a few pages of micro-behaviour.</div>';
      return;
    }
    var col = pcol(sig), icon = picon(sig);
    var max = 0; SIG_DIM.forEach(function (x) { if ((micro[x[0]] || 0) > max) max = micro[x[0]]; });
    var bars = SIG_DIM.map(function (x) {
      var v = micro[x[0]] || 0, pct = max ? Math.round(v / max * 100) : 0;
      return '<div class="vh-sig-row" title="' + esc(x[3] + (v ? " \u2014 seen on " + v + " page" + (v === 1 ? "" : "s") + "." : " \u2014 not seen this visit.")) + '">' +
        '<span class="vh-sig-l">' + x[1] + "</span>" +
        '<span class="vh-sig-b"><i style="width:' + pct + "%;background:" + x[2] + (v ? "" : ";opacity:.22") + '"></i></span></div>';
    }).join("");
    var ranked = SIG_DIM.filter(function (x) { return (micro[x[0]] || 0) > 0; }).sort(function (a, b) { return micro[b[0]] - micro[a[0]]; });
    var defline = ranked.length
      ? T("vi.sig.defined_by", {a: sigName(ranked[0][0]).toLowerCase(), b: ranked[1] ? " " + T("vi.si.and") + " " + sigName(ranked[1][0]).toLowerCase() : ""})
      : "A light footprint \u2014 little distinctive micro-behaviour yet.";

    var dl = { id: SEL, visitor_id: SEL };
    var tiles = [
      ["session-recordings", "bi-play-btn", T("vi.btn.watch_pattern")],
      ["heatmaps", "bi-fire", T("vi.btn.hover_map")],
      ["visitor-intelligence", "bi-stars", T("vi.btn.ai_insight")]
    ].map(function (x) {
      var params = x[0] === "visitor-intelligence" ? { id: SEL, tab: "insights" } : dl;
      return '<a class="vh-traj-tile" href="' + esc(link(x[0], params)) + '" title="Open ' + x[2] + '"><i class="bi ' + x[1] + '"></i><span>' + x[2] + "</span></a>";
    }).join("");

    host.hidden = false;
    host.innerHTML =
      '<div class="vh-sig-head"><span class="vh-h">'+T('vih.micro_behaviour_signature')+'</span>' +
        '<span class="vh-traj-badge" style="color:' + col + ";border-color:" + col + "33;background:" + col + '14" title="' + esc(phelp(sig)) + '">' +
          '<i class="bi ' + icon + '"></i> ' + esc(sig) + "</span>" + sigInfo() + "</div>" +
      '<div class="vh-sig-bars">' + bars + "</div>" +
      '<div class="vh-sig-def">' + defline + " <span class=\"vh-sig-pages\">" + d.pages + " page" + (d.pages === 1 ? "" : "s") + " fingerprinted</span></div>" +
      '<div class="vh-traj-tiles">' + tiles + "</div>";
  }

  /* ================================================= Visitor Motivation Decoder
     WHY are they here? The honest signal is WHERE they went. Each motivation owns a set of path
     keywords; we score them against the distinct pages the visitor viewed (from /motivation), weight
     by how often, fold in a couple of referrer signals, and surface the dominant one with its
     confidence and the pages that gave it away. Presentation over existing data; nothing stored. */
  function motName(k){ return T("vi.mot." + k); }
  function motHelp(k){ return T("vi.mot_d." + k); }
  var MOT = [
    ["price",       T('vih.price_checking'),       "#1FA463", "bi-tag",            T('vih.focused_on_what_it_costs_u2014_pricing_plans'),            ["pricing", "price", "/cost", "plans", "/plan", "quote", "subscription", "kosten", "tarief"]],
    ["features",    T('vih.feature_research'),     "#2A6FE8", "bi-list-check",     T('vih.digging_into_what_it_does_u2014_features_doc'),     ["feature", "product", "/docs", "documentation", "how-it-works", "capabilit", "integration", "/spec", "/tour"]],
    ["compare",     T('vih.comparing_options'),    "#D97706", "bi-shuffle",        T('vih.weighing_alternatives_u2014_comparison_and_v'),           ["compare", "/vs", "versus", "alternativ", "comparison", "competitor"]],
    ["support",     T('vih.seeking_support'),      "#0891B2", "bi-life-preserver", T('vih.looking_for_help_u2014_support_faq_contact_t'),     ["support", "/help", "faq", "contact", "troubleshoot", "ticket", "/service"]],
    ["reassurance", T('vih.seeking_reassurance'),  "#7C3AED", "bi-shield-check",   T('vih.checking_they_can_trust_you_u2014_about_secu'), ["/about", "security", "privacy", "guarantee", "refund", "/terms", "policy", "/trust", "gdpr"]],
    ["proof",       T('vih.looking_for_proof'),    "#059669", "bi-patch-check",    T('vih.wanting_evidence_u2014_testimonials_reviews_'), ["testimonial", "review", "case-stud", "casestud", "/customer", "/client", "results", "portfolio", "success", "/stories"]],
    ["deal",        T('vih.hunting_a_deal'),       "#EA580C", "bi-percent",        T('vih.after_a_discount_u2014_deals_offers_coupons_'),             ["deal", "discount", "/sale", "offer", "coupon", "promo", "special", "/free", "/trial"]]
  ];
  function motOf(k) { return MOT.filter(function (m) { return m[0] === k; })[0]; }
  function decodeMotivation(d) {
    var paths = (d && d.paths) || [], refs = (d && d.referrers) || [];
    var scores = {}, hits = {};
    MOT.forEach(function (m) { scores[m[0]] = 0; hits[m[0]] = []; });
    paths.forEach(function (p) {
      var lp = String(p.path || "").toLowerCase(), w = Math.min(3, p.count || 1);
      MOT.forEach(function (m) {
        var pat = m[5];
        for (var i = 0; i < pat.length; i++) { if (lp.indexOf(pat[i]) !== -1) { scores[m[0]] += w; hits[m[0]].push(p.path); break; } }
      });
    });
    refs.forEach(function (r) {
      var h = String(r.host || "").toLowerCase();
      if (/compar|versus|alternativeto/.test(h)) scores.compare += 2;
      if (/review|trustpilot|\bg2\b|capterra|producthunt/.test(h)) scores.proof += 2;
    });
    var ranked = MOT.map(function (m) { return m[0]; }).filter(function (k) { return scores[k] > 0; }).sort(function (a, b) { return scores[b] - scores[a]; });
    if (!ranked.length) return { top: null, pages: paths.length };
    var total = ranked.reduce(function (s, k) { return s + scores[k]; }, 0);
    var top = ranked[0], share = scores[top] / total;
    var conf = (scores[top] >= 4 && share >= 0.5) ? "High" : (scores[top] >= 2 || share >= 0.6) ? "Medium" : "Low";
    return { top: top, ranked: ranked, scores: scores, hits: hits, share: share, conf: conf, pages: paths.length };
  }
  function motInfo() {
    return '<details class="vh-info"><summary title=T("vi.info.mot_title")><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.mot_1") +
      T("vi.info.mot_2") +
      T("vi.info.mot_3") +
      "</div></details>";
  }
  function renderMotivation() {
    var host = q("mot"); if (!host) return;
    if (!SEL) { host.hidden = true; return; }
    var d = MOTD[SEL];
    if (!d) { host.hidden = true; return; }
    var r = decodeMotivation(d);
    host.hidden = false;
    if (!r.top) {
      host.innerHTML = '<div class="vh-mot-head"><span class="vh-h">'+T('vih.motivation')+'</span>' + motInfo() + "</div>" +
        '<div class="vh-mot-thin">' + (r.pages ? "General browsing \u2014 the pages viewed don\u2019t point to one clear motivation yet." : T('vih.no_pages_recorded_for_this_visitor_yet')) + "</div>";
      return;
    }
    var m = motOf(r.top), col = m[2];
    var dedupe = r.hits[r.top].filter(function (v, i, a) { return a.indexOf(v) === i; }).slice(0, 3);
    var reason = dedupe.length ? "Signalled by " + dedupe.map(function (p) { return "<b>" + esc(p) + "</b>"; }).join(", ") + "." : "";
    var confCol = r.conf === T('vih.high') ? "#1FA463" : r.conf === T('vih.medium') ? "#D97706" : "#8798B0";
    var confPct = r.conf === T('vih.high') ? 100 : r.conf === T('vih.medium') ? 62 : 30;
    var secondary = r.ranked.slice(1, 3).map(function (k) {
      var mm = motOf(k);
      return '<span class="vh-mot-chip" style="color:' + mm[2] + '" title="' + esc(motHelp(mm[0])) + '"><i class="bi ' + mm[3] + '"></i> ' + esc(motName(mm[0])) + "</span>";
    }).join("");

    var tiles = [
      ["user-flow", "bi-diagram-3", T("vi.btn.path"), { id: SEL, visitor_id: SEL }],
      ["funnels", "bi-filter", T("vi.btn.converted"), { id: SEL, visitor_id: SEL }],
      ["visitor-intelligence", "bi-stars", T("vi.btn.ai_insight"), { id: SEL, tab: "insights" }]
    ].map(function (x) {
      return '<a class="vh-traj-tile" href="' + esc(link(x[0], x[3])) + '" title="Open ' + x[2] + '"><i class="bi ' + x[1] + '"></i><span>' + x[2] + "</span></a>";
    }).join("");

    host.innerHTML =
      '<div class="vh-mot-head"><span class="vh-h">'+T('vih.motivation')+'</span>' +
        '<span class="vh-traj-badge" style="color:' + col + ";border-color:" + col + "33;background:" + col + '14" title="' + esc(m[4]) + '"><i class="bi ' + m[3] + '"></i> ' + esc(m[1]) + "</span>" +
        motInfo() + "</div>" +
      (reason ? '<div class="vh-mot-reason">' + reason + "</div>" : "") +
      '<div class="vh-mot-conf"><span class="vh-mot-conf-l">'+T('vih.confidence')+'</span>' +
        '<span class="vh-mot-conf-bar"><i style="width:' + confPct + "%;background:" + confCol + '"></i></span>' +
        '<span class="vh-mot-conf-v" style="color:' + confCol + '">' + r.conf + "</span></div>" +
      (secondary ? '<div class="vh-mot-sec"><span class="vh-mot-sec-l">'+T('vih.also')+'</span>' + secondary + "</div>" : "") +
      '<div class="vh-traj-tiles">' + tiles + "</div>";
  }

  /* ================================================= Decision Moment Detector
     The points in a visit where a decision got made \u2014 to explore, compare, hesitate, commit, buy or
     leave. These are transitions in the SAME per-page moment sequence the emotion panel already loaded
     (/emotions), so this reads EMO[SEL] and detects; no extra fetch. Presentation over existing data. */
  var DEC = {
    explore:  { label: T('vih.explored'),   color: "#2A6FE8", icon: "bi-compass",         headline: "Explored the site" },
    compare:  { label: T('vih.compared'),   color: "#D97706", icon: "bi-shuffle",         headline: "Compared options" },
    hesitate: { label: T('vih.hesitated'),  color: "#EA580C", icon: "bi-pause-circle",    headline: "Hesitated before acting" },
    commit:   { label: T('vih.committed'),  color: "#0891B2", icon: "bi-check2-circle",   headline: "Committed to the goal" },
    buy:      { label: T('vih.buy_signal'), color: "#1FA463", icon: "bi-bag-check",       headline: "Reached a buying moment" },
    leave:    { label: T('vih.left'),       color: "#E0533D", icon: "bi-box-arrow-right", headline: "Decided to leave" }
  };
  function detectDecisions(moments) {
    var out = [], seen = {};
    moments.forEach(function (m, idx) {
      var prev = idx > 0 ? moments[idx - 1] : null;
      var i = m.i == null ? 0 : m.i, f = m.f == null ? 0 : m.f, a = m.a == null ? 0 : m.a;
      var pi = prev ? (prev.i == null ? 0 : prev.i) : 0, page = m.page || "/";
      var last = idx === moments.length - 1, backtrack = seen[page] !== undefined;
      var type = null, why = "";
      if (m.itype === "exit-risk" || (last && (f >= 55 || (i < 35 && i < pi - 10)))) {
        type = "leave"; why = m.itype === "exit-risk" ? "Cursor drifted to leave" : (f >= 55 ? "Left amid friction" : T('vih.interest_faded_and_they_dropped_off'));
      } else if (i >= 75 && (m.itype === "high-intent" || i >= pi + 12)) {
        type = "buy"; why = T('vih.intent_spiked_to') + i + " \u2014 reached for it";
      } else if (i >= 68 && pi >= 62) {
        type = "commit"; why = T('vih.held_high_intent_across_pages');
      } else if (m.ftype === "hesitant" || (prev && i >= 35 && i <= 65 && f >= 30 && f <= 55 && Math.abs(i - pi) <= 6)) {
        type = "hesitate"; why = m.ftype === "hesitant" ? "Paused before acting" : T('vih.stalled_u2014_no_forward_movement');
      } else if (backtrack || m.ftype === "lost") {
        type = "compare"; why = backtrack ? "Returned to " + page : T('vih.doubled_back_looking');
      } else if (idx <= 1 && a >= 45 && i >= 20) {
        type = "explore"; why = T('vih.started_exploring');
      }
      seen[page] = idx;
      if (type) out.push({ idx: idx, page: page, ts: m.ts, session_id: m.session_id, type: type, why: why });
    });
    // collapse consecutive same-type runs into one marker (the first of the run)
    var seq = [], prevT = null;
    out.forEach(function (x) { if (x.type !== prevT) { seq.push(x); prevT = x.type; } });
    return seq;
  }
  function decInfo() {
    return '<details class="vh-info"><summary title=T("vi.info.dec_title")><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.dec_1") +
      T("vi.info.dec_2") +
      T("vi.info.dec_3") +
      "</div></details>";
  }
  function renderDecision() {
    var host = q("dec"); if (!host) return;
    if (!SEL) { host.hidden = true; return; }
    var d = EMO[SEL];
    if (!d) { host.hidden = true; return; }               // shares the emotion payload; waits for it
    var moments = (d.moments || []).filter(function (m) { return m && m.i != null; });
    var head = '<div class="vh-dec-head"><span class="vh-h">'+T('vih.decision_moments')+'</span>';
    if (moments.length < 2) {
      host.hidden = false;
      host.innerHTML = head + decInfo() + "</div><div class=\"vh-dec-thin\">" + T('vih.the_decision_path_appears_once_this_visitor_') + "</div>";
      return;
    }
    var seq = detectDecisions(moments);
    host.hidden = false;
    if (!seq.length) {
      host.innerHTML = head + decInfo() + "</div><div class=\"vh-dec-thin\">Steady browsing \u2014 no decisive moment stood out this visit.</div>";
      return;
    }
    // the decision that mattered is where they ended up; the flow shows how they got there
    var key = seq[seq.length - 1];
    var kd = DEC[key.type];
    var steps = seq.map(function (x, k) {
      var def = DEC[x.type];
      return '<span class="vh-dec-step" style="color:' + def.color + ";border-color:" + def.color + '55" title="' + esc(def.label + " \u00b7 " + x.page + " \u2014 " + x.why) + '"><i class="bi ' + def.icon + '"></i>' + def.label + "</span>" +
        (k < seq.length - 1 ? '<i class="bi bi-chevron-right vh-dec-arrow"></i>' : "");
    }).join("");

    var lastM = moments[moments.length - 1] || {};
    var dl = { id: SEL, visitor_id: SEL, session_id: key.session_id || lastM.session_id || "", page_url: key.page || lastM.page || "" };
    var tiles = [
      ["session-recordings", "bi-play-btn", T("vi.btn.watch_moment")],
      ["funnels", "bi-filter", T("vi.btn.where_dropped")],
      ["visitor-intelligence", "bi-stars", T("vi.btn.ai_insight")]
    ].map(function (x) {
      var params = x[0] === "visitor-intelligence" ? { id: SEL, tab: "insights" } : dl;
      return '<a class="vh-traj-tile" href="' + esc(link(x[0], params)) + '" title="Open ' + x[2] + '"><i class="bi ' + x[1] + '"></i><span>' + x[2] + "</span></a>";
    }).join("");

    host.innerHTML = head +
        '<span class="vh-traj-badge" style="color:' + kd.color + ";border-color:" + kd.color + "33;background:" + kd.color + '14"><i class="bi ' + kd.icon + '"></i> ' + esc(kd.headline) + "</span>" +
        decInfo() + "</div>" +
      '<div class="vh-dec-flow">' + steps + "</div>" +
      '<div class="vh-traj-tiles">' + tiles + "</div>";
  }

  /* ================================================= Behavioural Map of the Website
     A site-level view: every page placed by how visitors behave on it \u2014 intent (x) against friction
     (y), sized by traffic \u2014 and classified hot / confusing / high-friction / high-attention / drop-off
     / cold. Aggregated per page from the three score tables (/behaviormap). The client owns the
     thresholds so they stay visible. This is presentation over data the tracker already scores. */
  var BMAP = {
    hot:       { label: "Hot",            color: "#1FA463", icon: "bi-fire",            help: "High intent, low friction \u2014 these pages are working. People arrive engaged and move forward." },
    confusing: { label: T('vih.confusing'),      color: "#D97706", icon: "bi-patch-question",  help: "Wanted but hard \u2014 real intent alongside real friction. Fix what\u2019s fighting them and these convert." },
    friction:  { label: T('vih.high_friction'),  color: "#E0533D", icon: "bi-emoji-frown",     help: "Frustration runs high \u2014 rage clicks, dead clicks, backtracking. Something here is fighting the visitor." },
    attention: { label: T('vih.high_attention'), color: "#6C4BE8", icon: "bi-eye",             help: "Deeply read \u2014 people spend real attention here. Great for content; make the next step obvious." },
    dropoff:   { label: T('vih.drop_off'),       color: "#EA580C", icon: "bi-box-arrow-right", help: "Visits tend to end here \u2014 a high share show exit intent. A leak worth plugging." },
    cold:      { label: T('vih.cold'),           color: "#8798B0", icon: "bi-snow",            help: "Little engagement \u2014 low intent and low attention. People pass through without connecting." },
    neutral:   { label: T('vih.neutral'),        color: "#5C6E88", icon: "bi-dash-circle",     help: "No strong signal either way \u2014 a middling page." }
  };
  function bmName(k){ return T("vi.bm." + k); }
  function bmHelp(k){ return T("vi.bm_d." + k); }
  function classifyPage(p) {
    var i = p.intent || 0, f = p.frustration || 0, a = p.attention || 0, v = p.views || 0, er = v ? (p.exits || 0) / v : 0;
    var badges = [];
    if (i >= 60) badges.push([T('vih.high_intent'), "#1FA463"]);
    if (a >= 60) badges.push([T('vih.high_attention'), "#6C4BE8"]);
    if (f >= 50) badges.push([T('vih.high_friction'), "#E0533D"]);
    if (er >= 0.45) badges.push([T('vih.drop_off'), "#EA580C"]);
    var primary;
    if (f >= 55 && a >= 40 && i >= 40) primary = "confusing";
    else if (er >= 0.5 && i < 45) primary = "dropoff";
    else if (i >= 60 && f < 45) primary = "hot";
    else if (f >= 50) primary = "friction";
    else if (a >= 60) primary = "attention";
    else if (i < 30 && a < 35) primary = "cold";
    else primary = "neutral";
    return { primary: primary, badges: badges, er: er };
  }
  function mapInfo() {
    return '<details class="vh-info"><summary title=T("vi.info.map_title")><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.map_1") +
      T("vi.info.map_2") +
      T("vi.info.map_3") +
      "</div></details>";
  }
  function mapScatter(pages) {
    var W = 600, H = 470, L = 56, R = 584, T = 18, B = 410, pW = R - L, pH = B - T;
    var maxV = 1; pages.forEach(function (p) { if (p.views > maxV) maxV = p.views; });
    function x(i) { return L + (Math.max(0, Math.min(100, i)) / 100) * pW; }
    function y(f) { return T + (1 - Math.max(0, Math.min(100, f)) / 100) * pH; }
    var xMid = x(50), yMid = y(50);
    var s = '<svg viewBox="0 0 ' + W + " " + H + '" role="img" aria-label=T("vi.map.title") class="vh-bm-svg">';
    // quadrant tints
    s += '<rect x="' + xMid + '" y="' + yMid + '" width="' + (R - xMid) + '" height="' + (B - yMid) + '" fill="#1FA463" opacity="0.055"/>';   // hot
    s += '<rect x="' + xMid + '" y="' + T + '" width="' + (R - xMid) + '" height="' + (yMid - T) + '" fill="#D97706" opacity="0.055"/>';       // confusing
    s += '<rect x="' + L + '" y="' + T + '" width="' + (xMid - L) + '" height="' + (yMid - T) + '" fill="#E0533D" opacity="0.05"/>';           // problem
    s += '<rect x="' + L + '" y="' + yMid + '" width="' + (xMid - L) + '" height="' + (B - yMid) + '" fill="#8798B0" opacity="0.05"/>';        // cold
    // quadrant corner labels
    s += '<text class="vh-bm-q" x="' + (R - 6) + '" y="' + (B - 8) + '" text-anchor="end">working</text>';
    s += '<text class="vh-bm-q" x="' + (R - 6) + '" y="' + (T + 14) + '" text-anchor="end">confusing</text>';
    s += '<text class="vh-bm-q" x="' + (L + 6) + '" y="' + (T + 14) + '">problem</text>';
    s += '<text class="vh-bm-q" x="' + (L + 6) + '" y="' + (B - 8) + '">ignored</text>';
    // axes
    s += '<line class="vh-bm-ax" x1="' + L + '" y1="' + B + '" x2="' + R + '" y2="' + B + '"/>';
    s += '<line class="vh-bm-ax" x1="' + L + '" y1="' + T + '" x2="' + L + '" y2="' + B + '"/>';
    s += '<line class="vh-bm-mid" x1="' + xMid + '" y1="' + T + '" x2="' + xMid + '" y2="' + B + '"/>';
    s += '<line class="vh-bm-mid" x1="' + L + '" y1="' + yMid + '" x2="' + R + '" y2="' + yMid + '"/>';
    s += '<text class="vh-bm-al" x="' + ((L + R) / 2) + '" y="' + (B + 26) + '" text-anchor="middle">Intent \u2192</text>';
    s += '<text class="vh-bm-al" transform="translate(' + (L - 38) + "," + ((T + B) / 2) + ') rotate(-90)" text-anchor="middle">Frustration \u2192</text>';
    // bubbles (largest first so small ones stay clickable/hoverable on top)
    pages.slice().sort(function (a, b) { return b.views - a.views; }).forEach(function (p) {
      var c = classifyPage(p), col = BMAP[c.primary].color;
      var r = 4 + 18 * Math.sqrt(p.views / maxV);
      var tip = p.page + "\n" + bmName(c.primary) + " \u00b7 " + nf(p.views) + " views\n" +
        "Intent " + p.intent + " \u00b7 Frustration " + p.frustration + " \u00b7 Attention " + p.attention +
        (c.er >= 0.3 ? "\nExit intent on " + Math.round(c.er * 100) + "% of visits" : "");
      s += '<circle class="vh-bm-dot" data-page="' + esc(p.page) + '" cx="' + x(p.intent).toFixed(1) + '" cy="' + y(p.frustration).toFixed(1) +
        '" r="' + r.toFixed(1) + '" fill="' + col + '" fill-opacity="0.62" stroke="' + col + '" stroke-width="1.2"><title>' + esc(tip) + "</title></circle>";
    });
    s += "</svg>";
    return s;
  }
  function mapList(pages) {
    return pages.slice(0, 40).map(function (p) {
      var c = classifyPage(p), def = BMAP[c.primary];
      var bars = [["intent", p.intent, "#1FA463"], ["friction", p.frustration, "#E0533D"], ["attention", p.attention, "#6C4BE8"]].map(function (m) {
        return '<span class="vh-bm-m" title="' + m[0] + " " + m[1] + '"><i style="width:' + m[1] + "%;background:" + m[2] + '"></i></span>';
      }).join("");
      var badges = c.badges.slice(0, 2).map(function (b) { return '<span class="vh-bm-tag" style="color:' + b[1] + '">' + esc(b[0]) + "</span>"; }).join("");
      var links = [["heatmaps", "bi-fire", T('vih.heatmap')], ["session-recordings", "bi-play-btn", T("vi.btn.recordings")], ["user-flow", "bi-diagram-3", T('vih.flow')]].map(function (l) {
        return '<a class="vh-bm-lk" href="' + esc(link(l[0], { page: p.page, page_url: p.page })) + '" title="' + l[2] + ' for this page"><i class="bi ' + l[1] + '"></i></a>';
      }).join("");
      return '<div class="vh-bm-row">' +
        '<span class="vh-bm-badge" style="color:' + def.color + ";border-color:" + def.color + "33;background:" + def.color + '14" title="' + esc(bmHelp(c.primary)) + '"><i class="bi ' + def.icon + '"></i> ' + esc(bmName(c.primary)) + "</span>" +
        '<span class="vh-bm-p" title="' + esc(p.page) + '">' + esc(p.page) + "</span>" +
        '<span class="vh-bm-bars">' + bars + "</span>" +
        '<span class="vh-bm-tags">' + badges + "</span>" +
        '<span class="vh-bm-v">' + nf(p.views) + "</span>" +
        '<span class="vh-bm-lks">' + links + "</span></div>";
    }).join("");
  }
  function drawMap(data) {
    var pages = (data && data.pages) || [];
    var sumH = q("map-summary"), scH = q("map-scatter"), liH = q("map-list");
    if (!pages.length) {
      if (sumH) sumH.innerHTML = "";
      if (scH) scH.innerHTML = '<div class="vh-empty" style="padding:30px 0">'+T('vih.no_scored_pages_in_this_range_yet')+'<br>'+T('vih.the_map_fills_as_the_tracker_scores_behaviou')+'</div>';
      if (liH) liH.innerHTML = "";
      return;
    }
    var counts = {}; pages.forEach(function (p) { var k = classifyPage(p).primary; counts[k] = (counts[k] || 0) + 1; });
    if (sumH) {
      sumH.innerHTML = Object.keys(BMAP).filter(function (k) { return counts[k]; }).sort(function (a, b) { return counts[b] - counts[a]; }).map(function (k) {
        var d = BMAP[k];
        return '<span class="vh-bm-chip" style="color:' + d.color + '" title="' + esc(bmHelp(k)) + '"><i class="bi ' + d.icon + '"></i> ' + esc(bmName(k)) + " <b>" + counts[k] + "</b></span>";
      }).join("");
    }
    if (scH) {
      scH.innerHTML = mapScatter(pages);
      scH.querySelectorAll(".vh-bm-dot").forEach(function (c) {
        c.addEventListener("click", function () {
          var row = liH && liH.querySelector('[data-page="' + CSS.escape(c.getAttribute("data-page")) + '"]');
          if (row && row.scrollIntoView) { row.scrollIntoView({ behavior: "smooth", block: "center" }); row.classList.add("hl"); setTimeout(function () { row.classList.remove("hl"); }, 1400); }
        });
      });
    }
    if (liH) {
      liH.innerHTML = mapList(pages);
      liH.querySelectorAll(".vh-bm-row").forEach(function (r, idx) { r.setAttribute("data-page", pages[idx] ? pages[idx].page : ""); });
    }
  }
  function renderMap() {
    var scH = q("map-scatter"); if (!scH) return;
    var mi = q("map-info"); if (mi && !mi.innerHTML) mi.innerHTML = mapInfo();
    var key = RANGE.from + "|" + RANGE.to;
    if (MAP[key]) { drawMap(MAP[key]); return; }
    scH.innerHTML = '<div class="vh-empty" style="padding:30px 0">Mapping behaviour across your pages\u2026</div>';
    var sumH = q("map-summary"), liH = q("map-list"); if (sumH) sumH.innerHTML = ""; if (liH) liH.innerHTML = "";
    api("/plugin/visitor-intelligence/behaviormap?" + rng()).then(function (r) {
      if (!r || !r.ok) { scH.innerHTML = '<div class="vh-empty" style="padding:30px 0">Couldn\u2019t load the behavioural map.</div>'; return; }
      MAP[key] = r;
      if (VIEW === "map") drawMap(r);
    }).catch(function () { if (q("map-scatter")) q("map-scatter").innerHTML = '<div class="vh-empty" style="padding:30px 0">Couldn\u2019t load the behavioural map.</div>'; });
  }

  /* ================================================= Site Overview (rollups)
     The whole site at a glance \u2014 one card per intelligence layer, each rolled up across everyone in
     the range. Cheap aggregates from /overview (pulse, personas, journeys, intent trend, how visits
     end) plus /behaviormap (motivation + the map). Every card reuses the exact model from its engine's
     detail view, so the rollup and the drill-down agree. */
  var OV = null;
  function endName(k){ return T("vi.end." + String(k).replace(/-/g,"_")); }
  var END_MAP = {
    "high-intent": [T('vih.buy_ready'), "#1FA463", "bi-bag-check"],
    "exploring":   [T("vi.end.exploring"), "#2A6FE8", "bi-compass"],
    "low-intent":  [T("vi.end.low_intent"), "#8798B0", "bi-dash-circle"],
    "exit-risk":   [T('vih.left'), "#E0533D", "bi-box-arrow-right"]
  };
  function ovInfo() {
    return '<details class="vh-info"><summary title=T("vi.info.ov_title")><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.ov_1") +
      T("vi.info.ov_2") +
      T("vi.info.ov_3") +
      "</div></details>";
  }
  function ovCard(title, icon, body, action) {
    return '<div class="vh-ov-card"><div class="vh-ov-ch"><span class="vh-ov-ct"><i class="bi ' + icon + '"></i> ' + title + "</span>" + (action || "") + '</div><div class="vh-ov-cb">' + body + "</div></div>";
  }
  function ovGauge(k, v) {
    var g = GAUGE[k];
    return '<div class="vh-ovg"><div class="vh-ovg-t"><span>' + g.label + "</span><b>" + (v == null ? "\u2013" : v) + "</b></div>" +
      '<div class="vh-ovg-bar"><i style="width:' + (v || 0) + "%;background:" + g.ring[1] + '"></i></div>' +
      '<div class="vh-ovg-b">' + (v == null ? "no data" : g.band(v)) + "</div></div>";
  }
  function ovPulse(d) {
    var body = '<div class="vh-ov-gauges">' + ovGauge("intent", d.intent) + ovGauge("frustration", d.frustration) + ovGauge("attention", d.attention) + "</div>";
    var sub = nf(d.sessions) + " scored session" + (d.sessions === 1 ? "" : "s") + (d.scroll != null ? " \u00b7 avg scroll " + d.scroll + "%" : "");
    return ovCard(T("vi.h.site_pulse"), "bi-activity", body + '<div class="vh-ov-note">' + sub + "</div>", null);
  }
  function ovTrajectory(d) {
    var trend = (d.trend || []).filter(function (x) { return x.n > 0; });
    if (trend.length < 2) return ovCard(T("vi.h.intent_traj"), "bi-graph-up-arrow", '<div class="vh-ov-thin">'+T('vih.not_enough_days_with_scored_behaviour_to_dra')+'</div>', null);
    var scores = trend.map(function (x) { return x.intent; }), st = trajStats(scores);
    var dir = st.slope > 1.2 ? "rising" : st.slope < -1.2 ? "falling" : "steady";
    var dcol = dir === "rising" ? "#1FA463" : dir === "falling" ? "#E0533D" : "#2A6FE8";
    var dlbl = T(dir === "rising" ? "vi.intent.warming" : dir === "falling" ? "vi.intent.cooling" : "vi.intent.steady");
    var ic = dir === "rising" ? "bi-graph-up-arrow" : dir === "falling" ? "bi-graph-down-arrow" : "bi-dash-lg";
    return ovCard(T("vi.h.intent_traj"), "bi-graph-up-arrow",
      '<div class="vh-ov-badge" style="color:' + dcol + ";border-color:" + dcol + "33;background:" + dcol + '14"><i class="bi ' + ic + '"></i> ' + dlbl + "</div>" +
      '<div class="vh-ov-spark">' + trajSvg(scores, st.rev || [], dcol, "#E3E8EE") + "</div>" +
      '<div class="vh-ov-note">Daily average intent, ' + trend[0].date + " \u2192 " + trend[trend.length - 1].date + ".</div>", null);
  }
  function ovEmotion(d) {
    if (d.intent == null) return ovCard(T("vi.h.emo_climate"), "bi-emoji-smile", '<div class="vh-ov-thin">'+T('vih.no_scored_behaviour_in_this_range_yet')+'</div>', null);
    var e = reconEmo({ i: d.intent, f: d.frustration, a: d.attention }), dom = emoDominant(e), def = EMODEF[dom];
    var mix = EMO_KEYS.filter(function (k) { return e[k] > 0; }).sort(function (a, b) { return e[b] - e[a]; }).slice(0, 3);
    var chips = mix.length ? mix.map(function (k) { var dd = EMODEF[k]; return '<span class="vh-ov-chip" style="color:' + dd.color + '"><i class="bi ' + dd.icon + '"></i> ' + esc(emoName(k)) + "</span>"; }).join("") : '<span class="vh-ov-thin">'+T("vi.climate.calm")+'</span>';
    return ovCard(T("vi.h.emo_climate"), "bi-emoji-smile",
      '<div class="vh-ov-badge" style="color:' + def.color + ";border-color:" + def.color + "33;background:" + def.color + '14"><i class="bi ' + def.icon + '"></i> Mostly ' + def.label.toLowerCase() + "</div>" +
      '<div class="vh-ov-chips">' + chips + "</div>" +
      '<div class="vh-ov-note">Reconstructed from the site\u2019s average intent, friction and attention.</div>', null);
  }
  /**
   * T("vi.h.emo_signals") — the three scores as waves, in the visual language of the sign-in screen.
   *
   * The sign-in illustration is decorative: three hand-drawn curves that always look the same. Dropping
   * that same SVG here would put a shape that ignores the data next to charts that don't, which is worse
   * than no shape at all. So every part of this is driven by the numbers:
   *   - each wave's HEIGHT is its score, so a high-intent site visibly rides above a frustrated one;
   *   - each wave's AMPLITUDE is its score too, so a flat signal draws flat rather than decoratively wavy;
   *   - the end of each line carries its value, because a chart on a dashboard has to be readable, not
   *     just pretty.
   */
  function ovSignals(d) {
    if (d.intent == null)
      return ovCard(T("vi.h.emo_signals"), "bi-activity",
        '<div class="vh-ov-thin">No scored behaviour in this range yet \u2014 signals appear once visits have been scored.</div>', null);

    var W = 300, H = 120, PAD = 10, RIGHT = 34;
    var plotW = W - PAD - RIGHT, plotH = H - PAD * 2;
    var SIG = [
      { k: "intent",      label: T('vih.intent'),      v: +d.intent      || 0, col: "#1FA463" },
      { k: "attention",   label: T('vih.attention'),   v: +d.attention   || 0, col: "#2A6FE8" },
      { k: "frustration", label: T('vih.frustration'), v: +d.frustration || 0, col: "#D97706" }
    ];

    var paths = SIG.map(function (sg, idx) {
      var t = Math.max(0, Math.min(100, sg.v)) / 100;
      var y = PAD + plotH - t * plotH;                 // score sets the height
      var amp = 3 + t * 9;                             // ...and how much it moves
      var pts = [];
      for (var i = 0; i <= 24; i++) {
        var x = PAD + (i / 24) * plotW;
        /* Phase-shifted per signal so three lines at similar scores stay distinguishable. */
        var yy = y + Math.sin((i / 24) * Math.PI * 2.2 + idx * 1.9) * amp;
        pts.push(x.toFixed(1) + "," + Math.max(PAD, Math.min(H - PAD, yy)).toFixed(1));
      }
      return '<polyline class="vh-sig-w" points="' + pts.join(" ") + '" fill="none" stroke="' + sg.col +
             '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="animation-delay:' +
             (idx * 0.14) + 's"/>' +
             '<text x="' + (W - RIGHT + 6) + '" y="' + (y + 3.5).toFixed(1) + '" font-size="10" font-weight="700" fill="' +
             sg.col + '">' + Math.round(sg.v) + "</text>";
    }).join("");

    var legend = SIG.map(function (sg) {
      return '<span class="vh-ov-chip" style="color:' + sg.col + '" data-tip="' + esc(sg.label) +
             ' \u2014 ' + Math.round(sg.v) + ' out of 100, averaged across scored visits in this range">' +
             '<i class="vh-sig-dot" style="background:' + sg.col + '"></i> ' + sg.label + "</span>";
    }).join("");

    return ovCard(T("vi.h.emo_signals"), "bi-activity",
      '<svg class="vh-sig" viewBox="0 0 ' + W + " " + H + '" preserveAspectRatio="none" role="img" ' +
      'aria-label="Intent ' + Math.round(SIG[0].v) + ', attention ' + Math.round(SIG[1].v) +
      ', frustration ' + Math.round(SIG[2].v) + ' out of 100">' +
      '<line x1="' + PAD + '" x2="' + (W - RIGHT) + '" y1="' + (H - PAD) + '" y2="' + (H - PAD) +
      '" stroke="#E3E8EE" stroke-width="1"/>' + paths + "</svg>" +
      '<div class="vh-ov-chips">' + legend + "</div>" +
      '<div class="vh-ov-note">Higher line = stronger signal. Averaged over the range you selected.</div>', null);
  }

  function ovSignatures(d) {
    var ps = d.personas || [];
    if (!ps.length) return ovCard(T("vi.h.signatures"), "bi-fingerprint", '<div class="vh-ov-thin">'+T('vih.no_personas_scored_yet')+'</div>', null);
    var tot = ps.reduce(function (s, x) { return s + x.n; }, 0) || 1;
    var bars = ps.slice(0, 6).map(function (x) {
      var col = pcol(x.k), pct = Math.round(x.n / tot * 100);
      return '<div class="vh-ov-row" title="' + esc(phelp(x.k)) + '"><span class="vh-ov-rl"><i class="bi ' + picon(x.k) + '" style="color:' + col + '"></i> ' + esc(x.k) + '</span><span class="vh-ov-rb"><i style="width:' + pct + "%;background:" + col + '"></i></span><span class="vh-ov-rv">' + pct + "%</span></div>";
    }).join("");
    return ovCard(T("vi.h.signatures"), "bi-fingerprint", bars, null);
  }
  function ovMotivation() {
    var m = MAP[RANGE.from + "|" + RANGE.to];
    if (!m || !m.pages || !m.pages.length) return ovCard(T("vi.h.motivation"), "bi-signpost-split", '<div class="vh-ov-thin">Reading what people come for\u2026</div>', null);
    var paths = m.pages.map(function (p) { return { path: p.page, count: p.views }; });
    var r = decodeMotivation({ paths: paths, referrers: [] });
    if (!r.top) return ovCard(T("vi.h.motivation"), "bi-signpost-split", '<div class="vh-ov-thin">General browsing \u2014 no dominant motivation across the site.</div>', null);
    var total = 0; MOT.forEach(function (mm) { total += r.scores[mm[0]] || 0; }); total = total || 1;
    var mix = MOT.filter(function (mm) { return r.scores[mm[0]] > 0; }).sort(function (a, b) { return r.scores[b[0]] - r.scores[a[0]]; });
    var bar = mix.map(function (mm) { var pct = r.scores[mm[0]] / total * 100; return '<i style="width:' + pct.toFixed(1) + "%;background:" + mm[2] + '" title="' + esc(motName(mm[0]) + " (" + Math.round(pct) + "%)") + '"></i>'; }).join("");
    var legend = mix.slice(0, 4).map(function (mm) { return '<span class="vh-ov-chip" style="color:' + mm[2] + '"><i class="bi ' + mm[3] + '"></i> ' + esc(motName(mm[0])) + " " + Math.round(r.scores[mm[0]] / total * 100) + "%</span>"; }).join("");
    var m0 = motOf(r.top);
    return ovCard(T("vi.h.motivation"), "bi-signpost-split",
      '<div class="vh-ov-badge" style="color:' + m0[2] + ";border-color:" + m0[2] + "33;background:" + m0[2] + '14"><i class="bi ' + m0[3] + '"></i> Mostly ' + esc(m0[1].toLowerCase()) + "</div>" +
      '<div class="vh-ov-mixbar">' + bar + "</div><div class=\"vh-ov-chips\">" + legend + "</div>", null);
  }
  function ovDecisions(d) {
    var ends = d.ends || {}, tot = 0; Object.keys(ends).forEach(function (k) { tot += ends[k]; });
    if (!tot) return ovCard(T("vi.h.how_end"), "bi-flag", '<div class="vh-ov-thin">'+T('vih.not_enough_scored_sessions_to_read_outcomes_')+'</div>', null);
    var order = ["high-intent", "exploring", "low-intent", "exit-risk"];
    var bar = order.filter(function (k) { return ends[k]; }).map(function (k) { var m = END_MAP[k] || [k, "#8798B0"], pct = ends[k] / tot * 100; return '<i style="width:' + pct.toFixed(1) + "%;background:" + m[1] + '" title="' + esc(endName(k) + " (" + Math.round(pct) + "%)") + '"></i>'; }).join("");
    var legend = order.filter(function (k) { return ends[k]; }).sort(function (a, b) { return ends[b] - ends[a]; }).slice(0, 4).map(function (k) { var m = END_MAP[k] || [k, "#8798B0", "bi-dot"]; return '<span class="vh-ov-chip" style="color:' + m[1] + '"><i class="bi ' + m[2] + '"></i> ' + esc(endName(k)) + " " + Math.round(ends[k] / tot * 100) + "%</span>"; }).join("");
    return ovCard(T("vi.h.how_end"), "bi-flag",
      '<div class="vh-ov-mixbar">' + bar + '</div><div class="vh-ov-chips">' + legend + "</div>" +
      '<div class="vh-ov-note">The intent posture of each session\u2019s final page.</div>', null);
  }
  function ovMap() {
    var action = '<button class="vh-ov-goto" data-ov-goto="map" type="button">'+T('vih.open_the_map')+'<i class="bi bi-arrow-right"></i></button>';
    var m = MAP[RANGE.from + "|" + RANGE.to];
    if (!m || !m.pages || !m.pages.length) return ovCard(T("vi.h.beh_map"), "bi-grid-1x2", '<div class="vh-ov-thin">Mapping your pages\u2026</div>', action);
    var counts = {}; m.pages.forEach(function (p) { var k = classifyPage(p).primary; counts[k] = (counts[k] || 0) + 1; });
    var chips = Object.keys(BMAP).filter(function (k) { return counts[k]; }).sort(function (a, b) { return counts[b] - counts[a]; }).map(function (k) { var dd = BMAP[k]; return '<span class="vh-ov-chip" style="color:' + dd.color + '" title="' + esc(bmHelp(k)) + '"><i class="bi ' + dd.icon + '"></i> ' + esc(bmName(k)) + " " + counts[k] + "</span>"; }).join("");
    var probs = m.pages.filter(function (p) { var c = classifyPage(p).primary; return c === "confusing" || c === "dropoff" || c === "friction"; }).slice(0, 3);
    var list = probs.length ? probs.map(function (p) { var def = BMAP[classifyPage(p).primary]; return '<div class="vh-ov-row"><span class="vh-bm-badge" style="color:' + def.color + ";border-color:" + def.color + "33;background:" + def.color + '14"><i class="bi ' + def.icon + '"></i> ' + esc(bmName(classifyPage(p).primary)) + '</span><span class="vh-ov-rl2" title="' + esc(p.page) + '">' + esc(p.page) + "</span></div>"; }).join("") : '<div class="vh-ov-thin">'+T("vi.empty.no_problems")+'</div>';
    return ovCard(T("vi.h.beh_map"), "bi-grid-1x2", '<div class="vh-ov-chips">' + chips + '</div><div class="vh-ov-list">' + list + "</div>", action);
  }
  /* Journey stage distribution — the overview endpoint already returns d.journeys (persona's twin),
     it just was never drawn. Reuses the signatures row markup, so no new CSS. */
  function jinfo(k) {
    var s = STAGES.filter(function (x) { return x[0] === String(k || "").toLowerCase(); })[0];
    return s ? { label: s[1], icon: s[2], help: s[3] } : { label: k, icon: "bi-signpost", help: "" };
  }
  function ovJourneys(d) {
    var js = d.journeys || [];
    if (!js.length) return ovCard(T("vi.h.journey_stages"), "bi-signpost-2", '<div class="vh-ov-thin">No journey stages scored yet \u2014 they come from the tracker.</div>', null);
    var tot = js.reduce(function (s, x) { return s + x.n; }, 0) || 1;
    var bars = js.slice(0, 6).map(function (x) {
      var info = jinfo(x.k), col = segColor(x.k), pct = Math.round(x.n / tot * 100);
      return '<div class="vh-ov-row" title="' + esc(x.k + " \u2014 " + info.help) + '"><span class="vh-ov-rl"><i class="bi ' + info.icon + '" style="color:' + col + '"></i> ' + esc(info.label) +
        '</span><span class="vh-ov-rb"><i style="width:' + pct + "%;background:" + col + '"></i></span><span class="vh-ov-rv">' + pct + "%</span></div>";
    }).join("");
    return ovCard(T("vi.h.journey_stages"), "bi-signpost-2", bars, null);
  }

  /* Opportunity Map — the one card that says "do this next". Nothing new is measured: it ranks the
     signals already on this page (friction/confusing/drop-off pages from the behavioural map, cooling
     site intent, high exit-risk, low attention) by severity and deep-links each to the tool that acts
     on it. Empty when nothing stands out — an honest "you're fine", not a filler list. */
  function ovOpportunities(d) {
    function shorten(p) { p = String(p || "/"); return p.length > 34 ? p.slice(0, 32) + "\u2026" : p; }
    var m = MAP[RANGE.from + "|" + RANGE.to], ops = [];
    if (m && m.pages) m.pages.forEach(function (p) {
      var c = classifyPage(p).primary, def = BMAP[c];
      if (c === "friction")       ops.push({ sev: 3, icon: def.icon, color: def.color, text: "High friction on " + shorten(p.page), link: link("heatmaps", { page: p.page }), cta: "Heatmap" });
      else if (c === "confusing") ops.push({ sev: 2, icon: def.icon, color: def.color, text: "Confusing page: " + shorten(p.page), link: link("heatmaps", { page: p.page }), cta: "Heatmap" });
      else if (c === "dropoff")   ops.push({ sev: 2, icon: def.icon, color: def.color, text: "Drop-off at " + shorten(p.page), link: link("user-flow", {}), cta: "Flow" });
    });
    var trend = (d.trend || []).filter(function (x) { return x.n > 0; });
    if (trend.length >= 2) { var st = trajStats(trend.map(function (x) { return x.intent; })); if (st.slope < -1.2) ops.push({ sev: 3, icon: "bi-graph-down-arrow", color: "#E0533D", text: T("vi.op.cooling"), link: link("visitor-intelligence", { tab: "insights" }), cta: T("vi.op.why") }); }
    var ends = d.ends || {}, tot = 0; Object.keys(ends).forEach(function (k) { tot += ends[k]; });
    if (tot && ends["exit-risk"]) { var pct = Math.round(ends["exit-risk"] / tot * 100); if (pct >= 25) ops.push({ sev: 2, icon: "bi-box-arrow-right", color: "#E0533D", text: pct + "% of visits end at exit-risk", link: link("funnels", {}), cta: "Funnels" }); }
    if (d.attention != null && d.attention < 40) ops.push({ sev: 1, icon: "bi-eye-slash", color: "#B9770E", text: "Low attention site-wide (" + d.attention + "/100)", link: link("content-tracking", {}), cta: "Content" });
    if (!ops.length) return ovCard(T("vi.h.opportunities"), "bi-lightbulb", T("vi.op.none"), null);
    ops.sort(function (a, b) { return b.sev - a.sev; });
    var list = ops.slice(0, 5).map(function (o) {
      return '<a class="vh-ov-op" href="' + esc(o.link) + '"><span class="vh-ov-op-i" style="color:' + o.color + '"><i class="bi ' + o.icon + '"></i></span>' +
        '<span class="vh-ov-op-t">' + esc(o.text) + '</span><span class="vh-ov-op-c">' + o.cta + ' <i class="bi bi-arrow-right"></i></span></a>';
    }).join("");
    return ovCard(T("vi.h.opportunities"), "bi-lightbulb", '<div class="vh-ov-oplist">' + list + "</div>", null);
  }
  /* Funnel Health — the one cross-plugin card. Fetches the Funnels plugin's own list, then the top
     few funnels' models, and shows each funnel's conversion in the current range. Degrades honestly:
     a rejected fetch means Funnels isn't enabled for this site (it says so); no funnels means "none
     yet". Cached per range; re-draws the overview when it lands, same as the behaviour map. */
  var FUNH = {};
  function ovRedraw(key) { if (VIEW === "overview" && OV && OV._key === key) drawOverview(OV); }
  function loadFunnelHealth(key) {
    if (FUNH[key]) return;
    FUNH[key] = { loading: true };
    api("/plugin/funnels/list").then(function (r) {
      var fs = (r && r.funnels) || [];
      if (!fs.length) { FUNH[key] = { empty: true }; ovRedraw(key); return; }
      Promise.all(fs.slice(0, 3).map(function (f) {
        return api("/plugin/funnels/get?id=" + encodeURIComponent(f.id) + "&" + rng()).then(function (m) {
          if (!m || m.error || !m.stats) return null;
          return { id: f.id, name: (m.funnel && m.funnel.name) || f.name, conv: +(m.stats.overall_conv || 0), entry: m.entry || 0 };
        }).catch(function () { return null; });
      })).then(function (rows) {
        rows = rows.filter(Boolean).sort(function (a, b) { return b.conv - a.conv; });
        FUNH[key] = rows.length ? { funnels: rows, total: fs.length } : { empty: true };
        ovRedraw(key);
      });
    }).catch(function () { FUNH[key] = { disabled: true }; ovRedraw(key); });
  }
  function ovFunnelHealth() {
    var key = RANGE.from + "|" + RANGE.to, fh = FUNH[key];
    var open = '<a class="vh-ov-goto" href="' + esc(link("funnels", {})) + '">'+T('vih.open_funnels')+'<i class="bi bi-arrow-right"></i></a>';
    if (!fh || fh.loading) return ovCard(T("vi.h.funnel_health"), "bi-funnel", '<div class="vh-ov-thin">Checking your funnels\u2026</div>', null);
    if (fh.disabled)       return ovCard(T("vi.h.funnel_health"), "bi-funnel", '<div class="vh-ov-thin">'+T('vih.enable_the_funnels_plugin_to_see_conversion_')+'</div>', null);
    if (fh.empty)          return ovCard(T("vi.h.funnel_health"), "bi-funnel", '<div class="vh-ov-thin">No funnels defined yet \u2014 create one to track conversion.</div>', open);
    var rows = fh.funnels.map(function (f) {
      var conv = Math.round(f.conv * 10) / 10;
      return '<a class="vh-ov-fh" href="' + esc(link("funnels", { id: f.id })) + '" title="' + esc(f.name + " \u2014 " + nf(f.entry) + " entered, " + conv + "% converted") + '">' +
        '<span class="vh-ov-fh-n">' + esc(f.name) + "</span>" +
        '<span class="vh-ov-fh-b"><i style="width:' + Math.max(2, Math.min(100, conv)) + '%"></i></span>' +
        '<span class="vh-ov-fh-v">' + conv + "%</span></a>";
    }).join("");
    return ovCard(T("vi.h.funnel_health"), "bi-funnel", rows + (fh.total > fh.funnels.length ? '<div class="vh-ov-note">Top ' + fh.funnels.length + " of " + fh.total + " funnels.</div>" : ""), open);
  }

  /* Deep-Link Matrix — a fast launcher from the Hub to the tools people jump to most. Pure navigation
     (each tool owns its own range/filters), grouped visually rather than dumping all 50+. */
  function ovDeepLinks() {
    var tools = [
      ["heatmaps", "bi-fire", T('vih.heatmaps')], ["session-recordings", "bi-play-circle", T("vi.btn.recordings")],
      ["user-flow", "bi-diagram-3", T('vih.user_flow')], ["funnels", "bi-filter", T('vih.funnels')],
      ["geo", "bi-globe", "Geo"], ["provider", "bi-hdd-network", T('vih.providers')],
      ["search-engines", "bi-search", T('vih.search')], ["ai-crawlers", "bi-robot", T("vi.btn.ai_crawlers")],
      ["live-online", "bi-broadcast", T('vih.live')], ["marketing-campaigns", "bi-megaphone", T('vih.campaigns')],
      ["compare-mode", "bi-layers", T('vih.compare')], ["performanceaudit", "bi-speedometer2", T("vi.btn.performance")]
    ];
    var grid = tools.map(function (t) {
      return '<a class="vh-ov-dl" href="' + esc(link(t[0], {})) + '" title="Open ' + t[2] + '"><i class="bi ' + t[1] + '"></i><span>' + esc(t[2]) + "</span></a>";
    }).join("");
    return ovCard(T("vi.h.jump_tool"), "bi-grid-3x3-gap", '<div class="vh-ov-dlgrid">' + grid + "</div>", null);
  }
  function drawOverview(d) {
    var host = q("ov-grid"); if (!host) return;
    host.innerHTML = ovPulse(d) + ovTrajectory(d) + ovEmotion(d) + ovSignals(d) + ovSignatures(d) + ovJourneys(d) + ovMotivation() + ovDecisions(d) + ovFunnelHealth() + ovMap() + ovOpportunities(d) + ovDeepLinks();
    var mb = host.querySelector('[data-ov-goto="map"]');
    if (mb) mb.addEventListener("click", function () { setView("map"); });
  }
  function renderOverview() {
    var host = q("ov-grid"); if (!host) return;
    var mi = q("ov-info"); if (mi && !mi.innerHTML) mi.innerHTML = ovInfo();
    if (!(window.GS && GS.site)) { host.innerHTML = '<div class="vh-empty" style="padding:40px 0;grid-column:1/-1">Loading\u2026</div>'; return; }  // site not ready; loadAll re-calls us
    var key = RANGE.from + "|" + RANGE.to;
    if (OV && OV._key === key) {
      drawOverview(OV);
      // an empty overview may simply predate the behaviour landing (a session scores as it completes) —
      // refetch it once, silently, and swap in the real numbers if any have arrived. No blank, no loop.
      if (!OV.sessions && !OV._retried) {
        OV._retried = true;
        api("/plugin/visitor-intelligence/overview?" + rng()).then(function (r) {
          if (r && r.ok && r.sessions && VIEW === "overview") { r._key = key; OV = r; drawOverview(r); if (CP_OPEN) cpRender(); }
        }).catch(function () {});
      }
    }
    else {
      host.innerHTML = '<div class="vh-empty" style="padding:40px 0;grid-column:1/-1">Rolling up your site\u2026</div>';
      api("/plugin/visitor-intelligence/overview?" + rng()).then(function (r) {
        if (!r || !r.ok) { if (q("ov-grid")) q("ov-grid").innerHTML = '<div class="vh-empty" style="padding:40px 0;grid-column:1/-1">Couldn\u2019t load the overview.</div>'; return; }
        r._key = key; OV = r;
        if (VIEW === "overview") drawOverview(r);
        if (CP_OPEN && VIEW === "overview") cpRender();
      }).catch(function () { if (q("ov-grid")) q("ov-grid").innerHTML = '<div class="vh-empty" style="padding:40px 0;grid-column:1/-1">Couldn\u2019t load the overview.</div>'; });
    }
    if (!MAP[key]) {
      api("/plugin/visitor-intelligence/behaviormap?" + rng()).then(function (r) {
        if (r && r.ok) { MAP[key] = r; if (VIEW === "overview" && OV && OV._key === key) drawOverview(OV); }
      }).catch(function () {});
    }
    if (!FUNH[key]) loadFunnelHealth(key);
  }

  /* ================================================= AI Co-Pilot
     Rule-based and on-device \u2014 it reads whatever view you're on and explains it in plain language,
     reusing every engine model already here (trajectory, emotion, motivation, decisions, map, personas)
     and the existing rule-based /insights engine. Nothing leaves the server; no external LLM. Additive
     and heavily guarded so a missing cache can never throw. */
  var CP_OPEN = false, CP_INS = null, CP_INSKEY = "";
  function cpToggle() { if (CP_OPEN) cpClose(); else cpOpen(); }
  function cpOpen() { CP_OPEN = true; var el = q("copilot"); if (el) el.hidden = false; var b = q("cpBtn"); if (b) b.classList.add("on"); cpRender(); }
  function cpClose() { CP_OPEN = false; var el = q("copilot"); if (el) el.hidden = true; var b = q("cpBtn"); if (b) b.classList.remove("on"); }
  function cpBand(v) { try { return GAUGE.intent.band(v).toLowerCase(); } catch (e) { return ""; } }
  function cpCompose() {
    try {
      if (VIEW === "overview") return cpOverview();
      if (VIEW === "visitor") return cpVisitor();
      if (VIEW === "segment") return cpSegment();
      if (VIEW === "map") return cpMap();
      if (VIEW === "tree") return cpTree();
    } catch (e) { return { context: T('vih.this_view'), paragraphs: ["I couldn\u2019t read this view just now \u2014 try refreshing."], actions: [] }; }
    /* Name the view instead of telling someone to go somewhere else. */
    var VN = { radar: T('vih.live_radar'), tree: "Page tree" };
    return { context: VN[VIEW] || "This view",
      paragraphs: [VN[VIEW]
        ? "I can\u2019t summarise " + VN[VIEW].toLowerCase() + " yet \u2014 it updates live, so anything I wrote would be out of date before you read it. Overview, Visitor, Segment, Page tree and Map all have a read."
        : T('vih.open_the_overview_for_a_whole_site_read_or_p')],
      actions: [] };
  }
  /* Tree had no composer, so opening the Co-Pilot there fell through to the generic "open the
     Overview" line — advice to leave the page you are on. It reads the tree it is looking at. */
  function cpTree() {
    var out = { context: T('vih.page_tree'), paragraphs: [], observations: [], actions: [] };
    var pages = (TREE && TREE.pages) || [];
    if (!pages.length) { out.paragraphs.push(T('vih.the_tree_has_not_loaded_yet_u2014_give_it_a_')); return out; }

    var scored = pages.filter(function (p) { return p.attention_score != null; });
    var attn = scored.slice().sort(function (a2, b2) { return b2.attention_score - a2.attention_score; });
    var audited = pages.filter(function (p) { return p.design != null; });
    var sessions = pages.reduce(function (n, p) { return n + (+p.sessions || 0); }, 0);

    out.paragraphs.push(pages.length + " page" + (pages.length === 1 ? "" : "s") + " in this range, "
      + nf(sessions) + " session" + (sessions === 1 ? "" : "s") + " between them.");

    if (attn.length) {
      var worst = attn[0];
      out.observations.push(worst.path + " needs attention most (" + worst.attention_score
        + "/100) \u2014 " + worst.exit_rate + "% exit rate across " + nf(worst.sessions) + " sessions.");
      var bad = attn.filter(function (p) { return p.attention_score >= TREE_ATTN_MIN; });
      if (bad.length > 1) out.observations.push(bad.length + " pages score " + TREE_ATTN_MIN
        + " or above on attention needed. Fixing the top two is usually worth more than touching all of them.");
    }
    if (audited.length) {
      var mean = Math.round(audited.reduce(function (n, p) { return n + p.design; }, 0) / audited.length);
      var findings = audited.reduce(function (n, p) { return n + (+p.design_issues || 0); }, 0);
      out.observations.push(audited.length + " of " + pages.length + " pages audited, average design score "
        + mean + "/100, " + findings + " finding" + (findings === 1 ? "" : "s") + " between them.");
    } else {
      out.observations.push(T('vih.no_page_here_has_been_audited_yet_so_the_des'));
    }
    if (attn.length) out.actions.push({ label: T('vih.open_the_page_needing_attention_most'), href: null });
    return out;
  }

  function cpOverview() {
    var d = OV, out = { context: T('vih.site_overview'), paragraphs: [], actions: [] };
    if (!d) { out.paragraphs.push(T('vih.rolling_up_your_site_u2026_give_it_a_moment_')); return out; }
    var parts = [];
    if (d.sessions) {
      parts.push("Across " + nf(d.sessions) + " scored session" + (d.sessions === 1 ? "" : "s") + ", intent averages " + d.intent + " (" + cpBand(d.intent) + "), friction " + d.frustration + " and attention " + d.attention + ".");
      var e = reconEmo({ i: d.intent, f: d.frustration, a: d.attention }); var dom = emoDominant(e);
      parts.push(T("vi.climate.mostly", {mood: emoName(dom).toLowerCase()}));
      var trend = (d.trend || []).filter(function (x) { return x.n > 0; });
      if (trend.length >= 2) { var st = trajStats(trend.map(function (x) { return x.intent; })); parts.push(T(st.slope > 1.2 ? "vi.range.warming" : st.slope < -1.2 ? "vi.range.cooling" : "vi.range.holding")); }
      var ends = d.ends || {}, et = 0; Object.keys(ends).forEach(function (k) { et += ends[k]; });
      if (et) { var order = ["exit-risk", "high-intent", "exploring", "low-intent"]; var topk = order.filter(function (k) { return ends[k]; }).sort(function (a, b) { return ends[b] - ends[a]; })[0]; if (topk && END_MAP[topk]) parts.push(T("vi.end.most", {label: endName(topk).toLowerCase(), pct: Math.round(ends[topk] / et * 100)})); }
    } else parts.push(T('vih.no_scored_behaviour_in_this_range_yet_u2014_'));
    var m = MAP[RANGE.from + "|" + RANGE.to];
    if (m && m.pages && m.pages.length) {
      var r = decodeMotivation({ paths: m.pages.map(function (p) { return { path: p.page, count: p.views }; }), referrers: [] });
      if (r.top) parts.push("Most visitors come to " + motOf(r.top)[1].toLowerCase() + ".");
      var counts = {}; m.pages.forEach(function (p) { var c = classifyPage(p).primary; counts[c] = (counts[c] || 0) + 1; });
      var probs = m.pages.filter(function (p) { var c = classifyPage(p).primary; return c === "confusing" || c === "dropoff"; }).slice(0, 1);
      if ((counts.confusing || 0) + (counts.dropoff || 0) > 0) {
        parts.push((counts.confusing || 0) + " page" + ((counts.confusing || 0) === 1 ? "" : "s") + " look confusing and " + (counts.dropoff || 0) + " are drop-offs" + (probs.length ? ", starting with " + probs[0].page : "") + " \u2014 that\u2019s where intent exists but something breaks it.");
        out.actions.push({ label: T('vih.open_the_behavioural_map'), goto: "map" });
        if (probs.length) out.actions.push({ label: TR("js.heatmap_for") + probs[0].page, href: link("heatmaps", { page: probs[0].page, page_url: probs[0].page }) });
      }
    }
    if (d.sessions) {
      out.actions.push({ label: T('vih.break_it_down_by_audience'), goto: "segment" });
      out.actions.push({ label: T('vih.generate_a_full_ai_report'), href: link("visitor-intelligence", { tab: "report" }) });
    }
    out.paragraphs = parts; return out;
  }
  function cpVisitor() {
    var out = { context: "a visitor", paragraphs: [], actions: [] };
    if (!SEL) { out.paragraphs.push(T('vih.pick_a_visitor_from_the_stream_and_i_ll_read')); return out; }
    var b = BEH[SEL], pf = PROF[SEL] && PROF[SEL].profile;
    out.context = (pf && pf.short_id) ? (pf.short_id + "\u2026") : "this visitor";
    var parts = [];
    if (b && b.persona) parts.push("This looks like a " + b.persona.toLowerCase() + " \u2014 intent " + b.intent_score + ", friction " + b.frustration_score + ", attention " + b.attention_score + ".");
    var t = TRAJ[SEL];
    if (t && t.points && t.points.length >= 2) { var st = trajStats(t.points.map(function (x) { return x.score; })); parts.push("Their intent " + (st.slope > 1.2 ? "rose" : st.slope < -1.2 ? "fell" : "held steady") + " across the visit."); }
    var em = EMO[SEL];
    if (em && em.moments) { var seq = detectDecisions(em.moments.filter(function (mm) { return mm && mm.i != null; })); if (seq.length) parts.push("Decision path: " + seq.map(function (x) { return DEC[x.type] ? DEC[x.type].label : x.type; }).join(" \u2192 ") + "."); }
    var mo = MOTD[SEL];
    if (mo) { var rm = decodeMotivation(mo); if (rm.top) parts.push("They came to " + motOf(rm.top)[1].toLowerCase() + "."); }
    if (!parts.length) parts.push(T('vih.not_enough_scored_behaviour_for_this_visitor'));
    out.paragraphs = parts;
    out.actions.push({ label: T('vih.watch_a_recording'), href: link("session-recordings", { id: SEL, visitor_id: SEL }) });
    out.actions.push({ label: T('vih.open_the_full_profile'), href: link("visitor-intelligence", { id: SEL }) });
    return out;
  }
  function cpSegment() {
    var out = { context: "segments", paragraphs: [], actions: [] };
    if (!SSEL) { out.paragraphs.push(T('vih.pick_a_segment_and_i_ll_tell_you_what_this_a')); return out; }
    out.context = "the " + SSEL + " segment";
    var key = SDIM + "|" + SSEL, parts = [];
    var sig = SEGSIG[key]; if (sig && sig.signature) parts.push("This segment is mostly " + String(sig.signature).toLowerCase() + ".");
    var mot = SEGMOT[key]; if (mot) { var r = decodeMotivation(mot); if (r.top) parts.push("They mostly come to " + motOf(r.top)[1].toLowerCase() + "."); }
    var bm = SEGBM[key]; if (bm && bm.pages) { var counts = {}; bm.pages.forEach(function (p) { var c = classifyPage(p).primary; counts[c] = (counts[c] || 0) + 1; }); if ((counts.confusing || 0) + (counts.dropoff || 0) > 0) { parts.push((counts.confusing || 0) + " confusing and " + (counts.dropoff || 0) + " drop-off page" + (((counts.confusing || 0) + (counts.dropoff || 0)) === 1 ? "" : "s") + " for this audience specifically."); out.actions.push({ label: T('vih.see_these_pages_on_the_map'), goto: "map" }); } }
    if (!parts.length) parts.push(T('vih.open_this_segment_s_detail_to_load_its_behav'));
    out.paragraphs = parts; return out;
  }
  function cpMap() {
    var out = { context: "the behavioural map", paragraphs: [], actions: [] };
    var m = MAP[RANGE.from + "|" + RANGE.to];
    if (!m || !m.pages || !m.pages.length) { out.paragraphs.push(T('vih.mapping_your_pages_u2026_give_it_a_moment_th')); return out; }
    var counts = {}; m.pages.forEach(function (p) { var c = classifyPage(p).primary; counts[c] = (counts[c] || 0) + 1; });
    var parts = ["Across " + nf(m.pages.length) + " pages: " + Object.keys(BMAP).filter(function (k) { return counts[k]; }).map(function (k) { return counts[k] + " " + BMAP[k].label.toLowerCase(); }).join(", ") + "."];
    var probs = m.pages.filter(function (p) { var c = classifyPage(p).primary; return c === "confusing" || c === "dropoff"; }).slice(0, 3);
    if (probs.length) { parts.push("Fix these first: " + probs.map(function (p) { return p.page; }).join(", ") + "."); out.actions.push({ label: TR("js.heatmap_for") + probs[0].page, href: link("heatmaps", { page: probs[0].page, page_url: probs[0].page }) }); out.actions.push({ label: TR("js.how_people_reach") + probs[0].page, href: link("user-flow", { page: probs[0].page, page_url: probs[0].page }) }); }
    out.paragraphs = parts; return out;
  }
  function cpPaint(body, r) {
    if (!body) return;
    var html = (r.paragraphs || []).map(function (p) { return '<p class="vh-cp-p">' + esc(p) + "</p>"; }).join("");
    if (r.observations && r.observations.length) html += '<div class="vh-cp-sec">'+T('vih.what_stands_out')+'</div>' + r.observations.map(function (o) { return '<div class="vh-cp-obs"><i class="bi bi-lightbulb"></i><span>' + esc(o) + "</span></div>"; }).join("");
    if (r.actions && r.actions.length) html += '<div class="vh-cp-sec">'+T('vih.next_steps')+'</div>' + r.actions.map(function (a) { return a.href ? '<a class="vh-cp-act" href="' + esc(a.href) + '">' + esc(a.label) + ' <i class="bi bi-arrow-right"></i></a>' : '<button class="vh-cp-act" type="button" data-cp-goto="' + esc(a.goto || "") + '">' + esc(a.label) + ' <i class="bi bi-arrow-right"></i></button>'; }).join("");
    body.innerHTML = html || '<p class="vh-cp-p">'+T('vih.nothing_to_read_here_yet')+'</p>';
    body.querySelectorAll("[data-cp-goto]").forEach(function (bn) { bn.addEventListener("click", function () { var g = bn.getAttribute("data-cp-goto"); if (g) setView(g); }); });
  }
  function cpRender() {
    if (!CP_OPEN) return;
    var ctx = q("cp-ctx"), body = q("cp-body"); if (!body) return;
    var r = cpCompose();
    if (ctx) ctx.textContent = T('vih.reading') + r.context;
    cpPaint(body, r);
    if (VIEW === "overview" && window.GS && GS.site) {
      var key = RANGE.from + "|" + RANGE.to;
      if (CP_INS && CP_INSKEY === key) cpMerge(body, r, CP_INS);
      else api("/plugin/visitor-intelligence/insights?" + rng()).then(function (d) { if (d && d.ok) { CP_INS = d; CP_INSKEY = key; if (CP_OPEN && VIEW === "overview") cpMerge(body, r, d); } }).catch(function () {});
    }
  }
  function cpMerge(body, r, d) {
    var obs = (d.insights || []).concat(d.anomalies || []).concat(d.recommendations || []).map(function (x) { return x && x.text ? x.text : ""; }).filter(Boolean).slice(0, 6);
    cpPaint(body, { context: r.context, paragraphs: r.paragraphs, observations: (r.observations || []).concat(obs), actions: r.actions });
  }

  function renderTimeline(p, b, live) {
    var host = q("timeline"); if (!host) return;
    var sub = q("tl-sub");
    var evs = [];

    if (live) evs.push({ t: "Here now \u00b7 " + (live.path || "/"), m: "seen " + ago(live.ago) + " ago",
                         c: "#1FA463", i: "bi-broadcast", time: ago(live.ago) + " ago" });

    // the profile's own timeline: real pageviews and events, newest first
    var tl = (p && (p.timeline || p.events)) || [];
    if (Array.isArray(tl)) tl.slice(0, 14).forEach(function (e) {
      var isEv = e.name && e.name !== "pageview";
      evs.push({
        t: esc(e.path || e.name || "\u2014"),
        m: [e.source, e.referrer].filter(Boolean).join(" \u00b7 ") ||
           (e.scroll ? "read " + e.scroll + "%" : "") || (isEv ? "event" : "pageview"),
        c: isEv ? "#6C4BE8" : "#2A6FE8", i: isEv ? "bi-lightning-charge" : "bi-file-earmark",
        time: e.time || ""
      });
    });

    if (b) {
      if (b.dwell_ms != null) evs.push({ t: "Spent " + dwell(b.dwell_ms) + " on the page", m: "visible time, not tab-open time",
                                         c: "#29C5E8", i: "bi-hourglass", time: "" });
      if (b.scroll_pct != null) evs.push({ t: "Read " + b.scroll_pct + "% of the page", m: "scroll depth",
                                           c: "#1FA463", i: "bi-arrow-down", time: "" });
      if (b.clicks) evs.push({ t: nf(b.clicks) + " click" + (b.clicks === 1 ? "" : "s"), m: "during the session",
                               c: "#FFC83A", i: "bi-hand-index", time: "" });
      if (b.frustration_score >= 40) evs.push({ t: T('vih.friction_detected'), m: "frustration " + b.frustration_score + "/100",
                                                c: "#E0533D", i: "bi-exclamation-triangle", time: "" });
    }

    if (!evs.length) {
      host.innerHTML = '<div class="vh-none">'+T('vih.nothing_recorded_for_this_visitor_yet')+'</div>';
      if (sub) sub.textContent = "";
      return;
    }
    if (sub) sub.textContent = evs.length + " moment" + (evs.length === 1 ? "" : "s");
    host.innerHTML = evs.map(function (e) {
      return '<div class="vh-ev"><span class="vh-ev-dot" style="background:' + e.c + '"><i class="bi ' + e.i + '"></i></span>' +
        '<div class="vh-ev-b"><div class="vh-ev-t">' + e.t + '</div><div class="vh-ev-m">' + esc(e.m || "") + "</div></div>" +
        '<span class="vh-ev-time">' + esc(e.time || "") + "</span></div>";
    }).join("");
  }

  /* -------------------------------------------------------------- tabs */

  function renderTab() {
    var host = q("tabbody"); if (!host) return;
    var b = behOf(SEL), row = LIST.filter(function (v) { return v.id === SEL; })[0] || {};
    var none = '<div class="vh-none">No behaviour scored for this visitor yet. Scores come from the tracker \u2014 they appear once this visitor browses with it running.' + helpLink(T('vih.set_it_up_rarr')) + "</div>";

    if (TAB === "intent")
      host.innerHTML = b ? '<div><b>' + GAUGE.intent.band(b.intent_score) + "</b> \u00b7 " + b.intent_score + "/100</div>" +
        '<div class="vh-reasons">' + reason(T('vih.dwell'), dwell(b.dwell_ms)) + reason(T('vih.scroll'), b.scroll_pct != null ? b.scroll_pct + "%" : null) +
        reason(T('vih.clicks'), b.clicks != null ? nf(b.clicks) : null) + "</div>" : none;
    else if (TAB === "frustration")
      host.innerHTML = b ? '<div><b>' + GAUGE.frustration.band(b.frustration_score) + "</b> \u00b7 " + b.frustration_score + "/100</div>" +
        (b.frustration_score >= 40
          ? '<div class="vh-reasons">' + reason(T('vih.signals'), "rage/dead clicks or backtracking in this session") + "</div>"
          : '<div class="vh-reasons">' + reason(T('vih.signals'), "nothing notable \u2014 the session ran smoothly") + "</div>") : none;
    else if (TAB === "attention")
      host.innerHTML = b ? '<div><b>' + GAUGE.attention.band(b.attention_score) + "</b> \u00b7 " + b.attention_score + "/100</div>" +
        '<div class="vh-reasons">' + reason(T('vih.read'), b.scroll_pct != null ? b.scroll_pct + "% of the page" : null) +
        reason(T('vih.time'), dwell(b.dwell_ms)) + "</div>" : none;
    else if (TAB === "journey")
      host.innerHTML = b && b.journey ? "<div>Stage: <b>" + esc(b.journey) + "</b></div>" +
        (b.visitor_type ? '<div class="vh-reasons">' + reason(T('vih.type'), b.visitor_type) + "</div>" : "") : none;
    else
      host.innerHTML = b && b.summary
        ? "<div>" + esc(b.summary) + "</div>" +
          '<div class="vh-reasons">' + reason(T('vih.fingerprint'), b.fingerprint) + "</div>" +
          '<div style="margin-top:10px"><a class="vh-open" href="' + esc(link("visitor-intelligence", { tab: "report" })) +
          '">'+T('vih.full_ai_report')+'<i class="bi bi-arrow-up-right"></i></a></div>'
        : none;
  }
  function reason(k, v) { return v ? '<div class="vh-reason"><i class="bi bi-dot"></i><span><b>' + esc(k) + ":</b> " + esc(v) + "</span></div>" : ""; }

  /* ------------------------------------------------------- deep-link tiles */

  /* Every tile carries the visitor with it. A tile that would land on an unfiltered page is
     disabled rather than lying about what it will show. */
  function renderTiles(row, live, b, p) {
    var host = q("tiles"); if (!host) return;
    var id = row && row.id, page = (live && live.path) || (p && p.pages && p.pages[0] && p.pages[0].path) || "";
    var dev = row && row.device ? String(row.device).toLowerCase() : "", cc = (row && row.country) || "";
    /* Now that the receivers accept these, the tiles carry THIS visitor's real context: their sessions
       (recordings), their page + device (heatmap), their individual path (flow focus), their cohort
       (funnel by device/country), their country (geo). Honest labels — the funnel is the cohort, not
       the individual, because a funnel of one is not a funnel. */
    var cohort = {}; if (dev) cohort.device = dev; if (cc) cohort.country = cc;
    var cohortLbl = dev && cc ? dev + " \u00b7 " + cc : (dev || cc);
    var ROWS = [
      ["session-recordings", "bi-play-circle", T('vih.session_replay'), id ? "Replay this visitor\u2019s sessions" : T('vih.pick_a_visitor'), id ? { id: id } : null],
      ["heatmaps",           "bi-fire",        T('vih.heatmap'),        page ? (dev ? "See " + page + " on " + dev : "See " + page) : T('vih.no_current_page'),
                                                                 page ? (dev ? { page: page, device: dev } : { page: page }) : null],
      ["user-flow",          "bi-diagram-3",   T('vih.user_flow'),      id ? "This visitor\u2019s path through the site" : T('vih.how_visitors_move'), id ? { visitor: id } : {}],
      ["funnels",            "bi-filter",      T('vih.funnels'),        cohortLbl ? "The funnel for " + cohortLbl + " visitors" : T('vih.where_people_drop_out'), cohort],
      ["visitor-intelligence","bi-stars",      T('vih.ai_insights'),    T('vih.what_the_behaviour_means'), { tab: "insights" }],
      ["visitor-intelligence","bi-file-text",  T('vih.ai_report'),      T('vih.written_summary_for_this_range'), { tab: "report" }],
      ["geo",                "bi-globe",       "Geo",            cc ? "Others from " + cc : T('vih.where_they_are'), cc ? { country: cc } : {}],
      ["data-exporter",      "bi-database-down",T('vih.data_export'),   T('vih.raw_rows_for_this_range'), {}],
      ["pdf-exporter",       "bi-file-pdf",    T('vih.pdf_export'),     "A shareable summary", {}],
      ["public-seo-badge",   "bi-award",       T('vih.seo_badge'),      T('vih.public_proof_of_traffic'), {}]
    ];
    var mainHtml = ROWS.map(function (t) {
      var off = t[4] === null;
      var scoped = !off && t[4] && Object.keys(t[4]).filter(function (k) { return k !== "tab"; }).length > 0;
      return '<a class="vh-tile' + (off ? " off" : "") + (scoped ? " scoped" : "") + '" href="' + (off ? "#" : esc(link(t[0], t[4]))) +
        '" title="' + esc(t[3]) + '"><i class="bi ' + t[1] + '"></i>' +
        '<div><div class="vh-tile-t">' + t[2] + '</div><div class="vh-tile-d">' + esc(t[3]) + "</div></div></a>";
    }).join("");
    /* The six behavioural engines all resolve ?id= against VI's identity (COALESCE visitor_pid,
       visitor_hash) and load focused on that visitor — so from here we can open any of them on this
       exact person. Only shown when a visitor is selected. */
    var engHtml = "";
    if (id) {
      var ENG = [
        ["behavioral-forecasting", "bi-graph-up-arrow", T('vih.forecasting'),   T('vih.predict_what_this_visitor_does_next')],
        ["behavioral-memory",      "bi-clock-history",  T('vih.memory'),        T('vih.everything_we_ve_seen_this_visitor_do')],
        ["behavioral-fingerprint", "bi-fingerprint",    T('vih.fingerprint'),   T('vih.this_visitor_s_behavioural_signature')],
        ["conversion-doctor",      "bi-heart-pulse",    T('vih.conversion_dr'), T('vih.why_this_visitor_did_or_didn_t_convert')],
        ["ux-auditor",             "bi-bug",            T('vih.ux_auditor'),    T('vih.the_friction_this_visitor_hit')],
        ["journey-builder",        "bi-signpost-2",     T('vih.journey'),       T('vih.map_this_visitor_s_journey')]
      ];
      engHtml = '<div class="vh-eng-sec">AI engines \u2014 focused on this visitor</div><div class="vh-eng">' +
        ENG.map(function (e) {
          return '<a class="vh-eng-t" href="' + esc(link(e[0], { id: id })) + '" title="' + esc(e[3]) + '"><i class="bi ' + e[1] + '"></i><span>' + e[2] + "</span></a>";
        }).join("") + "</div>";
    }
    host.innerHTML = mainHtml + engHtml;
  }

  /* ---------------------------------------------------------- the stream */

  function cards() {
    var host = q("cards"); if (!host) return;
    var rows = LIST.slice();
    if (DEV) rows = rows.filter(function (v) { return (v.device || "").toLowerCase() === DEV; });
    if (TAG) rows = rows.filter(function (v) { var b = behOf(v.id); return b && b.persona === TAG; });
    if (BOTF === "humans") rows = rows.filter(function (v) { return !v.is_bot; });
    else if (BOTF === "bots") rows = rows.filter(function (v) { return v.is_bot; });

    // whoever is on the site right now goes first: this is a live stream, not a list
    var on = {};
    (LIVE.recent || []).forEach(function (r) { if (r.vid) on[r.vid] = r; });
    rows.sort(function (a, c) { return (on[c.id] ? 1 : 0) - (on[a.id] ? 1 : 0); });

    if (!rows.length) {
      var filtered = DEV || TAG || BOTF !== "all";
      host.innerHTML = '<div class="vh-empty">' + (filtered ? "Nobody matches that filter." : T('vih.no_visitors_in_this_range_yet')) + "</div>";
      return;
    }
    host.innerHTML = rows.slice(0, 40).map(function (v) {
      var b = behOf(v.id), l = on[v.id];
      var hot = b && b.intent_score >= 70, mad = b && b.frustration_score >= 60;
      var tip = [];
      if (b && b.summary) tip.push(b.summary);
      else tip.push(T('vih.no_behaviour_scored_yet_u2014_what_follows_i'));
      if (v.is_bot) tip.push((v.bot_name ? v.bot_name : T('vih.automated_traffic')) + " \u2014 not a person. Counted, not dropped.");
      if (v.first_source) tip.push("Arrived via " + v.first_source + ".");
      if (v.sessions > 1) tip.push("Visit " + v.sessions + " \u00b7 returns " + String(v.cadence || "").toLowerCase() + ".");
      if (l) tip.push("On " + (l.path || "/") + " right now.");
      tip.push(T('vih.click_to_read_the_whole_story'));
      return '<button class="vh-card' + (hot ? " hot" : "") + (mad ? " mad" : "") + (SEL === v.id ? " on" : "") +
        '" data-vid="' + esc(v.id) + '" title="' + esc(tip.join("\n")) + '">' +
        '<span class="vh-av" style="background:' + avatar(v.id) + '">' + esc(initials(v.short_id)) + "</span>" +
        '<span class="vh-c-main">' +
          '<span class="vh-c-top">' +
            (v.country ? '<span class="vh-flag">' + flag(v.country) + "</span>" : "") +
            '<span class="vh-c-id">' + esc(v.short_id) + "</span>" +
            botBadge(v) +
            (b && b.persona ? pchip(b.persona, {}) : "") +
          "</span>" +
          '<span class="vh-c-page">' + esc(l ? (l.path || "/") : (v.first_source || "\u2014")) + "</span>" +
          '<span class="vh-c-meta">' +
            "<span>" + esc(v.device || "?") + (v.browser ? " \u00b7 " + esc(v.browser) : "") + "</span>" +
            (l ? "<span>\u00b7 here " + ago(l.ago) + " ago</span>" : "<span>\u00b7 " + nf(v.pageviews) + " pages</span>") +
          "</span>" +
        "</span>" +
        (b ? '<span class="vh-c-scores">' +
          '<span class="vh-s" style="background:#2A6FE8" title="'+T('vih.intent')+'">' + b.intent_score + "</span>" +
          '<span class="vh-s" style="background:#E0533D" title="'+T('vih.frustration')+'">' + b.frustration_score + "</span>" +
          '<span class="vh-s" style="background:#6C4BE8" title="'+T('vih.attention')+'">' + b.attention_score + "</span></span>" : "") +
        "</button>";
    }).join("");
    qa(".vh-card").forEach(function (c) {
      c.addEventListener("click", function () { pickVisitor(c.getAttribute("data-vid")); });
    });
  }

  /* A tap ripple from the click point — the "ripple on tag clicks" B3 asks for. Appended to the tag,
     which now updates its selected state in place (below) rather than re-rendering, so the ripple
     survives long enough to play. Purely decorative; self-removes. */
  function rippleAt(el, e) {
    try {
      var r = el.getBoundingClientRect(), size = Math.max(r.width, r.height);
      var s = document.createElement("span");
      s.className = "vh-tag-rip";
      s.style.width = s.style.height = size + "px";
      s.style.left = ((e.clientX - r.left) - size / 2) + "px";
      s.style.top = ((e.clientY - r.top) - size / 2) + "px";
      el.appendChild(s);
      setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 520);
    } catch (x) {}
  }
  function tags() {
    var host = q("tags"); if (!host) return;
    var count = {};
    Object.keys(BEH).forEach(function (k) { var p = BEH[k].persona; if (p) count[p] = (count[p] || 0) + 1; });
    var ks = Object.keys(count).sort(function (a, b) { return count[b] - count[a]; });
    if (!ks.length) { host.innerHTML = ""; return; }
    host.innerHTML = ks.map(function (p) {
      return '<button class="vh-tag' + (TAG === p ? " on" : "") + '" data-tag="' + esc(p) + '" title="' + esc(pName(p) + " \u2014 " + phelp(p)) +
        '" style="--pc:' + pcol(p) + '"><i class="bi ' + picon(p) + '"></i> ' + esc(pName(p)) + "<b>" + count[p] + "</b></button>";
    }).join("");
    qa(".vh-tag").forEach(function (t) {
      t.addEventListener("click", function (e) {
        rippleAt(t, e);
        var p = t.getAttribute("data-tag"); TAG = (TAG === p) ? "" : p;
        qa(".vh-tag").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-tag") === TAG); });
        cards();
      });
    });
  }

  /* -------------------------------------------------------- today strip */

  function summary() {
    var host = q("summary"); if (!host) return;
    var count = {}, journeys = {}, friction = null, intent = null;
    Object.keys(BEH).forEach(function (k) {
      var b = BEH[k];
      if (b.persona) count[b.persona] = (count[b.persona] || 0) + 1;
      if (b.journey) journeys[b.journey] = (journeys[b.journey] || 0) + 1;
      if (b.frustration_score != null && (!friction || b.frustration_score > friction.frustration_score)) friction = b;
      if (b.intent_score != null && (!intent || b.intent_score > intent.intent_score)) intent = b;
    });
    var pk = Object.keys(count).sort(function (a, b) { return count[b] - count[a]; });
    var jk = Object.keys(journeys).sort(function (a, b) { return journeys[b] - journeys[a]; });

    var top = LIST.slice().sort(function (a, b) { return (b.pageviews || 0) - (a.pageviews || 0) })[0];
    var scored = Object.keys(BEH).length;

    function card(href, label, value, desc, extra) {
      return '<a class="vh-sum" href="' + esc(href) + '"><div class="vh-sum-l">' + label + "</div>" +
        '<div class="vh-sum-v">' + value + '</div><div class="vh-sum-d">' + esc(desc) + "</div>" + (extra || "") + "</a>";
    }
    host.innerHTML =
      card(link("visitor-intelligence", { tab: "behavior" }), T('vih.top_personas'),
           pk.length ? esc(pk[0]) : "\u2014",
           scored ? scored + " scored session" + (scored === 1 ? "" : "s") : "no behaviour data yet",
           pk.length ? '<div class="vh-sum-chips">' + pk.slice(0, 4).map(function (p) {
             return '<span class="vh-sum-chip" style="background:' + pcol(p) + '"><i class="bi ' + picon(p) + '"></i> ' + esc(p) + " " + count[p] + "</span>"; }).join("") + "</div>" : "") +
      card(link("visitor-intelligence", { tab: "journeys" }), T('vih.top_journey'),
           jk.length ? esc(jk[0]) : "\u2014",
           jk.length ? journeys[jk[0]] + " visitor" + (journeys[jk[0]] === 1 ? "" : "s") : "needs the tracker") +
      card(link("visitor-intelligence", { tab: "behavior" }), T('vih.most_friction'),
           friction ? friction.frustration_score + "/100" : "\u2014",
           friction ? "worst session in range" : "needs the tracker") +
      card(link("visitor-intelligence", { tab: "behavior" }), T('vih.highest_intent'),
           intent ? intent.intent_score + "/100" : "\u2014",
           intent ? "best session in range" : "needs the tracker") +
      card(link("visitor-intelligence", { tab: "visitors" }), T('vih.busiest_visitor'),
           top ? esc(top.short_id) + (top.is_bot ? " " + botBadge(top) : "") : "\u2014",
           top ? nf(top.pageviews) + " pages \u00b7 " + nf(top.sessions) + " visit" + (top.sessions === 1 ? "" : "s") +
                 (top.is_bot ? " \u00b7 automated" : "") : "no visitors yet");
  }

  /* --------------------------------------------------------------- load */

  function loadLive() {
    return api("/stats/realtime").then(function (d) {
      LIVE = d || {};
      var n = LIVE.online || 0;
      if (q("live-n")) q("live-n").textContent = nf(n);
      if (q("live-word")) q("live-word").textContent = n === 1 ? "person on the site" : "on the site";
      if (q("stream-sub")) q("stream-sub").textContent = n ? "right now" : "nobody right now";
      cards();
      if (SEL) renderStory();
      if (VIEW === "radar") renderRadar();
    }).catch(function () {});
  }

  function loadAll() {
    api("/plugin/visitor-intelligence/list?" + rng() + "&limit=60").then(function (d) {
      LIST = (d && d.visitors) || [];
      if (q("stream-sub") && MODE === "hist") q("stream-sub").textContent = nf((d && d.total) || LIST.length) + " in range";
      cards(); summary();
      if (SEL) renderStory();
      else gsDeep();
      if (VIEW === "segment") renderSeg();
      if (VIEW === "radar") renderRadar();
      if (VIEW === "overview") renderOverview();
    }).catch(function () {});

    api("/plugin/visitor-intelligence/bsessions?" + rng() + "&limit=200").then(function (d) {
      BEH = {}; SEGTRAJ = {}; SEGSIG = {}; SEGMOT = {}; SEGDEC = {}; SEGBM = {};
      ((d && d.sessions) || []).forEach(function (s) { if (s.vid && !BEH[s.vid]) BEH[s.vid] = s; });
      tags(); cards(); summary();
      if (SEL) renderStory();
      if (VIEW === "segment") renderSeg();
      if (VIEW === "radar") renderRadar();
    }).catch(function () {});

    loadLive();
  }

  /* /dashboard?view=radar opens straight into it, so a view is a link you can send someone. */
  function gsDeepView() {
    var v = null, hasId = false;
    if (window.GSLink) { v = GSLink.read({ view: "slug" }).view; hasId = !!GSLink.read({ id: "id64" }).id; }
    else { try { v = (String(new URLSearchParams(location.search).get("view") || "").toLowerCase().replace(/[^a-z]/g, "")) || null; hasId = !!new URLSearchParams(location.search).get("id"); } catch (e) {} }
    if (["segment", "radar", "map", "overview", "visitor"].indexOf(v) >= 0) setView(v);
    else if (!hasId) setView("overview");   // default landing; a ?id= link lets gsDeep open the visitor
  }

  function gsDeep() {
    var id = null;
    if (window.GSLink) id = GSLink.read({ id: "id64" }).id;
    else { try { id = (String(new URLSearchParams(location.search).get("id") || "").replace(/[^a-zA-Z0-9_-]/g, "")) || null; } catch (e) {} }
    if (id && LIST.some(function (v) { return v.id === id; })) { setView("visitor"); pickVisitor(id); }
  }


  /* ═══════════════════════════════════════════════════════ VIEW 2 — segments */

  /* Segments are computed from data already loaded — LIST (who) joined to BEH (how they behaved).
     Client-side, because a server round-trip per slice would be slower AND could disagree with the
     stream on screen. Every dimension answers the same question about a different axis: "what do
     these people have in common, and does it show in the behaviour?" */
  var DIMS = [
    ["device",  T('vih.device'),   function (v) { return v.device || null; }],
    ["country", T('vih.country'),  function (v) { return v.country || null; }],
    ["browser", T('vih.browser'),  function (v) { return v.browser || null; }],
    ["source",  T('vih.source'),   function (v) { return v.first_source || null; }],
    ["cadence", T('vih.return_rate'), function (v) { return v.cadence || null; }],
    ["persona", T('vih.persona'),  function (v) { var b = behOf(v.id); return b && b.persona; }],
    ["journey", T('vih.journey'),  function (v) { var b = behOf(v.id); return b && b.journey; }],
    ["intent",  T('vih.intent_level'), function (v) { var b = behOf(v.id); return b ? GAUGE.intent.band(b.intent_score) : null; }],
    ["frustration", T('vih.frustration_level'), function (v) { var b = behOf(v.id); return b ? GAUGE.frustration.band(b.frustration_score) : null; }],
    ["attention", T('vih.attention_level'), function (v) { var b = behOf(v.id); return b ? GAUGE.attention.band(b.attention_score) : null; }]
  ];
  function dimOf(k) { return DIMS.filter(function (d) { return d[0] === k; })[0] || DIMS[0]; }

  function segments() {
    var d = dimOf(SDIM), out = {};
    LIST.forEach(function (v) {
      var k = d[2](v);
      if (!k) return;                       // no value on this axis: not a segment, just unknown
      (out[k] = out[k] || []).push(v);
    });
    return out;
  }

  function segColor(k) {
    if (PERSONA[k]) return PERSONA[k][0];
    var pal = ["#1FA463", "#3E2DBA", "#2A6FE8", "#29C5E8", "#FFC83A", "#FF6B6B", "#6C4BE8", "#8C95A1"];
    return pal[hue(k) % pal.length];
  }

  function renderSegDims() {
    var host = q("segdim"); if (!host) return;
    host.innerHTML = DIMS.map(function (d) {
      var behavioural = ["persona", "journey", "intent", "frustration", "attention"].indexOf(d[0]) >= 0;
      return '<button class="mb' + (SDIM === d[0] ? " on" : "") + '" data-dim="' + d[0] + '" title="' +
        esc(behavioural ? "Needs the behaviour tracker \u2014 empty until vib events arrive."
                        : T('vih.from_the_visit_itself_available_today')) + '">' + d[1] + "</button>";
    }).join("");
    qa("[data-dim]").forEach(function (b) {
      b.addEventListener("click", function () { SDIM = b.getAttribute("data-dim"); SSEL = null; renderSeg(); if (CP_OPEN) cpRender(); });
    });
  }

  /* ---- Mini radar on segment hover: the segment's average intent / frustration / attention as a
     3-axis triangle, in a floating popover. Cheap — reuses avgOf over the rows already in hand. A
     segment with nothing scored yields no radar (rather than an empty one). ---- */
  var RADAR = {};
  function miniRadar(tri) {
    var cx = 62, cy = 58, R = 40;
    var axes = [[T('vih.intent'), tri.i, "#2A6FE8", -Math.PI / 2], [T('vih.frustration'), tri.f, "#E0533D", 5 * Math.PI / 6], [T('vih.attention'), tri.a, "#6C4BE8", Math.PI / 6]];
    function pt(v, th) { var r = (Math.max(0, Math.min(100, v || 0)) / 100) * R; return [cx + r * Math.cos(th), cy + r * Math.sin(th)]; }
    function outer(th, k) { return [cx + R * k * Math.cos(th), cy + R * k * Math.sin(th)]; }
    function poly(k, fill, stroke, w) { return '<polygon points="' + axes.map(function (a) { var p = outer(a[3], k); return p[0].toFixed(1) + "," + p[1].toFixed(1); }).join(" ") + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + w + '"/>'; }
    var spokes = axes.map(function (a) { var o = outer(a[3], 1); return '<line x1="' + cx + '" y1="' + cy + '" x2="' + o[0].toFixed(1) + '" y2="' + o[1].toFixed(1) + '" stroke="#E9EEF4" stroke-width="1"/>'; }).join("");
    var data = axes.map(function (a) { return pt(a[1], a[3]); });
    var dpoly = '<polygon points="' + data.map(function (p) { return p[0].toFixed(1) + "," + p[1].toFixed(1); }).join(" ") + '" fill="rgba(42,111,232,.14)" stroke="#2A6FE8" stroke-width="1.5"/>';
    var dots = axes.map(function (a, i) { return '<circle cx="' + data[i][0].toFixed(1) + '" cy="' + data[i][1].toFixed(1) + '" r="2.6" fill="' + a[2] + '"/>'; }).join("");
    var labels = axes.map(function (a) {
      var lx = cx + (R + 12) * Math.cos(a[3]), ly = cy + (R + 12) * Math.sin(a[3]);
      var anc = Math.abs(Math.cos(a[3])) < 0.3 ? "middle" : (Math.cos(a[3]) > 0 ? "start" : "end");
      return '<text x="' + lx.toFixed(1) + '" y="' + ly.toFixed(1) + '" font-size="8.5" font-weight="700" fill="' + a[2] + '" text-anchor="' + anc + '" dominant-baseline="middle">' +
        a[0][0] + " " + (a[1] == null ? "\u2014" : Math.round(a[1])) + "</text>";
    }).join("");
    return '<svg viewBox="0 0 124 116" width="124" height="116">' + spokes + poly(1, "none", "#E3E8EE", 1) + poly(0.5, "none", "#EEF2F7", 1) + dpoly + dots + labels + "</svg>";
  }
  function radarPop() {
    var el = document.getElementById("vh-seg-radar");
    if (!el) { el = document.createElement("div"); el.id = "vh-seg-radar"; el.className = "vh-seg-radar"; el.hidden = true; document.body.appendChild(el); }
    return el;
  }
  function showRadar(btn) {
    var k = btn.getAttribute("data-seg"), tri = RADAR[k];
    if (!tri || (tri.i == null && tri.f == null && tri.a == null)) return;   // nothing scored -> no radar
    var pop = radarPop();
    pop.innerHTML = '<div class="vh-seg-radar-t">' + esc(k) + "</div>" + miniRadar(tri);
    pop.hidden = false;
    var r = btn.getBoundingClientRect(), vw = document.documentElement.clientWidth;
    var left = r.right + 10; if (left + 140 > vw) left = r.left - 150;
    pop.style.top = Math.max(6, r.top - 6) + "px"; pop.style.left = Math.max(6, left) + "px";
  }
  function hideRadar() { var el = document.getElementById("vh-seg-radar"); if (el) el.hidden = true; }
  document.addEventListener("scroll", hideRadar, true);

  function renderSeg() {
    renderSegDims();
    var segs = segments(), keys = Object.keys(segs).sort(function (a, b) { return segs[b].length - segs[a].length; });
    var host = q("seg-list"), cnt = q("seg-count");
    if (cnt) cnt.textContent = keys.length ? keys.length + " segment" + (keys.length === 1 ? "" : "s") + " \u00b7 " + nf(LIST.length) + " visitors" : "";
    if (!host) return;

    if (!keys.length) {
      var behavioural = ["persona", "journey", "intent", "frustration", "attention"].indexOf(SDIM) >= 0;
      var label = dimOf(SDIM)[1].toLowerCase();
      var msg = behavioural
        ? "No behaviour scored in this range, so nobody can be grouped by " + label + " yet. Scores come from the tracker."
        : (SDIM === "source"
            ? "No arrival source on these visits \u2014 they came direct, or without a referrer."
            : "No " + label + " recorded for anyone in this range.");
      host.innerHTML = '<div class="vh-seg-empty"><i class="bi bi-bar-chart-line"></i>' +
        '<div class="vh-seg-empty-msg">' + esc(msg) + (behavioural ? helpLink(T('vih.how_to_turn_it_on_rarr')) : "") + "</div>" +
        ghostBars("") + "</div>";
      q("seg-detail").innerHTML = '<div class="vh-sd-empty">' + ghostBars(T('vih.pick_a_segment_on_the_left_to_see_its_breakd')) + "</div>";
      return;
    }
    var max = segs[keys[0]].length;
    host.innerHTML = keys.map(function (k) {
      var n = segs[k].length;
      return '<button class="vh-sg' + (SSEL === k ? " on" : "") + '" data-seg="' + esc(k) + '" title="' +
        esc(n + " visitor" + (n === 1 ? "" : "s") + " \u00b7 " + (n / LIST.length * 100).toFixed(1) + "% of the range") + '">' +
        '<span class="vh-sg-dot" style="background:' + segColor(k) + '"></span>' +
        '<span class="vh-sg-n">' + esc(k) + "</span>" +
        '<span class="vh-sg-b"><i style="width:' + (n / max * 100).toFixed(1) + '%;background:' + segColor(k) + '"></i></span>' +
        '<span class="vh-sg-c">' + nf(n) + "</span></button>";
    }).join("");
    hideRadar();
    RADAR = {};
    keys.forEach(function (k) { var rows = segs[k]; RADAR[k] = { i: avgOf(rows, "intent_score"), f: avgOf(rows, "frustration_score"), a: avgOf(rows, "attention_score") }; });
    qa("[data-seg]").forEach(function (b) {
      b.addEventListener("click", function () { SSEL = b.getAttribute("data-seg"); renderSeg(); if (CP_OPEN) cpRender(); });
      b.addEventListener("mouseenter", function () { showRadar(b); });
      b.addEventListener("mouseleave", hideRadar);
    });
    if (!SSEL) SSEL = keys[0];
    renderSegDetail(SSEL, segs[SSEL] || []);
  }

  /* A visually intentional empty state: faint placeholder bars + a one-line reason, so an empty slice
     reads as "measured, nothing here" rather than a broken panel or a wrong "needs the tracker". */
  function ghostBars(msg) {
    var w = [70, 46, 28];
    return '<div class="vh-ghost">' +
      w.map(function (p) { return '<span class="vh-ghost-b"><i style="width:' + p + '%"></i></span>'; }).join("") +
      (msg ? '<div class="vh-ghost-msg">' + esc(msg) + "</div>" : "") + "</div>";
  }
  function dist(rows, get, emptyMsg) {
    var c = {};
    rows.forEach(function (v) { var k = get(v); if (k) c[k] = (c[k] || 0) + 1; });
    var ks = Object.keys(c).sort(function (a, b) { return c[b] - c[a]; });
    if (!ks.length) return ghostBars(emptyMsg || "Nothing in this slice.");
    var max = c[ks[0]];
    return '<div class="vh-dist">' + ks.slice(0, 6).map(function (k) {
      return '<div class="vh-dist-row"><span class="vh-dist-k"><i style="background:' + segColor(k) + '"></i>' + esc(k) + "</span>" +
        '<span class="vh-dist-b"><i style="width:' + (c[k] / max * 100).toFixed(1) + '%;background:' + segColor(k) + '"></i></span>' +
        '<span class="vh-dist-v">' + nf(c[k]) + "</span></div>";
    }).join("") + "</div>";
  }

  function avgOf(rows, key) {
    var v = rows.map(function (r) { var b = behOf(r.id); return b ? b[key] : null; }).filter(function (x) { return x != null; });
    return v.length ? Math.round(v.reduce(function (a, b) { return a + b; }, 0) / v.length) : null;
  }

  /* ---- Segment intent trajectory: the AVERAGE shape of intent across a typical visit for the whole
     segment. The Hub sends the exact visitor ids it resolved to /segtrajectory (POST), the server
     lines each scored visit's per-page intent up by position and averages, and we read direction /
     net / consistency off that curve here — same engine as the single visitor, one level up. */
  function segTrajInfo() {
    return '<details class="vh-info"><summary title="'+T('vih.what_is_segment_intent_trajectory')+'"><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.segtraj_1") +
      T("vi.info.segtraj_2") +
      T("vi.info.segtraj_3") +
      "</div></details>";
  }
  function segTrajHtml(t, segSize) {
    var curve = (t && t.curve) || [];
    if (curve.length < 2) {
      return '<div class="vh-st-thin">' + (curve.length === 1
        ? "Only one intent reading across this segment\u2019s visits so far \u2014 a shape needs at least two."
        : T('vih.no_intent_readings_scored_for_this_segment_y')) + "</div>";
    }
    var s = trajStats(curve);
    var dir = s.slope > 1.2 ? "rising" : s.slope < -1.2 ? "falling" : "steady";
    var color = dir === "rising" ? "#1FA463" : dir === "falling" ? "#E0533D" : "#2A6FE8";
    var headline = dir === "rising" ? "warms up" : dir === "falling" ? "cools off" : "holds steady";
    var accelWord = s.accel > 1 ? (dir === "falling" ? ", faster near the end" : " and keeps building")
                  : s.accel < -1 ? (dir === "rising" ? ", then levels off" : ", then eases") : " through the visit";
    var volWord = s.vol < 6 ? "steady" : s.vol < 16 ? "variable" : "erratic";
    var netSign = s.net > 0 ? "+" : "";
    var sampledNote = (t.sampled && t.sampled >= 400 && segSize > 400) ? " (from a 400-visitor sample)" : "";
    return '<div class="vh-st-badge-row"><span class="vh-traj-badge" style="color:' + color + ';border-color:' + color + '33;background:' + color + '14">' +
        '<i class="bi ' + (dir === "rising" ? "bi-graph-up-arrow" : dir === "falling" ? "bi-graph-down-arrow" : "bi-dash-lg") + '"></i> A typical visit ' + esc(headline + accelWord) + "</span></div>" +
      '<div class="vh-st-graph">' + trajSvg(curve, s.rev, color, "#E3E8EE") +
        (s.rev.length ? '<span class="vh-st-rev" title="'+T('vih.points_where_the_average_intent_flipped_dire')+'">' + s.rev.length + " reversal" + (s.rev.length === 1 ? "" : "s") + "</span>" : "") + "</div>" +
      '<div class="vh-traj-metrics">' +
        '<div class="vh-st-m"><div class="vh-st-m-l">'+T('vih.direction')+'</div><div class="vh-st-m-v" style="color:' + color + '">' + esc(headline) + "</div></div>" +
        '<div class="vh-st-m"><div class="vh-st-m-l">'+T('vih.net_change')+'</div><div class="vh-st-m-v" style="color:' + (s.net > 0 ? "#1FA463" : s.net < 0 ? "#E0533D" : "#697586") + '">' + netSign + s.net + " pts</div></div>" +
        '<div class="vh-st-m"><div class="vh-st-m-l">'+T('vih.consistency')+'</div><div class="vh-st-m-v">' + volWord + "</div></div>" +
      "</div>" +
      '<div class="vh-st-note">Averaged across ' + nf(t.visits) + " scored visit" + (t.visits === 1 ? "" : "s") + " in this segment" + sampledNote + ".</div>";
  }
  function loadSegTraj(name, rows) {
    var host = q("seg-traj-body"); if (!host) return;
    var key = SDIM + "|" + name;
    if (SEGTRAJ[key]) { host.innerHTML = segTrajHtml(SEGTRAJ[key], rows.length); return; }
    host.innerHTML = '<div class="vh-st-thin">Reading the intent shape across this segment\u2026</div>';
    var ids = rows.map(function (r) { return r.id; });
    var fail = '<div class="vh-st-thin">Couldn\u2019t read the intent shape for this segment.</div>';
    apiPost("/plugin/visitor-intelligence/segtrajectory", { ids: ids }).then(function (t) {
      if (!t || !t.ok) { if (q("seg-traj-body")) q("seg-traj-body").innerHTML = fail; return; }
      SEGTRAJ[key] = t;
      if (SSEL === name && q("seg-traj-body")) q("seg-traj-body").innerHTML = segTrajHtml(t, rows.length);
    }).catch(function () { if (q("seg-traj-body")) q("seg-traj-body").innerHTML = fail; });
  }

  /* ---- Segment emotional profile: reconstruct each visitor's dominant emotion from their
     representative behaviour (BEH — the same scores the Avg-intent cards use), then show how the
     segment splits across the eight states. Client-side; no endpoint, same emotion model as the
     single visitor, one level up. */
  function segEmoInfo() {
    return '<details class="vh-info"><summary title="'+T('vih.what_is_the_segment_emotional_profile')+'"><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.segemo_1") +
      T("vi.info.segemo_2") +
      T("vi.info.segemo_3") +
      "</div></details>";
  }
  function segEmotion(rows) {
    var counts = {}, total = 0, valSum = 0;
    rows.forEach(function (r) {
      var b = behOf(r.id); if (!b) return;
      var e = reconEmo({ i: b.intent_score, f: b.frustration_score, a: b.attention_score });
      var dm = emoDominant(e);
      counts[dm] = (counts[dm] || 0) + 1; total++; valSum += emoValence(e);
    });
    return { counts: counts, total: total, valence: total ? Math.round(valSum / total) : 0 };
  }
  function segEmoHtml(rows) {
    var s = segEmotion(rows);
    if (!s.total) return '<div class="vh-st-thin">No behaviour scored for this segment yet \u2014 emotions come from the tracker.</div>';
    var keys = Object.keys(s.counts).sort(function (a, b) { return s.counts[b] - s.counts[a]; });
    var named = keys.filter(function (k) { return k !== "settled"; });
    var top = named.length ? named[0] : "settled", def = EMODEF[top];
    var headline = named.length ? "Mostly " + def.label.toLowerCase() : T('vih.calm_u2014_low_arousal_across_the_segment');
    var bar = keys.map(function (k) {
      var pct = s.counts[k] / s.total * 100;
      return '<i style="width:' + pct.toFixed(1) + "%;background:" + EMODEF[k].color + (k === "settled" ? ";opacity:.4" : "") +
        '" title="' + esc(EMODEF[k].label + " \u00b7 " + s.counts[k] + " (" + pct.toFixed(0) + "%)") + '"></i>';
    }).join("");
    var legend = keys.slice(0, 4).map(function (k) {
      return '<span class="vh-se-leg"><i style="background:' + EMODEF[k].color + (k === "settled" ? ";opacity:.4" : "") + '"></i>' +
        esc(EMODEF[k].label) + " <b>" + Math.round(s.counts[k] / s.total * 100) + "%</b></span>";
    }).join("");
    var vcol = s.valence > 8 ? "#1FA463" : s.valence < -8 ? "#E0533D" : "#697586";
    var vword = s.valence > 20 ? "felt good" : s.valence > 8 ? "leaned positive" : s.valence < -20 ? "felt rough" : s.valence < -8 ? "leaned negative" : "neutral";
    return '<div class="vh-se-badge-row"><span class="vh-traj-badge" style="color:' + def.color + ";border-color:" + def.color + "33;background:" + def.color + '14"><i class="bi ' + def.icon + '"></i> ' + esc(headline) + "</span>" +
        '<span class="vh-se-val" style="color:' + vcol + '" title="'+T('vih.average_emotional_valence_across_the_segment')+'">' + vword + "</span></div>" +
      '<div class="vh-se-bar">' + bar + "</div>" +
      '<div class="vh-se-legend">' + legend + "</div>" +
      '<div class="vh-st-note">From ' + nf(s.total) + " scored visitor" + (s.total === 1 ? "" : "s") + "\u2019 representative behaviour.</div>";
  }

  /* ---- Segment signature: the aggregate micro-behaviour fingerprint + dominant persona across the
     segment. Needs the per-page reasons the client doesn't hold, so it POSTs the segment's exact ids
     to /segsignature (same population as on screen). Reuses SIG_DIM so the bars match the visitor's. */
  function segSigInfo() {
    return '<details class="vh-info"><summary title="'+T('vih.what_is_the_segment_signature')+'"><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.segsig_1") +
      T("vi.info.segsig_2") +
      T("vi.info.segsig_3") +
      "</div></details>";
  }
  function segSigHtml(t, segSize) {
    var sig = t.signature, micro = t.micro || {};
    if (!sig || !t.pages) return '<div class="vh-st-thin">No micro-behaviour scored for this segment yet \u2014 the signature comes from the tracker.</div>';
    var col = pcol(sig), icon = picon(sig);
    var max = 0; SIG_DIM.forEach(function (x) { if ((micro[x[0]] || 0) > max) max = micro[x[0]]; });
    var bars = SIG_DIM.map(function (x) {
      var v = micro[x[0]] || 0, pct = max ? Math.round(v / max * 100) : 0;
      return '<div class="vh-ss-row" title="' + esc(x[3]) + '"><span class="vh-ss-l">' + x[1] + "</span>" +
        '<span class="vh-ss-b"><i style="width:' + pct + "%;background:" + x[2] + (v ? "" : ";opacity:.22") + '"></i></span></div>';
    }).join("");
    var ranked = SIG_DIM.filter(function (x) { return (micro[x[0]] || 0) > 0; }).sort(function (a, b) { return micro[b[0]] - micro[a[0]]; });
    var defline = ranked.length ? "Mostly " + ranked[0][1].toLowerCase() + (ranked[1] ? " and " + ranked[1][1].toLowerCase() : "") + "." : "A light footprint across this segment.";
    var sampledNote = (t.sampled && t.sampled >= 400 && segSize > 400) ? " (from a 400-visitor sample)" : "";
    return '<div class="vh-se-badge-row"><span class="vh-traj-badge" style="color:' + col + ";border-color:" + col + "33;background:" + col + '14" title="' + esc(phelp(sig)) + '"><i class="bi ' + icon + '"></i> ' + esc(sig) + "</span></div>" +
      '<div class="vh-ss-bars">' + bars + "</div>" +
      '<div class="vh-st-note">' + esc(defline) + " From " + nf(t.pages) + " scored page" + (t.pages === 1 ? "" : "s") + sampledNote + ".</div>";
  }
  function loadSegSig(name, rows) {
    var host = q("seg-sig-body"); if (!host) return;
    var key = SDIM + "|" + name;
    if (SEGSIG[key]) { host.innerHTML = segSigHtml(SEGSIG[key], rows.length); return; }
    host.innerHTML = '<div class="vh-st-thin">Reading the micro-behaviour signature across this segment\u2026</div>';
    var fail = '<div class="vh-st-thin">Couldn\u2019t read the signature for this segment.</div>';
    apiPost("/plugin/visitor-intelligence/segsignature", { ids: rows.map(function (r) { return r.id; }) }).then(function (t) {
      if (!t || !t.ok) { if (q("seg-sig-body")) q("seg-sig-body").innerHTML = fail; return; }
      SEGSIG[key] = t;
      if (SSEL === name && q("seg-sig-body")) q("seg-sig-body").innerHTML = segSigHtml(t, rows.length);
    }).catch(function () { if (q("seg-sig-body")) q("seg-sig-body").innerHTML = fail; });
  }

  /* ---- Segment motivation: run the same decodeMotivation over the segment's aggregate pages
     (POSTed via /segmotivation) and show the mix \u2014 what this audience collectively came for. */
  function segMotInfo() {
    return '<details class="vh-info"><summary title="'+T('vih.what_is_the_segment_motivation_mix')+'"><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.segmot_1") +
      T("vi.info.segmot_2") +
      T("vi.info.segmot_3") +
      "</div></details>";
  }
  function segMotHtml(t) {
    var r = decodeMotivation(t);
    if (!r.top) return '<div class="vh-st-thin">' + (t.paths && t.paths.length ? "The pages this segment viewed don\u2019t point to a clear motivation yet." : T('vih.no_pages_recorded_for_this_segment_yet')) + "</div>";
    var total = 0; MOT.forEach(function (m) { total += r.scores[m[0]] || 0; }); total = total || 1;
    var mix = MOT.filter(function (m) { return r.scores[m[0]] > 0; }).sort(function (a, b) { return r.scores[b[0]] - r.scores[a[0]]; });
    var bar = mix.map(function (m) { var pct = r.scores[m[0]] / total * 100; return '<i style="width:' + pct.toFixed(1) + "%;background:" + m[2] + '" title="' + esc(m[1] + " (" + Math.round(pct) + "%)") + '"></i>'; }).join("");
    var legend = mix.slice(0, 4).map(function (m) { return '<span class="vh-se-leg"><i style="background:' + m[2] + '"></i>' + esc(m[1]) + " <b>" + Math.round(r.scores[m[0]] / total * 100) + "%</b></span>"; }).join("");
    var m0 = motOf(r.top);
    var sampledNote = (t.sampled && t.sampled >= 400) ? " (from a 400-visitor sample)" : "";
    return '<div class="vh-se-badge-row"><span class="vh-traj-badge" style="color:' + m0[2] + ";border-color:" + m0[2] + "33;background:" + m0[2] + '14" title="' + esc(m0[4]) + '"><i class="bi ' + m0[3] + '"></i> Mostly ' + esc(m0[1].toLowerCase()) + "</span></div>" +
      '<div class="vh-se-bar">' + bar + "</div>" +
      '<div class="vh-se-legend">' + legend + "</div>" +
      '<div class="vh-st-note">Across ' + nf((t.paths || []).length) + " distinct page" + ((t.paths || []).length === 1 ? "" : "s") + " this segment viewed" + sampledNote + ".</div>";
  }
  function loadSegMot(name, rows) {
    var host = q("seg-mot-body"); if (!host) return;
    var key = SDIM + "|" + name;
    if (SEGMOT[key]) { host.innerHTML = segMotHtml(SEGMOT[key]); return; }
    host.innerHTML = '<div class="vh-st-thin">Reading what this segment came for\u2026</div>';
    var fail = '<div class="vh-st-thin">Couldn\u2019t read the motivation for this segment.</div>';
    apiPost("/plugin/visitor-intelligence/segmotivation", { ids: rows.map(function (r) { return r.id; }) }).then(function (t) {
      if (!t || !t.ok) { if (q("seg-mot-body")) q("seg-mot-body").innerHTML = fail; return; }
      SEGMOT[key] = t;
      if (SSEL === name && q("seg-mot-body")) q("seg-mot-body").innerHTML = segMotHtml(t);
    }).catch(function () { if (q("seg-mot-body")) q("seg-mot-body").innerHTML = fail; });
  }

  /* ---- Segment decisions: run the same detectDecisions over each visitor's moment sequence
     (POSTed via /segdecisions), take each visitor's outcome (their last decision), and show how the
     whole segment tends to resolve \u2014 buy, commit, hesitate, compare, leave, or steady browsing. */
  var DEC_ORDER = ["buy", "commit", "explore", "compare", "hesitate", "leave"];
  function segDecTally(t) {
    var vis = (t && t.visitors) || [], tally = { explore: 0, compare: 0, hesitate: 0, commit: 0, buy: 0, leave: 0, steady: 0 };
    vis.forEach(function (seq) {
      var moments = seq.map(function (m) { return { i: m.i, f: m.f, a: m.a, itype: m.it, ftype: m.ft, page: m.pg }; });
      var d = detectDecisions(moments);
      if (!d.length) { tally.steady++; return; }
      tally[d[d.length - 1].type]++;
    });
    return tally;
  }
  function segDecInfo() {
    return '<details class="vh-info"><summary title="'+T('vih.what_is_the_segment_decision_mix')+'"><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.segdec_1") +
      T("vi.info.segdec_2") +
      T("vi.info.segdec_3") +
      "</div></details>";
  }
  function segDecHtml(t) {
    var tally = segDecTally(t), total = 0;
    DEC_ORDER.concat(["steady"]).forEach(function (k) { total += tally[k]; });
    if (!total) return '<div class="vh-st-thin">' + ((t.visitors && t.visitors.length) ? "Not enough scored pages to read decisions for this segment yet." : T('vih.no_visitors_with_a_decision_path_yet_u2014_t')) + "</div>";
    var bar = DEC_ORDER.concat(["steady"]).filter(function (k) { return tally[k]; }).map(function (k) {
      var col = k === "steady" ? "#8798B0" : DEC[k].color, lbl = k === "steady" ? "Steady" : DEC[k].label, pct = tally[k] / total * 100;
      return '<i style="width:' + pct.toFixed(1) + "%;background:" + col + '" title="' + esc(lbl + " (" + Math.round(pct) + "%)") + '"></i>';
    }).join("");
    var legend = DEC_ORDER.concat(["steady"]).filter(function (k) { return tally[k]; }).sort(function (a, b) { return tally[b] - tally[a]; }).slice(0, 4).map(function (k) {
      var col = k === "steady" ? "#8798B0" : DEC[k].color, lbl = k === "steady" ? "Steady" : DEC[k].label;
      return '<span class="vh-se-leg"><i style="background:' + col + '"></i>' + esc(lbl) + " <b>" + Math.round(tally[k] / total * 100) + "%</b></span>";
    }).join("");
    var topK = DEC_ORDER.concat(["steady"]).sort(function (a, b) { return tally[b] - tally[a]; })[0];
    var badge = topK === "steady"
      ? '<span class="vh-traj-badge" style="color:#8798B0;border-color:#8798B033;background:#8798B014"><i class="bi bi-dash-circle"></i> Mostly steady browsing</span>'
      : '<span class="vh-traj-badge" style="color:' + DEC[topK].color + ";border-color:" + DEC[topK].color + "33;background:" + DEC[topK].color + '14"><i class="bi ' + DEC[topK].icon + '"></i> Most ' + (topK === "leave" ? "end up leaving" : topK === "buy" ? "reach a buying moment" : topK === "commit" ? "commit" : topK === "hesitate" ? "hesitate" : topK === "compare" ? "compare" : "explore") + "</span>";
    return '<div class="vh-se-badge-row">' + badge + "</div>" +
      '<div class="vh-se-bar">' + bar + "</div>" +
      '<div class="vh-se-legend">' + legend + "</div>" +
      '<div class="vh-st-note">Outcome for ' + nf(total) + " visitor" + (total === 1 ? "" : "s") + " with a decision path" + ((t.sampled && t.sampled >= 400) ? " (from a 400-visitor sample)" : "") + ".</div>";
  }
  function loadSegDec(name, rows) {
    var host = q("seg-dec-body"); if (!host) return;
    var key = SDIM + "|" + name;
    if (SEGDEC[key]) { host.innerHTML = segDecHtml(SEGDEC[key]); return; }
    host.innerHTML = '<div class="vh-st-thin">Reading how this segment decides\u2026</div>';
    var fail = '<div class="vh-st-thin">Couldn\u2019t read decisions for this segment.</div>';
    apiPost("/plugin/visitor-intelligence/segdecisions", { ids: rows.map(function (r) { return r.id; }) }).then(function (t) {
      if (!t || !t.ok) { if (q("seg-dec-body")) q("seg-dec-body").innerHTML = fail; return; }
      SEGDEC[key] = t;
      if (SSEL === name && q("seg-dec-body")) q("seg-dec-body").innerHTML = segDecHtml(t);
    }).catch(function () { if (q("seg-dec-body")) q("seg-dec-body").innerHTML = fail; });
  }

  /* ---- Segment behavioural map: the same page-level classifier as the Map view, scoped to this
     segment's visitors (POST /segbehaviormap). Which pages are hot / confusing / drop-off for THEM. */
  function segBmInfo() {
    return '<details class="vh-info"><summary title="'+T('vih.what_is_the_segment_behavioural_map')+'"><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.segbm_1") +
      T("vi.info.segbm_2") +
      T("vi.info.segbm_3") +
      "</div></details>";
  }
  function segBmHtml(t) {
    var pages = (t && t.pages) || [];
    if (!pages.length) return '<div class="vh-st-thin">No scored pages for this segment yet \u2014 the map fills as the tracker scores their visits.</div>';
    var counts = {}; pages.forEach(function (p) { var k = classifyPage(p).primary; counts[k] = (counts[k] || 0) + 1; });
    var chips = Object.keys(BMAP).filter(function (k) { return counts[k]; }).sort(function (a, b) { return counts[b] - counts[a]; }).map(function (k) {
      var d = BMAP[k];
      return '<span class="vh-sbm-chip" style="color:' + d.color + ";border-color:" + d.color + "33;background:" + d.color + '12" title="' + esc(bmHelp(k)) + '"><i class="bi ' + d.icon + '"></i> ' + esc(bmName(k)) + " <b>" + counts[k] + "</b></span>";
    }).join("");
    var top = pages.slice(0, 6).map(function (p) {
      var c = classifyPage(p), def = BMAP[c.primary];
      return '<div class="vh-sbm-row">' +
        '<span class="vh-bm-badge" style="color:' + def.color + ";border-color:" + def.color + "33;background:" + def.color + '14" title="' + esc(bmHelp(c.primary)) + '"><i class="bi ' + def.icon + '"></i> ' + esc(bmName(c.primary)) + "</span>" +
        '<span class="vh-sbm-p" title="' + esc(p.page) + '">' + esc(p.page) + "</span>" +
        '<span class="vh-sbm-v">' + nf(p.views) + "</span></div>";
    }).join("");
    return '<div class="vh-sbm-chips">' + chips + "</div>" +
      '<div class="vh-sbm-scatter">' + mapScatter(pages) + "</div>" +
      '<div class="vh-sbm-list">' + top + "</div>" +
      '<div class="vh-st-note">' + nf(pages.length) + " page" + (pages.length === 1 ? "" : "s") + " this segment engaged with" + ((t.sampled && t.sampled >= 400) ? " (from a 400-visitor sample)" : "") + ".</div>";
  }
  function loadSegBm(name, rows) {
    var host = q("seg-bm-body"); if (!host) return;
    var key = SDIM + "|" + name;
    if (SEGBM[key]) { host.innerHTML = segBmHtml(SEGBM[key]); return; }
    host.innerHTML = '<div class="vh-st-thin">Mapping this segment\u2019s pages\u2026</div>';
    var fail = '<div class="vh-st-thin">Couldn\u2019t map this segment\u2019s pages.</div>';
    apiPost("/plugin/visitor-intelligence/segbehaviormap", { ids: rows.map(function (r) { return r.id; }) }).then(function (t) {
      if (!t || !t.ok) { if (q("seg-bm-body")) q("seg-bm-body").innerHTML = fail; return; }
      SEGBM[key] = t;
      if (SSEL === name && q("seg-bm-body")) q("seg-bm-body").innerHTML = segBmHtml(t);
    }).catch(function () { if (q("seg-bm-body")) q("seg-bm-body").innerHTML = fail; });
  }

  /* ---- Segment AI Insights: an always-visible, plain-language read of the selected segment —
     intent/friction/attention, the dominant persona + journey, a prediction and next steps. Same
     rule-based engine as the Segment Co-Pilot, but rendered inline in the "Emotional Climate" card
     style rather than tucked in the Co-Pilot drawer. Computed from this segment's own scored rows. */
  function segTopKey(rows, get) {
    var c = {}, n = 0;
    rows.forEach(function (v) { var k = get(v); if (k) { c[k] = (c[k] || 0) + 1; n++; } });
    var ks = Object.keys(c).sort(function (a, b) { return c[b] - c[a]; });
    return ks.length ? { key: ks[0], pct: Math.round(c[ks[0]] / Math.max(1, n) * 100) } : null;
  }
  function segInsightsInfo() {
    return '<details class="vh-info"><summary title="'+T('vih.what_is_this')+'"><i class="bi bi-info-circle"></i></summary><div class="vh-info-body">' +
      T("vi.info.seginsights_1") +
      T("vi.info.seginsights_2") +
      "</div></details>";
  }
  function segInsightsHtml(name, rows) {
    var scored = rows.filter(function (r) { return behOf(r.id); }).length;
    if (!scored) return ghostBars(T('vih.no_behaviour_scored_for_this_segment_yet_u20'));
    var ai = avgOf(rows, "intent_score"), af = avgOf(rows, "frustration_score"), aa = avgOf(rows, "attention_score");
    var persona = segTopKey(rows, function (v) { var b = behOf(v.id); return b && b.persona; });
    var journey = segTopKey(rows, function (v) { var b = behOf(v.id); return b && b.journey; });
    var para = [], reco = [], pred = "", predClass = "warm", bits = [];
    if (ai != null) bits.push("<b>" + esc(GAUGE.intent.band(ai).toLowerCase()) + "</b> " + T("vi.si.on_intent"));
    if (af != null) bits.push("<b>" + esc(GAUGE.frustration.band(af).toLowerCase()) + "</b> " + T("vi.si.on_friction"));
    if (aa != null) bits.push("<b>" + esc(GAUGE.attention.band(aa).toLowerCase()) + "</b> " + T("vi.si.on_attention"));
    if (bits.length) para.push(T("vi.si.reads", {bits: bits.join(", ").replace(/,([^,]*)$/, " " + T("vi.si.and") + "$1")}));
    if (persona) para.push(T("vi.si.mostly", {persona: esc(pName(persona.key).toLowerCase()), pct: persona.pct}) +
      (journey ? T("vi.si.in_stage", {stage: esc(jName(journey.key).toLowerCase())}) : "."));
    if (ai != null) {
      if (ai >= 70 && journey && /commit|comparison/i.test(journey.key)) { pred = T("vi.si.pred_close"); predClass = "hot"; }
      else if (ai >= 40) { pred = T("vi.si.pred_eval"); predClass = "warm"; }
      else { pred = T("vi.si.pred_early"); predClass = "cool"; }
    }
    if (af != null && af >= 70) reco.push(T("vi.si.reco_friction"));
    if (aa != null && aa < 40) reco.push(T("vi.si.reco_attention"));
    if (ai != null && ai >= 70) reco.push(T("vi.si.reco_intent"));
    if (!reco.length) reco.push(T("vi.si.reco_none"));
    return '<div class="vh-si">' +
      para.map(function (p) { return '<p class="vh-si-p">' + p + "</p>"; }).join("") +
      (pred ? '<div class="vh-si-pred ' + predClass + '"><i class="bi bi-graph-up-arrow"></i><span>' + esc(pred) + "</span></div>" : "") +
      '<div class="vh-si-sec">'+T('vih.recommended')+'</div>' +
      reco.map(function (r) { return '<div class="vh-si-reco"><i class="bi bi-lightbulb"></i><span>' + esc(r) + "</span></div>"; }).join("") +
      "</div>";
  }

  function renderSegDetail(name, rows) {
    var host = q("seg-detail"); if (!host) return;
    var scored = rows.filter(function (r) { return behOf(r.id); });
    var pv = rows.reduce(function (a, r) { return a + (r.pageviews || 0); }, 0);
    var ses = rows.reduce(function (a, r) { return a + (r.sessions || 0); }, 0);
    var ret = rows.filter(function (r) { return r.returning; }).length;
    var ai = avgOf(rows, "intent_score"), af = avgOf(rows, "frustration_score"), aa = avgOf(rows, "attention_score");

    function card(l, v, d, tip) {
      return '<div class="vh-sd-card" title="' + esc(tip || "") + '"><div class="vh-sd-l">' + l + "</div>" +
        '<div class="vh-sd-v">' + v + '</div><div class="vh-sd-d">' + esc(d) + "</div></div>";
    }
    /* One country in the list, and the tiles carry it. A segment you cannot act on is a chart. */
    /* Tiles carry the segment as a REAL filter wherever the receiver already accepts one: Heatmaps
       reads ?device=, Compare Mode reads ?device=/?country=, Geo reads country. Other tiles stay
       range-only until their receiver learns to filter — an honest tile beats a dead one. */
    var segDev = SDIM === "device" ? { device: String(name).toLowerCase() } : {};
    var segCmp = SDIM === "device" ? { device: String(name).toLowerCase() } : SDIM === "country" ? { country: name } : {};
    var ctx    = SDIM === "country" ? { country: name } : {};
    var ENGDIM = { device: 1, country: 1, persona: 1, journey: 1 };
    var segEng = ENGDIM[SDIM] ? (function () { var o = {}; o[SDIM] = (SDIM === "country") ? name : (SDIM === "device" || SDIM === "journey") ? String(name).toLowerCase() : name; return o; })() : {};
    function tileFiltered(p) { return p && Object.keys(p).filter(function (k) { return k !== "tab"; }).length > 0; }
    function tileTitle(label, p) { return tileFiltered(p) ? "Open " + label + " filtered to \u201c" + name + "\u201d" : "Open " + label + " for this range"; }

    host.innerHTML =
      '<div class="vh-sd-head"><span class="vh-sd-dot" style="display:inline-block;width:11px;height:11px;border-radius:3px;background:' +
        segColor(name) + '"></span><span class="vh-sd-t">' + esc(name) + '</span>' +
        '<span class="vh-sd-c">' + nf(rows.length) + " visitor" + (rows.length === 1 ? "" : "s") + " \u00b7 " +
        (rows.length / Math.max(1, LIST.length) * 100).toFixed(1) + "% of the range</span></div>" +

      '<div class="vh-sd-cards">' +
        card(T('vih.visitors'), nf(rows.length), nf(ret) + " returning", T('vih.unique_visitors_in_this_segment')) +
        card(T('vih.pageviews'), nf(pv), (rows.length ? (pv / rows.length).toFixed(1) : "0") + " per visitor",
             T('vih.total_pages_read_by_this_segment')) +
        card(T('vih.sessions'), nf(ses), (rows.length ? (ses / rows.length).toFixed(1) : "0") + " per visitor",
             "A visit ends after 30 minutes of inactivity.") +
        card(T('vih.avg_intent'), ai == null ? "\u2014" : ai, ai == null ? "needs the tracker" : GAUGE.intent.band(ai),
             GAUGE.intent.help) +
        card(T('vih.avg_frustration'), af == null ? "\u2014" : af, af == null ? "needs the tracker" : GAUGE.frustration.band(af),
             GAUGE.frustration.help) +
        card(T('vih.avg_attention'), aa == null ? "\u2014" : aa, aa == null ? "needs the tracker" : GAUGE.attention.band(aa),
             GAUGE.attention.help) +
      "</div>" +

      '<div class="vh-sd-panel vh-si-panel"><div class="vh-sd-pt"><i class="bi bi-stars vh-si-star"></i> Segment AI insights' + segInsightsInfo() + "</div>" +
        segInsightsHtml(name, rows) + "</div>" +

      '<div class="vh-sd-row">' +
        '<div class="vh-sd-panel"><div class="vh-sd-pt">'+T('vih.personas_in_this_segment')+'</div>' +
          dist(rows, function (v) { var b = behOf(v.id); return b && b.persona; }, T('vih.no_behaviour_scored_for_this_segment_yet_u20')) + "</div>" +
        '<div class="vh-sd-panel"><div class="vh-sd-pt">'+T('vih.journey_stages')+'</div>' +
          dist(rows, function (v) { var b = behOf(v.id); return b && b.journey; }, T('vih.no_journey_stages_scored_for_this_segment_ye')) + "</div>" +
      "</div>" +
      '<div class="vh-sd-row" style="margin-top:11px">' +
        '<div class="vh-sd-panel"><div class="vh-sd-pt">'+T('vih.how_they_arrived')+'</div>' +
          dist(rows, function (v) { return v.first_source; }, T('vih.all_arrived_direct_u2014_no_referrer_on_thes')) + "</div>" +
        '<div class="vh-sd-panel"><div class="vh-sd-pt">'+T('vih.devices')+'</div>' +
          dist(rows, function (v) { return v.device; }, T('vih.no_device_recorded_for_this_segment')) + "</div>" +
      "</div>" +

      '<div class="vh-sd-panel vh-st-panel" style="margin-top:11px"><div class="vh-sd-pt">Segment intent trajectory' + segTrajInfo() + "</div>" +
        '<div class="vh-st-body" data-h="seg-traj-body"></div></div>' +

      '<div class="vh-sd-panel vh-st-panel" style="margin-top:11px"><div class="vh-sd-pt">Segment emotional profile' + segEmoInfo() + "</div>" +
        segEmoHtml(rows) + "</div>" +

      '<div class="vh-sd-panel vh-st-panel" style="margin-top:11px"><div class="vh-sd-pt">Segment signature' + segSigInfo() + "</div>" +
        '<div class="vh-st-body" data-h="seg-sig-body"></div></div>' +

      '<div class="vh-sd-panel vh-st-panel" style="margin-top:11px"><div class="vh-sd-pt">Segment motivation' + segMotInfo() + "</div>" +
        '<div class="vh-st-body" data-h="seg-mot-body"></div></div>' +

      '<div class="vh-sd-panel vh-st-panel" style="margin-top:11px"><div class="vh-sd-pt">Segment decisions' + segDecInfo() + "</div>" +
        '<div class="vh-st-body" data-h="seg-dec-body"></div></div>' +

      '<div class="vh-sd-panel vh-st-panel" style="margin-top:11px"><div class="vh-sd-pt">Segment behavioural map' + segBmInfo() + "</div>" +
        '<div class="vh-st-body" data-h="seg-bm-body"></div></div>' +

      '<div class="vh-sd-tiles">' + [
        ["user-flow", "bi-diagram-3", T('vih.flow'), segCmp],
        ["funnels", "bi-filter", T('vih.funnels'), segCmp],
        ["heatmaps", "bi-fire", T('vih.heatmaps'), segDev],
        ["visitor-intelligence", "bi-stars", T('vih.ai_insights'), { tab: "insights" }],
        ["compare-mode", "bi-layers", T('vih.compare'), segCmp],
        ["geo", "bi-globe", "Geo", ctx],
        ["behavioral-forecasting", "bi-graph-up-arrow", T('vih.forecast'), segEng],
        ["behavioral-memory", "bi-clock-history", T('vih.memory'), segEng]
      ].map(function (t) {
        return '<a class="vh-sd-tile' + (tileFiltered(t[3]) ? " on" : "") + '" href="' + esc(link(t[0], t[3])) + '" title="' + esc(tileTitle(t[2], t[3])) + '">' +
          '<i class="bi ' + t[1] + '"></i>' + t[2] + "</a>";
      }).join("") + "</div>" +

      '<div style="margin-top:12px"><button class="vh-sd-tile" data-h="seg-stream" style="cursor:pointer">' +
        '<i class="bi bi-people"></i>Show these ' + nf(rows.length) + ' visitors in the stream</button></div>';

    var b = q("seg-stream");
    if (b) b.addEventListener("click", function () {
      // filtering the stream by this segment is the point: a segment you cannot open is a chart
      if (SDIM === "device") { DEV = String(name).toLowerCase(); var fm = q("filtersMenu"); if (fm) fm.querySelectorAll(".rm[data-dev]").forEach(function (x) { x.classList.toggle("on", (x.getAttribute("data-dev") || "") === DEV); }); syncFiltersLabel(); }
      else if (SDIM === "persona") TAG = name;
      setView("visitor"); cards();
    });
    loadSegTraj(name, rows);
    loadSegSig(name, rows);
    loadSegMot(name, rows);
    loadSegDec(name, rows);
    loadSegBm(name, rows);
  }

  /* ═════════════════════════════════════════════════════════ VIEW 3 — radar */

  /* Everyone on the site, as one picture.
     Ring   = journey stage (outer = exploring, inner = ready) — the geometry IS the funnel
     Colour = persona
     Glow   = intent  (a halo, sized by score)
     Pulse  = frustration (an expanding ring, only above 50 — otherwise everything pulses and
              nothing means anything)
     Angle  = derived from the visitor id, so a node keeps its place between refreshes rather than
              jumping around and looking like new people arriving. */
  var RING = ["exploration", "evaluation", "comparison", "commitment"];
  function ringOf(j) {
    var i = RING.indexOf(String(j || "").toLowerCase());
    if (i >= 0) return i;
    if (/confus|frustrat/i.test(j || "")) return 1;      // stuck: they got as far as evaluating
    return 0;                                            // unknown: the outer ring, honestly
  }

  /* Intent DIRECTION for a live blip — reuses the same per-visitor trajectory the story panel loads.
     The on-site set is small, so we can afford one /trajectory call per visitor, cached in TRAJ and
     attempted at most once (TRAJTRIED) so the 15-second radar refresh never re-fetches or loops. */
  function trajDir(vid) {
    var t = TRAJ[vid];
    if (!t || !t.points || t.points.length < 2) return null;
    var scores = t.points.map(function (p) { return p.score; });
    var s = trajStats(scores);
    return s.slope > 1.2 ? "rising" : s.slope < -1.2 ? "falling" : "steady";
  }
  /* Decision flash from the cached trajectory: the visitor's latest scored page tells us if they're
     at a buy moment (intent spiked) or a leave moment (exit intent). Reuses TRAJ \u2014 no per-blip fetch. */
  function trajDecision(vid) {
    var t = TRAJ[vid];
    if (!t || !t.points || t.points.length < 2) return null;
    var last = t.points[t.points.length - 1];
    if (last.type === "exit-risk") return "leave";
    if (last.score >= 75 || (last.type === "high-intent" && last.score >= 68)) return "buy";
    return null;
  }
  function radarPrefetchTraj(nodes) {
    var todo = nodes.filter(function (n) { return !TRAJ[n.v.id] && !TRAJTRIED[n.v.id]; }).slice(0, 8);
    if (!todo.length) return;
    todo.forEach(function (n) { TRAJTRIED[n.v.id] = 1; });          // mark first: a failure must not retry every tick
    Promise.all(todo.map(function (n) {
      return api("/plugin/visitor-intelligence/trajectory?id=" + encodeURIComponent(n.v.id))
        .then(function (r) { if (r && r.ok) TRAJ[n.v.id] = r; }).catch(function () {});
    })).then(function () { if (VIEW === "radar") renderRadar(); });   // one redraw after the batch, not per node
  }

  function renderRadar() {
    var host = q("radar"); if (!host) return;
    var on = (LIVE.recent || []).filter(function (r) { return r.vid; });
    var seen = {}, nodes = [];
    on.forEach(function (r) {
      if (seen[r.vid]) return; seen[r.vid] = 1;
      var v = LIST.filter(function (x) { return x.id === r.vid; })[0] || { id: r.vid, short_id: String(r.vid).slice(0, 10) };
      nodes.push({ v: v, live: r, b: behOf(r.vid) });
    });

    if (q("r-n")) q("r-n").textContent = nf(LIVE.online || nodes.length);
    if (!nodes.length) {
      host.innerHTML = '<div class="vh-rempty">'+T('vih.nobody_on_the_site_right_now')+'<br>'+T('vih.the_radar_fills_as_people_arrive')+'</div>';
      renderRadarSide([]); return;
    }

    var W = 460, C = W / 2, R0 = 46, STEP = 46;
    var svg = '<svg viewBox="0 0 ' + W + " " + W + '" role="img" aria-label="'+T('vih.live_visitor_radar')+'">';
    // rings + labels
    for (var i = 0; i < 4; i++) {
      var r = R0 + i * STEP;
      svg += '<circle class="vh-rring" cx="' + C + '" cy="' + C + '" r="' + r + '"/>';
      svg += '<text class="vh-rlab" x="' + C + '" y="' + (C - r - 4) + '" text-anchor="middle">' + RING[3 - i] + "</text>";
    }
    svg += '<line class="vh-rring" x1="' + C + '" y1="' + (C - R0 - 3 * STEP) + '" x2="' + C + '" y2="' + (C + R0 + 3 * STEP) + '"/>';
    svg += '<line class="vh-rring" x1="' + (C - R0 - 3 * STEP) + '" y1="' + C + '" x2="' + (C + R0 + 3 * STEP) + '" y2="' + C + '"/>';
    // sweep
    svg += '<g class="vh-rsweep" style="transform-origin:' + C + 'px ' + C + 'px"><defs><linearGradient id="vhsw" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0" stop-color="#1FA463" stop-opacity="0"/><stop offset="1" stop-color="#1FA463" stop-opacity=".16"/></linearGradient></defs>' +
      '<path d="M' + C + " " + C + " L" + (C + R0 + 3 * STEP) + " " + C + " A" + (R0 + 3 * STEP) + " " + (R0 + 3 * STEP) +
      " 0 0 0 " + (C + (R0 + 3 * STEP) * Math.cos(-0.6)) + " " + (C + (R0 + 3 * STEP) * Math.sin(-0.6)) + ' Z" fill="url(#vhsw)"/></g>';

    nodes.forEach(function (nd) {
      var b = nd.b;
      var ri = 3 - ringOf(b && b.journey);                 // inner = further along
      var rad = R0 + ri * STEP;
      var ang = (hue(nd.v.id) / 360) * Math.PI * 2;        // deterministic: nodes hold their place
      var x = C + rad * Math.cos(ang), y = C + rad * Math.sin(ang);
      var col = b && b.persona ? pcol(b.persona) : "#5C6E88";
      var intent = b ? b.intent_score : null;
      var att = b ? b.attention_score : null;

      var dir = trajDir(nd.v.id);                          // intent trajectory direction, if we have it cached
      if (dir === "rising" || dir === "falling")           // soft filled halo: warming (green) / cooling (red)
        svg += '<circle class="vh-rglow" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' +
          (b ? 12 : 10) + '" fill="' + (dir === "rising" ? "#1FA463" : "#E0533D") + '" opacity="0.2"/>';

      if (att != null && att >= 40)                        // halo = attention
        svg += '<circle class="vh-rhalo" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' +
          (7 + att / 12).toFixed(1) + '" fill="' + col + '" opacity="' + (0.06 + att / 700).toFixed(3) + '"/>';
      if (b && b.frustration_score >= 50)                  // pulse = frustration, only when it means something
        svg += '<circle class="vh-rpulse" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="6" fill="none" stroke="#E0533D" stroke-width="1.4"/>';
      if (intent != null && intent >= 60)                  // glow = intent
        svg += '<circle class="vh-rhalo" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' +
          (5 + intent / 22).toFixed(1) + '" fill="none" stroke="' + col + '" stroke-width="1" opacity=".5"/>';

      var dec = trajDecision(nd.v.id);                     // flash = a decision just happened (buy / leave)
      if (dec)
        svg += '<circle class="vh-rflash vh-rflash-' + dec + '" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' +
          (b ? 11 : 9) + '" fill="none" stroke="' + (dec === "buy" ? "#1FA463" : "#E0533D") + '" stroke-width="1.8"/>';

      var tip = [nd.v.short_id + (nd.v.country ? " \u00b7 " + nd.v.country : "")];
      tip.push("On " + (nd.live.path || "/") + ", seen " + ago(nd.live.ago) + " ago.");
      if (b) {
        tip.push(b.persona + " \u00b7 " + (b.journey || "stage unknown"));
        tip.push("Intent " + b.intent_score + " \u00b7 Frustration " + b.frustration_score + " \u00b7 Attention " + b.attention_score);
      } else tip.push(T('vih.no_behaviour_scored_yet_u2014_outer_ring_unt'));
      if (dir === "rising" || dir === "falling") tip.push(T(dir === "rising" ? "vi.traj.warming_visit" : "vi.traj.cooling_visit"));
      if (dec) tip.push("Decision: " + (dec === "buy" ? "at a buying moment right now" : "showing exit intent \u2014 leaving") + ".");
      if (b) { var em = emoDominant(reconEmo({ i: b.intent_score, f: b.frustration_score, a: b.attention_score })); if (em !== "settled") tip.push("Feels: " + EMODEF[em].label.toLowerCase() + "."); }
      tip.push(T('vih.click_to_open_their_story'));

      svg += '<circle class="vh-rnode" data-vid="' + esc(nd.v.id) + '" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) +
        '" r="' + (b ? 5 : 3.5) + '" fill="' + col + '"><title>' + esc(tip.join("\n")) + "</title></circle>";
    });
    svg += "</svg>";
    host.innerHTML = svg;
    host.querySelectorAll(".vh-rnode").forEach(function (c) {
      var vid = c.getAttribute("data-vid");
      c.addEventListener("click", function () { setView("visitor"); pickVisitor(vid); });
      c.addEventListener("mouseenter", function () { radarLink(vid, true, true); });
      c.addEventListener("mouseleave", function () { radarLink(vid, false, false); });
    });
    renderRadarSide(nodes);
    radarPrefetchTraj(nodes);
  }

  /* Node <-> stream hover linking: hovering a live-stream row lights up that visitor's node on the
     canvas, and hovering a node lights up (and scrolls to) their row. Everything already carries
     data-vid, so this just toggles a .hot class on both sides by id. Symmetric, id-matched, cheap. */
  function radarLink(vid, on, reveal) {
    if (!vid) return;
    qa(".vh-rnode").forEach(function (n) { if (n.getAttribute("data-vid") === vid) n.classList.toggle("hot", on); });
    qa(".vh-rv").forEach(function (r) {
      if (r.getAttribute("data-vid") !== vid) return;
      r.classList.toggle("hot", on);
      if (on && reveal && r.scrollIntoView) { try { r.scrollIntoView({ block: "nearest" }); } catch (e) {} }
    });
  }
  function wireRadarRow(b) {
    var vid = b.getAttribute("data-vid");
    b.addEventListener("click", function () { setView("visitor"); pickVisitor(vid); });
    b.addEventListener("mouseenter", function () { radarLink(vid, true, false); });
    b.addEventListener("mouseleave", function () { radarLink(vid, false, false); });
  }

  function renderRadarSide(nodes) {
    // stage distribution
    var st = q("r-stages");
    if (st) {
      var c = {};
      nodes.forEach(function (n) { var k = (n.b && n.b.journey) || "unknown"; c[k] = (c[k] || 0) + 1; });
      var ks = Object.keys(c);
      st.innerHTML = ks.length ? ks.sort(function (a, b) { return c[b] - c[a]; }).map(function (k) {
        return '<div class="vh-rs" title="' + esc(k === "unknown"
          ? "No behaviour scored yet for these visitors."
          : "Visitors currently at the " + k + " stage.") + '">' +
          '<i style="background:' + segColor(k) + '"></i><span>' + esc(k) + "</span><b>" + c[k] + "</b></div>";
      }).join("") : '<div class="vh-empty" style="padding:8px 0">'+T('vih.nobody_on_the_site')+'</div>';
    }
    // the live list beside the radar
    var stream = q("r-stream");
    if (stream) {
      stream.innerHTML = nodes.length ? nodes.map(function (n) {
        var col = n.b && n.b.persona ? pcol(n.b.persona) : "#8C95A1";
        return '<button class="vh-rv" data-vid="' + esc(n.v.id) + '" title="' + esc((n.b && n.b.summary) || "No behaviour scored yet.") + '">' +
          '<span class="vh-rv-d" style="background:' + col + '"></span>' +
          '<span class="vh-rv-p">' + esc(n.live.path || "/") + "</span>" +
          '<span class="vh-rv-t">' + ago(n.live.ago) + "</span></button>";
      }).join("") : '<div class="vh-empty" style="padding:8px 0">\u2014</div>';
      stream.querySelectorAll(".vh-rv").forEach(wireRadarRow);
    }
    // live averages
    var bars = q("r-bars");
    if (bars) {
      var rows = nodes.filter(function (n) { return n.b; }).map(function (n) { return n.v; });
      bars.innerHTML = ["intent", "frustration", "attention"].map(function (k) {
        var g = GAUGE[k], v = avgOf(rows, k + "_score");
        return '<div class="vh-rb" title="' + esc(g.help) + '"><div class="vh-rb-t"><span>' + g.label + "</span><b>" +
          (v == null ? "\u2014" : v) + "</b></div>" +
          '<div class="vh-rb-b"><i style="width:' + (v || 0) + '%;background:' + g.ring[1] + '"></i></div></div>';
      }).join("") +
      (rows.length ? "" : '<div class="vh-empty" style="padding:6px 0;font-size:11px">'+T('vih.no_behaviour_scored_for_anyone_on_the_site_r')+'</div>');
    }
    // anomalies: the honest definition is "a session whose frustration is high"
    var tick = q("r-tick");
    if (tick) {
      var bad = nodes.filter(function (n) { return n.b && n.b.frustration_score >= 50; })
                     .sort(function (a, b) { return b.b.frustration_score - a.b.frustration_score; });
      tick.innerHTML = bad.length ? bad.map(function (n) {
        return '<a class="vh-tk" href="' + esc(link("visitor-intelligence", { id: n.v.id })) + '" title="'+T('vih.open_this_visitor')+'">' +
          '<i class="bi bi-exclamation-triangle"></i><span><b>' + esc(n.v.short_id) + " \u00b7 friction " + n.b.frustration_score + "</b>" +
          esc((n.live.path || "/") + " \u00b7 " + (n.b.persona || "")) + "</span></a>";
      }).join("") : T("vi.radar.no_anomalies");
    }

    // intent momentum: of the on-site visitors whose intent we can read a trend for, how many are
    // warming vs cooling. Same green/red as the halos, so the tally and the radar always agree.
    var mo = q("r-momentum");
    if (mo) {
      var m = { rising: 0, falling: 0, steady: 0 }, unknown = 0;
      nodes.forEach(function (n) { var d = trajDir(n.v.id); if (d) m[d]++; else unknown++; });
      if (!(m.rising + m.falling + m.steady)) {
        mo.innerHTML = '<div class="vh-empty" style="padding:8px 0;font-size:11px">' +
          (nodes.length ? "Reading intent trends\u2026 momentum appears once these visitors have a couple of scored pages."
                        : T('vih.nobody_on_the_site')) + "</div>";
      } else {
        var chip = function (n, col, ic, lbl, tip) {
          return '<div class="vh-mom" title="' + esc(tip) + '"><span class="vh-mom-i" style="color:' + col + '"><i class="bi ' + ic + '"></i></span>' +
            "<b>" + n + '</b><span class="vh-mom-l">' + lbl + "</span></div>";
        };
        mo.innerHTML =
          chip(m.rising, "#1FA463", "bi-graph-up-arrow", "warming", T('vih.on_site_visitors_whose_intent_is_trending_up')) +
          chip(m.falling, "#E0533D", "bi-graph-down-arrow", "cooling", T('vih.on_site_visitors_whose_intent_is_trending_do')) +
          chip(m.steady, "#2A6FE8", "bi-dash-lg", "steady", T('vih.on_site_visitors_whose_intent_is_holding_lev')) +
          (unknown ? '<div class="vh-mom-note">' + unknown + " more without enough readings yet.</div>" : "");
      }
    }

    // deciding now: on-site visitors whose latest scored page is a buy or leave moment. Reuses the
    // same cached trajectory as the flashes on the canvas, so the tally and the rings always agree.
    var dc = q("r-decisions");
    if (dc) {
      var buy = [], leave = [];
      nodes.forEach(function (n) { var d = trajDecision(n.v.id); if (d === "buy") buy.push(n); else if (d === "leave") leave.push(n); });
      if (!(buy.length + leave.length)) {
        dc.innerHTML = '<div class="vh-empty" style="padding:8px 0;font-size:11px">' +
          (nodes.length ? "No buy or leave moments right now \u2014 a ring flashes on the radar when someone\u2019s intent spikes or they move to leave."
                        : T('vih.nobody_on_the_site')) + "</div>";
      } else {
        var dchip = function (n, col, ic, lbl, tip) {
          return '<div class="vh-mom" title="' + esc(tip) + '"><span class="vh-mom-i" style="color:' + col + '"><i class="bi ' + ic + '"></i></span>' +
            "<b>" + n + '</b><span class="vh-mom-l">' + lbl + "</span></div>";
        };
        var dlist = buy.concat(leave).slice(0, 5).map(function (n) {
          var d = trajDecision(n.v.id), col = d === "buy" ? "#1FA463" : "#E0533D";
          return '<button class="vh-rv" data-vid="' + esc(n.v.id) + '" title="'+T('vih.open_this_visitor')+'">' +
            '<span class="vh-rv-d" style="background:' + col + '"></span>' +
            '<span class="vh-rv-p">' + esc(n.live.path || "/") + "</span>" +
            '<span class="vh-rv-t" style="color:' + col + '">' + (d === "buy" ? "buy" : "leave") + "</span></button>";
        }).join("");
        dc.innerHTML =
          dchip(buy.length, "#1FA463", "bi-bag-check", "buying", T('vih.on_site_visitors_whose_intent_just_spiked_to')) +
          dchip(leave.length, "#E0533D", "bi-box-arrow-right", "leaving", T('vih.on_site_visitors_who_just_showed_exit_intent')) +
          '<div class="vh-rdec-list">' + dlist + "</div>";
        dc.querySelectorAll(".vh-rv").forEach(wireRadarRow);
      }
    }

    // emotional climate: the dominant emotion of everyone on the site right now, reconstructed from
    // their representative behaviour (same model as the story panel). Reuses the stage-row style.
    // signatures on site: the persona (= signature) distribution of everyone here right now. The node
    // colours on the canvas already ARE these; this tallies them. Client-side; reuses the stage rows.
    var rs = q("r-sig");
    if (rs) {
      var sc = {}, stot = 0;
      nodes.forEach(function (n) { var p = n.b && n.b.persona; if (p) { sc[p] = (sc[p] || 0) + 1; stot++; } });
      if (!stot) rs.innerHTML = '<div class="vh-empty" style="padding:8px 0;font-size:11px">' + (nodes.length ? "No behaviour scored yet." : T('vih.nobody_on_the_site')) + "</div>";
      else rs.innerHTML = Object.keys(sc).sort(function (a, b) { return sc[b] - sc[a]; }).map(function (p) {
        return '<div class="vh-rs" title="' + esc(phelp(p)) + '"><i style="background:' + pcol(p) + '"></i><span>' + esc(p) + "</span><b>" + sc[p] + "</b></div>";
      }).join("");
    }

    var re = q("r-emo");
    if (re) {
      var ec = {}, et = 0;
      nodes.forEach(function (n) {
        if (!n.b) return;
        var dm = emoDominant(reconEmo({ i: n.b.intent_score, f: n.b.frustration_score, a: n.b.attention_score }));
        ec[dm] = (ec[dm] || 0) + 1; et++;
      });
      if (!et) {
        re.innerHTML = '<div class="vh-empty" style="padding:8px 0;font-size:11px">' +
          (nodes.length ? "No behaviour scored for anyone on the site yet." : T('vih.nobody_on_the_site')) + "</div>";
      } else {
        re.innerHTML = Object.keys(ec).sort(function (a, b) { return ec[b] - ec[a]; }).map(function (k) {
          var def = EMODEF[k];
          return '<div class="vh-rs" title="' + esc(def.help) + '"><i style="background:' + def.color + (k === "settled" ? ";opacity:.5" : "") +
            '"></i><span>' + esc(def.label) + "</span><b>" + ec[k] + "</b></div>";
        }).join("");
      }
    }
  }

  /* ═══════════════════════════════════════════════════════ view switching */

  /* --------------------------------------------------------------- help */
  // A real, click-to-open help panel. The bar tooltips are native title= attributes, which show
  // nothing on touch and vanish the moment a pane renders empty — exactly when a new user most
  // needs them. This one is static markup in the page, so it works before any data loads.
  function openHelp() { var h = q("help"); if (h) { h.hidden = false; document.body.classList.add("vh-help-open"); } }
  function closeHelp() { var h = q("help"); if (h) { h.hidden = true; document.body.classList.remove("vh-help-open"); } }
  function initCopilot() {
    var btn = q("cpBtn"), x = q("cp-close"), rf = q("cp-refresh");
    if (btn) btn.addEventListener("click", cpToggle);
    if (x) x.addEventListener("click", cpClose);
    if (rf) rf.addEventListener("click", cpRender);
    document.addEventListener("keydown", function (e) { if (e.key === T('vih.escape') && CP_OPEN) cpClose(); });
  }
  function initHelp() {
    var btn = q("helpBtn"), x = q("helpClose"), pane = q("help");
    if (btn) btn.addEventListener("click", function (e) { e.stopPropagation(); (pane && pane.hidden) ? openHelp() : closeHelp(); });
    if (x) x.addEventListener("click", closeHelp);
    if (pane) pane.addEventListener("click", function (e) { if (e.target === pane) closeHelp(); });
    document.addEventListener("keydown", function (e) { if (e.key === T('vih.escape')) closeHelp(); });
  }
  // Small inline affordance used by every "needs the tracker" empty state, so the dead-end text
  // becomes a way in rather than a full stop.
  function helpLink(label) { return ' <a href="#" class="vh-help-link" data-h="help-open">' + (label || "Why? &rarr;") + "</a>"; }

  /* ── Hierarchy & attention ──────────────────────────────────────────────────
     The site drawn as a tree, with two lenses over the same structure: what people
     visit, and what needs fixing. Detail opens in an offcanvas because a page can
     carry a dozen findings and each one needs its fix spelled out. */
  var TREE = null, TREE_LENS = "traffic", TREE_F = { critical: false, major: false };
  /* Stated here rather than buried in a condition, because both are judgement calls:
     45 is where the attention bands turn amber, and 1% of all traffic is the point past which a
     page cannot move a site-level number however bad it is. */
  var TREE_ATTN_MIN = 45, TREE_TAIL_MIN = 0.01;

  function treeTone(p, lens) {
    if (!p) return "#C7CDD6";
    if (lens === "attention") {
      var a = p.attention_score || 0;
      return a >= 60 ? "#DC2626" : a >= 45 ? "#EA580C" : a >= 30 ? "#D97706" : "#1FA463";
    }
    if (lens === "seo") {
      if (!p.seo_verdict) return "#C7CDD6";              // not crawled
      if (p.seo_indexable === false) return "#DC2626";   // won't index
      return (p.seo_issues > 0) ? "#D97706" : "#1FA463"; // has issues / clean
    }
    return "#2A6FE8";
  }

  /* Long tail is measured against the site's TOTAL traffic, not against its biggest single page.
     Dividing by the largest page made the threshold meaningless — on a site whose busiest page has
     200 sessions, a page with 2 scored 1% and survived a "hide below 1%" filter it should have
     failed. Total is what "long tail" actually means. */
  function treeShare(p, total) { return total > 0 ? (p.sessions / total) : 1; }

  function treeKeep(node, total) {
    var p = node.page;
    var kids = function () { return node.children.some(function (c) { return treeKeep(c, total); }); };
    if (!p) return kids();
    /* A branch whose own page fails can still be kept for a child that passes, or the tree loses
       its shape — but the branch row itself is dimmed rather than presented as a result. */
    if (TREE_F.critical && (p.attention_score || 0) < TREE_ATTN_MIN) return kids();
    if (TREE_F.major && treeShare(p, total) < TREE_TAIL_MIN) return kids();
    return true;
  }

  /* Columns, not one long indented list.
     A site's top level — its hosts, or its main sections — are peers, and laying them side by side
     is what makes a hierarchy worth looking at: you can compare them without scrolling. Their pages
     run vertically underneath, where depth reads naturally and a long section scrolls inside its own
     column instead of pushing everything else down the page. */

  /* Flatten one branch into ordered rows, carrying depth so indentation still shows structure. */
  function treeFlatten(node, depth, total, out) {
    if (!treeKeep(node, total)) return out;
    out.push({ node: node, depth: depth });
    node.children.forEach(function (c) { treeFlatten(c, depth + 1, total, out); });
    return out;
  }

  function seoShort(v) {
    return ({ not_found: "404", soft_404: "soft404", noindex: "noindex", robots_blocked: "blocked",
              canonical_conflict: "canon", redirect: "redirect", redirect_loop: "loop", error: "err" })[v] || v;
  }
  /* A small red flag on pages that won't index (404, noindex, redirect, ...). Clean pages get none,
     so problems stand out. Reuses the existing badge classes, so no CSS change. Needs PageTree to
     supply seo_verdict/seo_indexable (SEO Visibility plugin). */
  function seoBadge(p, cls) {
    if (!p || !p.seo_verdict) return "";
    if (p.seo_indexable === false)
      return '<span class="' + cls + '" style="background:#DC2626" title="SEO: won\u2019t index (' + esc(p.seo_verdict) + ')">' + seoShort(p.seo_verdict) + "</span>";
    if (p.seo_issues > 0)
      return '<span class="' + cls + '" style="background:#D97706" title="Indexable \u00b7 ' + p.seo_issues + " SEO issue" + (p.seo_issues === 1 ? "" : "s") + '">!' + p.seo_issues + "</span>";
    return "";
  }

  function treeLeaf(entry, maxInCol) {
    var node = entry.node, p = node.page;
    var tone = treeTone(p, TREE_LENS);
    var width = maxInCol > 0 ? Math.max(3, Math.round(node.subtree_sessions / maxInCol * 100)) : 3;
    var meta = p
      ? nf(p.sessions) + " \u00b7 " + p.exit_rate + "%" + (p.design != null ? " \u00b7 d" + p.design : "")
      : nf(node.subtree_sessions) + " below";
    var badge = (p && TREE_LENS === "attention")
      ? '<span class="vh-tn-badge" style="background:' + tone + '">' + p.attention_score + "</span>" : "";
    return '<div class="vh-tn' + (p ? "" : " is-branch") + '" style="--d:' + entry.depth + '"'
      + (p ? ' data-tree-path="' + esc(p.key || p.path) + '" tabindex="0" role="button"'
           + ' title="' + esc(p.path) + '"'
          : ' title="'+TR('js.a_section_not_a_page')+'"')
      + '><span class="vh-tn-name">' + esc(node.name === "/" ? "/" : node.name) + "</span>"
      + '<span class="vh-tn-bar"><i style="width:' + width + "%;background:" + tone + '"></i></span>'
      + badge + seoBadge(p, "vh-tn-badge") + '<span class="vh-tn-meta">' + esc(meta) + "</span></div>";
  }

  /* A flowchart, not a list: nested <ul>/<li> with connector lines drawn in CSS.
     Structure is the point of this view, and lines say "these belong to that" in a way indentation
     only implies. Depth is capped and wide levels are summarised, because a flowchart of four
     hundred pages is a wall, not a diagram — the offcanvas holds the detail. */
  var TREE_MAX_SIBLINGS = 6, TREE_STACK_MAX = 14;

  function treeNodeBox(node, total) {
    var p = node.page;
    var tone = treeTone(p, TREE_LENS);
    var isHost = !!(node.host && node.name === node.host);
    var share = total > 0 ? Math.round(node.subtree_sessions / total * 100) : 0;
    var label = node.name === "/" ? "/" : node.name;
    var sub = p
      ? nf(p.sessions) + " \u00b7 " + p.exit_rate + "% exit" + (p.design != null ? " \u00b7 d" + p.design : "")
      : nf(node.subtree_sessions) + " below";
    var badge = (p && TREE_LENS === "attention")
      ? '<span class="vh-fc-badge" style="background:' + tone + '">' + p.attention_score + "</span>" : "";
    return '<div class="vh-fc-box' + (isHost ? " is-host" : "") + (p ? "" : " is-branch") + '"'
      + ' style="--tone:' + tone + '"'
      + (p ? ' data-tree-path="' + esc(p.key || p.path) + '" tabindex="0" role="button"'
           + ' title="' + esc(p.path) + '"' : ' title="'+TR('js.a_section_not_a_page')+'"')
      + '><span class="vh-fc-t">'
      + (isHost ? '<i class="bi bi-globe2" aria-hidden="true"></i>' : "")
      + esc(label) + badge + seoBadge(p, "vh-fc-badge") + "</span>"
      + '<span class="vh-fc-s">' + esc(sub) + (share ? " \u00b7 " + share + "%" : "") + "</span></div>";
  }

  /* Horizontal only where structure genuinely branches; vertical everywhere below.
     A site has a handful of top-level sections and then a long tail beneath them — /entry/a,
     /entry/b, /entry/c. Spreading those sideways produces a diagram nobody can read on any screen,
     so the first two levels are a flowchart and everything under them is a stacked list, which is
     the shape the content actually has. */
  function treeStack(node, depth, total, out) {
    if (!treeKeep(node, total)) return out;
    var p = node.page;
    var tone = treeTone(p, TREE_LENS);
    var meta = p
      ? nf(p.sessions) + " \u00b7 " + p.exit_rate + "%" + (p.design != null ? " \u00b7 d" + p.design : "")
      : nf(node.subtree_sessions) + " below";
    var badge = (p && TREE_LENS === "attention")
      ? '<span class="vh-fc-badge" style="background:' + tone + '">' + p.attention_score + "</span>" : "";
    out.push('<div class="vh-fc-row' + (p ? "" : " is-branch") + '" style="--d:' + depth + '"'
      + (p ? ' data-tree-path="' + esc(p.key || p.path) + '" tabindex="0" role="button" title="' + esc(p.path) + '"'
          : ' title="'+TR('js.a_section_not_a_page')+'"')
      + '><i style="background:' + tone + '"></i>'
      + '<span class="vh-fc-row-n">' + esc(node.name) + "</span>" + badge + seoBadge(p, "vh-fc-badge")
      + '<span class="vh-fc-row-m">' + esc(meta) + "</span></div>");
    node.children.forEach(function (c) { treeStack(c, depth + 1, total, out); });
    return out;
  }

  function treeBranch(node, depth, total) {
    if (!treeKeep(node, total)) return "";
    var box = treeNodeBox(node, total);
    var kids = node.children.filter(function (c) { return treeKeep(c, total); });
    if (!kids.length) return "<li>" + box + "</li>";

    /* Depth 1 still branches — those are the site's real sections. Below that, stack. */
    if (depth >= 1) {
      var rows = [];
      kids.forEach(function (c) { treeStack(c, 0, total, rows); });
      /* "+26 more below" was a dead label: the rows existed, they were sliced off and thrown away,
         and the only way to see them was to not have them. They are all rendered now — the ones past
         the fold wrapped in a layout-neutral <div hidden> — and the label is a button that reveals
         the next twenty. No re-render, no refetch, and each stack pages independently.
         CAP is a floor under pathological trees: past it the rows are genuinely not drawn, and the
         panel says so rather than quietly stopping. */
      var CAP = 600;
      var capped = rows.length > CAP, all = capped ? rows.slice(0, CAP) : rows;
      var head = all.slice(0, TREE_STACK_MAX).join("");
      var tail = all.slice(TREE_STACK_MAX).map(function (r) {
        return '<div class="vh-fc-hid" hidden>' + r + "</div>";
      }).join("");
      var hidden = Math.max(0, all.length - TREE_STACK_MAX);
      return "<li>" + box
        + '<div class="vh-fc-stack">' + head + tail
        + (hidden > 0 ? '<button type="button" class="vh-fc-more vh-fc-more-row" data-more="1">+'
            + hidden + ' more below</button>' : "")
        + (capped ? '<div class="vh-fc-more vh-fc-more-row vh-fc-cap">'
            + nf(rows.length - CAP) + ' further pages not drawn</div>' : "")
        + "</div></li>";
    }

    var show = kids.slice(0, TREE_MAX_SIBLINGS);
    var rest = kids.length - show.length;
    var inner = show.map(function (c) { return treeBranch(c, depth + 1, total); }).join("");
    if (rest > 0) {
      var restSessions = kids.slice(TREE_MAX_SIBLINGS).reduce(function (n, c) { return n + c.subtree_sessions; }, 0);
      inner += '<li><div class="vh-fc-more">+' + rest + " more \u00b7 " + nf(restSessions) + " sessions</div></li>";
    }
    return "<li>" + box + "<ul>" + inner + "</ul></li>";
  }



  function renderTree() {
    var host = q("tree-body"); if (!host) return;
    if (TREE) { treePaint(); return; }
    host.innerHTML = '<div class="vh-tree-loading">Building the tree…</div>';
    /* api() adds the site parameter and unwraps the envelope, exactly as every other call in this
       file does — duplicating that was how a variable that does not exist crept in. */
    api("/stats/pagetree?" + rng())
      .then(function (r) {
        TREE = r;
        treePaint();
      })
      .catch(function (e) {
        host.innerHTML = '<div class="vh-tree-loading">Could not build the tree ('
          + esc((e && e.message) || "request failed") + ").</div>";
      });
  }

  function treePaint() {
    var host = q("tree-body"); if (!host || !TREE) return;
    if (!TREE.ok) { host.innerHTML = '<div class="vh-tree-loading">' + esc(TREE.error || "No data.") + "</div>"; return; }
    if (!TREE.tree || !TREE.tree.children || (!TREE.tree.children.length && !TREE.tree.page)) {
      host.innerHTML = '<div class="vh-tree-loading">' + esc(TREE.note || "No pages in this range yet.") + "</div>";
      return;
    }
    var total = (TREE.totals && TREE.totals.sessions) || 0;
    if (!total) (TREE.pages || []).forEach(function (p) { total += p.sessions; });

    var branches = (TREE.tree.children || []).filter(function (b) { return treeKeep(b, total); });
    if (!branches.length && TREE.tree.page) branches = [TREE.tree];

    if (!branches.length) {
      host.innerHTML = '<div class="vh-tree-loading">'+T('vih.nothing_matches_these_filters')+'</div>';
    } else {
      /* The root is the diagram's own head, so the site's landing page belongs in it rather than
         floating above as a separate row. */
      var rootBox = TREE.tree.page
        ? treeNodeBox(TREE.tree, total)
        : '<div class="vh-fc-box is-branch is-root"><span class="vh-fc-t">'
          + esc((TREE.site && TREE.site.domain) || "site") + '</span><span class="vh-fc-s">'
          + nf(total) + " sessions</span></div>";
      host.innerHTML = '<div class="vh-fc"><ul><li>' + rootBox + "<ul>"
        + branches.map(function (b) { return treeBranch(b, 1, total); }).join("")
        + "</ul></li></ul></div>";
    }

    var leg = q("tree-legend");
    if (leg) leg.innerHTML =
      TREE_LENS === "attention"
        ? '<span><i style="background:#DC2626"></i>urgent</span><span><i style="background:#EA580C"></i>poor</span>'
          + '<span><i style="background:#D97706"></i>watch</span><span><i style="background:#1FA463"></i>healthy</span>'
          + '<em>bar = share of traffic through this branch \u00b7 number = attention score</em>'
        : TREE_LENS === "seo"
        ? '<span><i style="background:#1FA463"></i>indexable</span><span><i style="background:#D97706"></i>has issues</span>'
          + '<span><i style="background:#DC2626"></i>won\u2019t index</span><span><i style="background:#C7CDD6"></i>not crawled</span>'
          + '<em>bar = share of traffic through this branch \u00b7 colour = SEO verdict</em>'
        : '<span><i style="background:#2A6FE8"></i>traffic</span><em>bar = share of all sessions passing through this branch</em>';

    var note = q("tree-note");
    if (note) {
      var bits = [];
      if (TREE.totals) bits.push(TREE.totals.pages + " pages \u00b7 " + nf(TREE.totals.sessions) + " sessions.");
      if (TREE.note) bits.push(TREE.note);
      /* Say why a subdomain page can appear under the main domain, rather than leaving someone to
         conclude the tree is simply wrong. */
      var h = TREE.history;
      if (h && h.mixed) bits.push("Pages visited before " + String(h.before).slice(0, 10)
        + " show under your main domain: subdomain tracking was off then, so the real host was never "
        + "recorded for those " + nf(h.rows) + " pageviews and cannot be recovered.");
      note.textContent = bits.join(" ");
    }

    qa('[data-tree-path]', host).forEach(function (el) {
      el.addEventListener("click", function () { treeOpen(el.getAttribute("data-tree-path")); });
      el.addEventListener("keydown", function (ev) {
        if (ev.key === T('vih.enter') || ev.key === " ") { ev.preventDefault(); treeOpen(el.getAttribute("data-tree-path")); }
      });
    });
  }

  /* Match on the node's own key: with subdomains tracked, two pages share a path and matching on
     path alone would open whichever happened to come first. */
  function treePage(key) {
    var hit = null;
    (TREE && TREE.pages || []).forEach(function (p) {
      if (p.key === key || (!hit && p.path === key)) hit = p;
    });
    return hit;
  }

  function seoVerdictLabel(v) {
    return ({ indexable: T('vih.indexable'), noindex: T('vih.noindex_directive'), robots_blocked: T('vih.blocked_by_robots_txt'),
              canonical_conflict: T('vih.canonical_points_elsewhere'), redirect: T('vih.redirects_to_another_url'),
              redirect_loop: T('vih.redirect_loop'), not_found: T('vih.not_found_404'), soft_404: T('vih.soft_404'),
              error: "Couldn\u2019t be fetched" })[v] || v;
  }
  /* Search-visibility section for the page offcanvas: indexability + the on-page findings the crawl
     stored (needs PageTree to supply seo_verdict / seo_indexable / seo_findings). */
  function ocSeoSection(p) {
    var rankHtml = "";
    if (p.seo_queries && p.seo_queries.length) {
      rankHtml = '<div class="vh-oc-seo-qh">'+T('vih.ranking_for')+'</div><div class="vh-oc-seo-queries">'
        + p.seo_queries.map(function (q) {
            var qp = +q.position, t = qp <= 10 ? "g" : qp <= 20 ? "a" : "l", l = qp % 1 === 0 ? qp : qp.toFixed(1);
            return '<div class="vh-oc-qrow"><span class="vh-oc-rankpos vh-oc-rankpos-' + t + '">#' + l + "</span>"
              + '<span class="vh-oc-qkw" title="' + esc(q.keyword) + '">' + esc(q.keyword) + "</span>"
              + (q.impressions ? '<span class="vh-oc-rankmeta">' + nf(q.impressions) + "</span>" : "") + "</div>";
          }).join("") + "</div>";
    } else if (p.seo_rank && p.seo_rank.position) {
      var rk = p.seo_rank, rp = +rk.position, tier = rp <= 10 ? "g" : rp <= 20 ? "a" : "l", lbl = rp % 1 === 0 ? rp : rp.toFixed(1);
      rankHtml = '<div class="vh-oc-seo-rank"><span class="vh-oc-rankpos vh-oc-rankpos-' + tier + '">#' + lbl + "</span>"
        + '<span>ranks for <b>' + esc(rk.keyword) + "</b>"
        + (rk.impressions ? " \u00b7 " + nf(rk.impressions) + " impressions" : "") + "</span></div>";
    }
    if (!p.seo_verdict) {
      return '<div class="vh-oc-sec"><h6>'+T('vih.search_visibility')+'</h6><div class="vh-oc-seobox" style="--seo:#C7CDD6">'
        + rankHtml
        + '<p class="vh-oc-hint" style="margin:' + (rankHtml ? "8px 0 0" : "0") + '">Not crawled yet \u2014 open <a href="/seo-visibility">'+T('vih.search_engine_visibility')+'</a> and run a crawl to see indexability and on-page findings.</p>'
        + '</div></div>';
    }
    var ok = p.seo_indexable === true, color = ok ? "#1FA463" : "#DC2626";
    var status = '<div class="vh-oc-seo-head"><span class="vh-oc-seo-dot" style="background:' + color + '"></span>'
      + '<b style="color:' + color + '">' + (ok ? "Indexable" : "Won\u2019t index") + "</b>"
      + '<span class="vh-oc-seo-verdict">' + esc(seoVerdictLabel(p.seo_verdict)) + "</span></div>";
    var f = p.seo_findings || [];
    var body = f.length
      ? '<ul class="vh-oc-seo-list">' + f.map(function (x) { return "<li>" + esc(x.label || x) + "</li>"; }).join("") + "</ul>"
      : '<p class="vh-oc-hint" style="margin:0">'+T('vih.no_on_page_issues_found')+'</p>';
    return '<div class="vh-oc-sec"><h6>'+T('vih.search_visibility')+'</h6>'
      + '<div class="vh-oc-seobox" style="--seo:' + color + '">' + status + rankHtml + body + "</div></div>";
  }

  /* A collapsible labelled block wrapping several sections, so the panel stays scannable as more is
     added. Sections keep their own sub-headers; the group header sits one level above them. */
  function ocGroup(title, id, content) {
    return '<section class="vh-oc-grp" data-oc-grp="' + esc(id) + '">'
      + '<button type="button" class="vh-oc-ghead" aria-expanded="true"><span>' + esc(title) + '</span>'
      + '<i class="bi bi-chevron-down"></i></button>'
      + '<div class="vh-oc-gbody">' + content + "</div></section>";
  }

  /* Offcanvas: the numbers, then what to fix, then everywhere else this page can be opened. */
  function treeOpen(key) {
    var p = treePage(key); if (!p) return;
    var path = p.path;
    var t = q("oc-title"), sub = q("oc-sub"), body = q("oc-body");
    if (t) t.textContent = p.path;
    if (sub) sub.textContent = (p.hostname ? p.hostname + " · " : "")
      + nf(p.sessions) + " sessions in this range";
    if (!body) return;

    /* Score first and in its own box: it is the one number that answers "is this page any good",
       and burying it among six stats made it just another figure. */
    var g = p.design_grade || "";
    var scoreBox = p.design == null
      ? '<div class="vh-oc-scorebox is-none"><div class="vh-oc-sv">\u2014</div>'
        + '<div class="vh-oc-sl">'+T('vih.not_audited_yet')+'</div></div>'
      : '<div class="vh-oc-scorebox vh-oc-g' + esc(g) + '">'
        + '<div class="vh-oc-sv">' + p.design + '<span>' + esc(g) + '</span></div>'
        + '<div class="vh-oc-sl">Design score \u00b7 '
        /* Gated on "has this page been audited", not on the count. The count has been wrong
           before (PageTree's host-keyed lookup) and a wrong zero must not also hide the findings
           that are sitting on disk. An audit with genuinely nothing to fix says so when opened. */
        + '<button type="button" class="vh-oc-findings" data-h="oc-findings">'
          + (+p.design_issues || 0) + ' finding' + ((+p.design_issues || 0) === 1 ? "" : "s")
          + ' <i class="bi bi-chevron-down"></i></button>'
        + '</div></div>';

    var parts = p.attention_parts || {};
    var statsHtml = '<div class="vh-oc-stats">'
      + ocStat(T('vih.sessions'), nf(p.sessions)) + ocStat(T('vih.exit_rate'), p.exit_rate + "%")
      + ocStat(T('vih.intent'), p.intent == null ? "\u2014" : p.intent)
      + ocStat(T('vih.friction'), p.friction == null ? "\u2014" : p.friction)
      + ocStat(T('vih.attention'), p.attention == null ? "\u2014" : p.attention)
      + ocStat(T('vih.conversion'), p.conv_rate + "%")
      + '</div>';
    var whyHtml = '<div class="vh-oc-sec"><h6>'+T('vih.why_it_needs_attention')+'</h6>'
      + '<div class="vh-oc-why"><div class="vh-oc-whyn" style="color:'
      +   (p.attention_score >= 60 ? "#DC2626" : p.attention_score >= 45 ? "#EA580C" : "#1FA463")
      +   '">' + p.attention_score + '</div><div class="vh-oc-whyb">'
      +   ocTerm("exits", parts.exit) + ocTerm("friction", parts.friction)
      +   ocTerm("design", parts.design) + ocTerm("conversion", parts.conv)
      +   '<div class="vh-oc-hint">'+T('vih.each_term_is_a_stated_share_so_you_can_disag')+'</div>'
      + '</div></div></div>';
    var auditHtml = '<div class="vh-oc-sec"><h6>'+T('vih.design_audit')+'</h6><div data-h="oc-audit">'
      + (p.design == null
          ? '<p class="vh-oc-hint">Not audited. The audit fetches this page and reads its markup and styles '
            + '\u2014 contrast, tap targets, form length, headings, viewport, images, typography, '
            + 'render-blocking scripts.</p>'
            + '<button class="vh-oc-btn" data-h="oc-run" data-path="' + esc(path) + '" data-key="' + esc(p.key || path) + '">'+T('vih.audit_this_page_now')+'</button>'
          : '<p class="vh-oc-hint">'
            + (p.audited_at ? 'Audited ' + esc(String(p.audited_at).slice(0, 16)) + '. ' : '')
            + 'Re-run to see the findings.</p>'
            + '<button class="vh-oc-btn" data-h="oc-run" data-path="' + esc(path) + '" data-key="' + esc(p.key || path) + '">'+T('vih.re_run_the_audit')+'</button>')
      + '</div></div>';
    var whereHtml = '<div class="vh-oc-sec"><h6>'+T('vih.where_this_page_is_served')+'</h6>'
      +   '<div data-h="oc-hosts"><span class="vh-oc-hint">Checking\u2026</span></div></div>';
    var openHtml = '<div class="vh-oc-sec"><h6>'+T('vih.open_this_page_in')+'</h6><div class="vh-oc-links">'
      + ocLink("/heatmaps?page=", path, T('vih.heatmaps'), T('vih.where_people_clicked_and_how_far_they_scroll'), "heatmaps")
      + ocLink("/content-intel?page=", path, T('vih.content_intelligence'), T('vih.whether_it_is_actually_read'), "content-intel")
      + ocLink("/user-flow?page=", path, T('vih.user_flow'), T('vih.what_they_did_before_and_after'), "user-flow")
      + ocLink("/session-recordings?page=", path, T('vih.session_recordings'), T('vih.watch_a_real_visit'), "session-recordings")
      + ocLink("/dropoff-risk?page=", path, T('vih.drop_off_risk'), T('vih.how_this_page_ranks_for_leaving'), "dropoff-risk")
      + ocLink("/ux-auditor?page=", path, T('vih.ux_auditor'), T('vih.behavioural_problems_not_design_ones'), "ux-auditor")
      + '</div></div>';

    /* Score is the headline and stays out of the groups; everything else is grouped so the panel
       reads as a few labelled blocks rather than one long scroll. Sections keep their data-h hooks,
       so the findings/audit/hosts wiring below still finds them. */
    body.innerHTML =
      scoreBox
      + ocGroup(T("vi.btn.performance"), "perf", statsHtml + whyHtml)
      + ocGroup(T('vih.page_quality'), "quality", ocSeoSection(p) + auditHtml)
      + ocGroup(T('vih.explore'), "explore", whereHtml + openHtml);

    if (!body._grpWired) {
      body._grpWired = 1;
      body.addEventListener("click", function (e) {
        var h = e.target.closest(".vh-oc-ghead"); if (!h) return;
        var grp = h.closest(".vh-oc-grp"); if (!grp) return;
        var collapsed = grp.classList.toggle("collapsed");
        h.setAttribute("aria-expanded", collapsed ? "false" : "true");
      });
    }

    ocHosts(path);
    ocTools(path);

    var fnd = body.querySelector('[data-h="oc-findings"]');
    if (fnd) fnd.addEventListener("click", function () {
      /* Second press collapses back to the summary rather than re-fetching. */
      if (fnd.getAttribute("data-open") === "1") {
        fnd.removeAttribute("data-open");
        var n = fnd.getAttribute("data-count") != null ? +fnd.getAttribute("data-count") : (+p.design_issues || 0);
        fnd.innerHTML = n + ' finding' + (n === 1 ? "" : "s") + ' <i class="bi bi-chevron-down"></i>';
        var h2 = q("oc-audit");
        if (h2) { h2.innerHTML = '<p class="vh-oc-hint">'
          + (p.audited_at ? 'Audited ' + esc(String(p.audited_at).slice(0, 16)) + '. ' : "")
          + 'Re-run to refresh the findings.</p>'; ocRunAgain(h2, path, p.key || path); }
        return;
      }
      fnd.setAttribute("data-open", "1");
      ocShowStored(path, p.key || path, fnd);
    });

    var run = body.querySelector('[data-h="oc-run"]');
    /* The key, not the path: treePage() matches on key first precisely because two hostnames can
       share a path, and passing the path made the audit fetch whichever host happened to be first. */
    if (run) run.addEventListener("click", function () {
      treeAudit(run.getAttribute("data-path"), run, run.getAttribute("data-key"));
    });

    var el = document.getElementById("vhPageOc");
    if (el && window.bootstrap && bootstrap.Offcanvas) bootstrap.Offcanvas.getOrCreateInstance(el).show();
  }

  /* One term of the attention sum, drawn as a bar so the mix is readable at a glance. */
  function ocTerm(label, v) {
    v = Math.round((+v || 0) * 10) / 10;
    var neg = v < 0;
    return '<div class="vh-oc-term"><span>' + label + '</span>'
      + '<i><b style="width:' + Math.max(2, Math.min(100, Math.abs(v) * 2.2)) + '%;background:'
      + (neg ? "#1FA463" : "#EA580C") + '"></b></i>'
      + '<em>' + (neg ? "" : "+") + v + '</em></div>';
  }

  /* One page can be recorded under more than one hostname — usually because the site genuinely
     answers on both. Showing it here, with how people got there, turns "why is this under that
     host?" into something answerable without a shell. */
  function ocHosts(path) {
    var host = q("oc-hosts"); if (!host) return;
    api("/stats/pagehosts?path=" + encodeURIComponent(path))
      .then(function (d) {
        if (!d || !d.hosts || !d.hosts.length) { host.innerHTML = '<span class="vh-oc-hint">'+T('vih.no_host_data')+'</span>'; return; }
        var total = d.hosts.reduce(function (n, h) { return n + (+h.views || 0); }, 0);
        var rows = d.hosts.map(function (h) {
          var pct = total > 0 ? Math.round(h.views / total * 100) : 0;
          return '<div class="vh-oc-host"><span class="vh-oc-hname">' + esc(h.host) + "</span>"
            + '<span class="vh-oc-hbar"><i style="width:' + Math.max(3, pct) + '%"></i></span>'
            + '<span class="vh-oc-hn">' + nf(h.views) + " \u00b7 " + pct + "%</span>"
            + '<span class="vh-oc-hwhen">last ' + esc(String(h.last_seen || "").slice(0, 10)) + "</span></div>";
        }).join("");

        var note = "";
        if (d.hosts.length > 1) {
          /* Naming the likely cause is more use than reporting the split and stopping. */
          var byHost = {};
          (d.referrers || []).forEach(function (r) { (byHost[r.host] = byHost[r.host] || []).push(r); });
          var minor = d.hosts[d.hosts.length - 1].host;
          var srcs = (byHost[minor] || []).slice(0, 4).map(function (r) {
            return '<li>' + esc(r.src) + " \u2014 " + nf(r.n) + "</li>";
          }).join("");
          note = '<div class="vh-oc-warn"><b>Served under ' + d.hosts.length + " hostnames.</b> "
            + "Search engines count those as separate pages, and every figure above is split between "
            + "them.</div>"
            + (srcs ? '<div class="vh-oc-hint">'+T('vih.how_visitors_reached')+'<code>' + esc(minor)
                      + "</code>:</div><ul class=\"vh-oc-srcs\">" + srcs + "</ul>" : "");
        }
        host.innerHTML = rows + note;
      })
      .catch(function () { host.innerHTML = '<span class="vh-oc-hint">'+T('vih.could_not_check_hosts')+'</span>'; });
  }

  function ocStat(k, v) { return '<div class="vh-oc-stat"><span>' + k + "</span><b>" + v + "</b></div>"; }
  function ocLink(base, path, label, why, tool) {
    return '<a class="vh-oc-link" href="' + base + encodeURIComponent(path) + '" title="' + esc(why) + '"'
         + (tool ? ' data-tool="' + esc(tool) + '" data-why="' + esc(why) + '"' : "")
         + '>' + esc(label) + '<em>' + esc(why) + "</em></a>";
  }

  function treeAudit(path, btn, key) {
    var host = q("oc-audit"); if (!host) return;
    /* The audit fetches your live page and parses it, with a 35-second budget server-side. A static
       "Fetching the page…" for up to half a minute is indistinguishable from nothing happening,
       which is what you reported.
       This is an INDETERMINATE bar plus a real elapsed count — not a percentage. PageAudit returns
       one blob at the end and reports no stages, so any percentage would be invented, and an
       invented percentage that sticks at 60% is worse than no bar. Elapsed seconds and the budget
       are both facts, so those are what it shows. */
    if (btn) { btn.disabled = true; btn.textContent = T('vih.fetching_the_page'); }
    var t0 = Date.now(), progT = null;
    host.innerHTML = '<div class="vh-oc-prog"><div class="vh-oc-prog-bar"><i></i></div>'
      + '<div class="vh-oc-prog-t" data-h="oc-prog-t">Fetching the page\u2026 0s</div></div>';
    var pt = host.querySelector('[data-h="oc-prog-t"]');
    progT = setInterval(function () {
      var sec = Math.round((Date.now() - t0) / 1000);
      if (!pt || !pt.parentNode) { clearInterval(progT); progT = null; return; }
      pt.textContent = sec < 8 ? "Fetching the page\u2026 " + sec + "s"
        : sec < 20 ? "Reading its markup and styles\u2026 " + sec + "s"
        : "Still going \u2014 " + sec + "s of a 35s budget. Slow sites take the whole of it.";
    }, 1000);
    var stopProg = function () { if (progT) { clearInterval(progT); progT = null; } };
    var pg = treePage(key || path) || {};
    apiPost("/stats/pageaudit",
            { path: path, hostname: pg.hostname || "" })
      .then(function (d) {
        if (!d || !d.ok) {
          /* Two different things wear the same coat.
             A REFUSAL — auditing switched off for this site, path excluded, host not ours — will
             answer identically for ever, so offering "try again" is a lie; what it needs is the
             setting that would change the answer. A FAILURE (timeout, page unreachable) is worth
             retrying. The server says which via `code`, because the HTTP status does not survive
             apiPost()'s unwrap(). */
          stopProg();
          var code = (d && d.code) || "";
          var refusal = REFUSALS[code];
          host.innerHTML = '<div class="vh-oc-refuse' + (refusal ? " is-policy" : "") + '">'
            + '<i class="bi bi-' + (refusal ? "sliders" : "exclamation-triangle") + '"></i>'
            + '<p>' + esc((d && d.error) || "The audit could not fetch that page.") + '</p>'
            + (refusal ? '<a class="vh-oc-btn" href="' + esc(refusal.href()) + '">' + esc(refusal.cta) + '</a>' : "")
            + '</div>';
          if (!refusal) ocRunAgain(host, path, key);
          return;
        }
        stopProg();
        host.innerHTML = ocAuditHtml(d);
        /* keep the tree in step without a full refetch */
        var p = treePage(path);
        if (p) { p.design = d.score; p.design_grade = d.grade; p.design_issues = (d.issues || []).length; treePaint(); }
      })
      .catch(function (e) {
        stopProg();
        host.innerHTML = '<p class="vh-oc-hint">Audit failed (' + esc((e && e.message) || "request failed") + ").</p>";
        ocRunAgain(host, path, key);
      });
  }
  /* One renderer for a set of findings, whether they arrived from a live run or off disk. */
  function ocAuditHtml(d) {
    return '<div class="vh-oc-score vh-oc-g' + esc(d.grade) + '">' + d.score + ' <span>' + esc(d.grade) + "</span></div>"
      + (d.stored ? '<p class="vh-oc-hint">Stored audit'
          + (d.audited_at ? ' from ' + esc(String(d.audited_at).slice(0, 16)) : "") + '. Re-run to refresh it.</p>' : "")
      + (d.partial ? '<p class="vh-oc-hint">This audit ran out of time and stopped early, so the '
          + 'score is based on what it managed to read. Re-run it when the site is responding faster.</p>' : "")
      + (d.skipped ? '<p class="vh-oc-hint">' + d.skipped + ' contrast check' + (d.skipped === 1 ? "" : "s")
          + ' skipped: those colours only resolve in a browser, so they were not guessed.</p>' : "")
      + (d.issues || []).map(function (i) {
          return '<div class="vh-oc-issue vh-oc-' + esc(i.severity) + '">'
            + '<div class="vh-oc-ih"><b>' + esc(i.title) + '</b><span>&minus;' + i.cost + "</span></div>"
            + "<p>" + esc(i.detail) + "</p>"
            + '<p class="vh-oc-fix"><b>'+T('vih.fix')+'</b> ' + esc(i.fix) + "</p></div>";
        }).join("")
      + (!(d.issues || []).length ? '<p class="vh-oc-hint">'+T('vih.nothing_to_fix_that_this_audit_can_see')+'</p>' : "");
  }

  /* Show the findings that are already on disk. No network fetch of the live page — this is a read. */
  function ocShowStored(path, key, btn) {
    var host = q("oc-audit"); if (!host) return;
    if (btn) { btn.disabled = true; btn.innerHTML = 'loading\u2026'; }
    var pg = treePage(key || path) || {};
    api("/stats/pageaudit?path=" + encodeURIComponent(path)
        + "&hostname=" + encodeURIComponent(pg.hostname || "")).then(function (d) {
      if (btn) { btn.disabled = false; btn.innerHTML = 'hide <i class="bi bi-chevron-up"></i>'; }
      if (!d || !d.ok) {
        host.innerHTML = '<p class="vh-oc-hint">' + esc((d && d.error) || "No stored audit for this page yet.") + '</p>';
        ocRunAgain(host, path, key);
        return;
      }
      host.innerHTML = ocAuditHtml(d);
      /* The stored row is authoritative about how many findings there are, so fix the summary line
         from it rather than leaving whatever the tree believed. */
      var pg2 = treePage(key || path);
      if (pg2) pg2.design_issues = (d.issues || []).length;
      if (btn) btn.setAttribute("data-count", String((d.issues || []).length));
      ocRunAgain(host, path, key);            // "Try the audit again" doubles as "re-run" here
      host.scrollIntoView && host.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = 'findings'; }
    });
  }

  /* Refusals the server will repeat for ever, each with the one control that changes its answer.
     ?s= is the spelling site-settings reads. */
  function ssHref() { return "/site-settings?s=" + encodeURIComponent(GS.site || ""); }
  var REFUSALS = {
    audit_disabled: { cta: T('vih.open_site_settings'),      href: ssHref },
    path_excluded:  { cta: T('vih.edit_the_exclusion_list'), href: ssHref },
    host_not_site:  { cta: TR('js.check_the_site_s_domain'), href: ssHref },
    no_domain:      { cta: T('vih.set_this_site_s_domain'),  href: ssHref }
  };

  /* Put a working button back after a failed audit. */
  function ocRunAgain(host, path, key) {
    var b = document.createElement("button");
    /* Same data-h as the button it replaces, so anything looking for the re-run control finds it
       whichever of the two is on screen. */
    b.className = "vh-oc-btn"; b.type = "button"; b.setAttribute("data-h", "oc-run");
    b.setAttribute("data-path", path); b.setAttribute("data-key", key || path);
    b.textContent = T('vih.try_the_audit_again');
    b.addEventListener("click", function () { treeAudit(path, b, key); });
    host.appendChild(b);
  }

  /* Which destinations actually hold something for this page. Verified server-side; a tool that
     cannot be checked is left neutral rather than being guessed green. */
  function ocTools(path) {
    var body = q("oc-body"); if (!body) return;
    api("/stats/pagetools?path=" + encodeURIComponent(path)).then(function (d) {
      var t = (d && d.tools) || {};
      body.querySelectorAll(".vh-oc-link[data-tool]").forEach(function (a2) {
        var v = t[a2.getAttribute("data-tool")], why = a2.getAttribute("data-why") || "";
        if (v === true)  { a2.classList.add("has-data");  a2.title = why + " \u2014 this page has data here."; }
        else if (v === false) { a2.classList.add("no-data"); a2.title = why + " \u2014 nothing recorded for this page yet."; }
        else a2.title = why + " \u2014 not checked, so this may or may not have data.";
      });
    }).catch(function () {});
  }

  function setView(v) {
    VIEW = v;
    qa(".vh-view").forEach(function (b) { b.classList.toggle("on", b.getAttribute("data-view") === v); });
    ["visitor", "segment", "radar", "map", "tree", "overview"].forEach(function (k) {
      var pane = q("pane-" + k); if (pane) pane.hidden = (k !== v);
    });
    var sum = q("summary"); if (sum) sum.hidden = (v !== "visitor");
    if (window.GSLink) GSLink.write({ view: v === "visitor" ? null : v });
    if (v === "segment") renderSeg();
    if (v === "radar") renderRadar();
    if (v === "map") renderMap();
    if (v === "tree") renderTree();
    if (v === "overview") renderOverview();
    if (CP_OPEN) cpRender();
  }
  function initViews() {
    /* Wired once. This lived inside setView() at first, which meant a fresh listener on every tab
       switch: after three switches one checkbox click repainted three times. */
    qa(".vh-lens").forEach(function (b) {
      b.addEventListener("click", function () {
        TREE_LENS = b.getAttribute("data-lens");
        qa(".vh-lens").forEach(function (x) { x.classList.toggle("on", x === b); });
        treePaint();
      });
    });
    /* "Only pages needing attention" and "Hide the long tail" are gone from the markup: they did
       not match what the tree actually shows. TREE_F stays false/false so treePaint's filter
       branches are simply never taken — no logic was ripped out, it is just never asked for. */
    /* Delegated so it survives every treePaint(): the body element is reused, only its innerHTML
       is replaced. */
    var tbody = q("tree-body");
    if (tbody && !tbody._moreWired) {
      tbody._moreWired = 1;
      tbody.addEventListener("click", function (e) {
        var b = e.target && e.target.closest ? e.target.closest("[data-more]") : null;
        if (!b) return;
        var stack = b.parentNode; if (!stack) return;
        var hid = stack.querySelectorAll(".vh-fc-hid[hidden]");
        var n = Math.min(20, hid.length);
        for (var i = 0; i < n; i++) hid[i].removeAttribute("hidden");
        var left = hid.length - n;
        if (left > 0) b.innerHTML = "+" + left + " more below";
        else if (b.parentNode) b.parentNode.removeChild(b);
      });
    }

    qa("[data-tf]").forEach(function (c) {
      c.addEventListener("change", function () { TREE_F[c.getAttribute("data-tf")] = c.checked; treePaint(); });
    });
    qa(".vh-view").forEach(function (b) {
      b.addEventListener("click", function () { setView(b.getAttribute("data-view")); });
    });
  }

  /* --------------------------------------------------------------- init */

  function initRange() {
    var btn = q("rangeBtn"), menu = q("rangeMenu"), lab = q("range-label");
    if (!btn || !menu) return;
    if (lab) lab.textContent = RANGE.label;
    btn.addEventListener("click", function (e) {
      if (menu.contains(e.target)) return;
      e.stopPropagation(); menu.style.display = menu.style.display === "none" ? "block" : "none";
    });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) {
      b.addEventListener("click", function () {
        RANGE = preset(b.getAttribute("data-preset"));
        try { localStorage.setItem("gs_hub_range", JSON.stringify(RANGE)); } catch (e) {}
        if (lab) lab.textContent = RANGE.label;
        menu.querySelectorAll(".rm").forEach(function (x) { x.classList.toggle("on", x === b); });
        menu.style.display = "none";
        loadAll();
        if (VIEW === "map") renderMap();
        if (VIEW === "overview") renderOverview();
        if (CP_OPEN) cpRender();
      });
    });
  }
  function filtersLabelText() {
    var parts = [];
    if (DEV) parts.push(DEV.charAt(0).toUpperCase() + DEV.slice(1));
    if (BOTF === "humans") parts.push(T('vih.people_only'));
    else if (BOTF === "bots") parts.push(T('vih.bots_only'));
    return parts.length ? parts.join(" \u00b7 ") : T('vih.all_visitors');
  }
  function syncFiltersLabel() { var l = q("filters-label"); if (l) l.textContent = filtersLabelText(); }
  function initFilters() {
    var btn = q("filtersBtn"), menu = q("filtersMenu");
    if (!btn || !menu) return;
    // seed the visitor-type choice from the signed-in account; device always starts at "all"
    var saved = (window.GS && GS.user && GS.user.hub_visitor_filter) || "humans";
    BOTF = (saved === "all" || saved === "bots") ? saved : "humans";
    menu.querySelectorAll(".rm[data-who]").forEach(function (x) { x.classList.toggle("on", (x.getAttribute("data-who") || "all") === BOTF); });
    syncFiltersLabel();
    // toggle — one pill opens the combined menu; it stays open across choices so you can set both
    btn.addEventListener("click", function (e) {
      if (menu.contains(e.target)) return;
      e.stopPropagation(); menu.style.display = menu.style.display === "none" ? "block" : "none";
    });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-dev]").forEach(function (b) {
      b.addEventListener("click", function () {
        DEV = b.getAttribute("data-dev") || "";
        menu.querySelectorAll(".rm[data-dev]").forEach(function (x) { x.classList.toggle("on", x === b); });
        syncFiltersLabel(); cards();
      });
    });
    menu.querySelectorAll(".rm[data-who]").forEach(function (b) {
      b.addEventListener("click", function () {
        BOTF = b.getAttribute("data-who") || "humans";
        menu.querySelectorAll(".rm[data-who]").forEach(function (x) { x.classList.toggle("on", x === b); });
        syncFiltersLabel(); cards();
        // persist to the account so the choice follows the user to any device
        if (window.GS && GS.user) GS.user.hub_visitor_filter = BOTF;
        try { GS.api("/me/hub-filter", { method: "POST", body: JSON.stringify({ value: BOTF }) }); } catch (e) {}
      });
    });
  }
  function initMode() {
    var seg = q("mode"); if (!seg) return;
    seg.querySelectorAll("b").forEach(function (b) {
      b.addEventListener("click", function () {
        MODE = b.getAttribute("data-v");
        seg.querySelectorAll("b").forEach(function (x) { x.classList.toggle("on", x === b); });
        // Live polls; Historical does not — a range in the past cannot change, so refreshing it
        // every 15 seconds is pure load for no new information.
        clearInterval(timer); timer = null;
        if (MODE === "live") { timer = setInterval(function () { if (!document.hidden) loadLive(); }, 15000); loadLive(); }
        if (q("stream-sub")) q("stream-sub").textContent = MODE === "live" ? "right now" : "in range";
      });
    });
  }
  function initTabs() {
    qa(".vh-tab").forEach(function (t) {
      t.addEventListener("click", function () {
        TAB = t.getAttribute("data-t");
        qa(".vh-tab").forEach(function (x) { x.classList.toggle("on", x === t); });
        renderTab();
      });
    });
  }

  function ready() {
    root = document.querySelector(".vihub[data-h='root']"); if (!root) return;
    initRange(); initFilters(); initMode(); initTabs(); initViews(); initHelp(); initCopilot(); gsDeepView();
    document.addEventListener("click", function (e) {
      var m = q("rangeMenu"), d = q("filtersMenu");
      if (m) m.style.display = "none"; if (d) d.style.display = "none";
      // any "Why? →" link inside an empty state opens the help panel
      var a = e.target && e.target.closest ? e.target.closest('[data-h="help-open"]') : null;
      if (a) { e.preventDefault(); openHelp(); }
    });
    var n = 0, t = setInterval(function () {
      if (window.GS && GS.api && GS.site) {
        clearInterval(t);
        loadAll();
        timer = setInterval(function () { if (!document.hidden && MODE === "live") loadLive(); }, 15000);
      } else if (++n > 300) clearInterval(t);
    }, 30);
    /* Refresh only ever cleared the overview and the map, so pressing it on Tree or Live radar
       re-read two views you were not looking at and left the one you were. Every per-view cache is
       dropped now and the CURRENT view is re-read, whichever it is. */
    var rf = q("refresh"); if (rf) rf.addEventListener("click", function () {
      OV = null; MAP = {}; TREE = null; RADAR = {};
      CP_INS = null; CP_INSKEY = null;                 // the Co-Pilot's cached read is stale too
      loadAll();
      if (VIEW === "tree") renderTree();
      else if (VIEW === "radar") renderRadar();
      if (CP_OPEN) cpRender();
    });
    document.addEventListener("gs:site-change", function () { SEL = null; PROF = {}; TRAJ = {}; TRAJTRIED = {}; SEGTRAJ = {}; SEGSIG = {}; SEGMOT = {}; SEGDEC = {}; SEGBM = {}; EMO = {}; SIG = {}; MOTD = {}; MAP = {}; FUNH = {}; OV = null; loadAll(); if (VIEW === "overview") renderOverview(); else if (VIEW === "map") renderMap(); });
  }
  if (document.readyState !== "loading") ready();
  else document.addEventListener("DOMContentLoaded", ready);
})();
